angular
  .module('theme.core.services', [])
  .provider('$themeInitialSettings', function() {
  	this.settings = {
      fixedHeader: true,
      headerBarHidden: true,
      leftbarCollapsed: false,
      leftbarShown: false,
      rightbarCollapsed: false,
      fullscreen: false,
      layoutHorizontal: false,
      layoutHorizontalLargeIcons: false,
      layoutBoxed: false,
      showSmallSearchBar: false,
      topNavThemeClass: 'navbar-default',
      sidebarThemeClass: 'sidebar-midnightblue',
      showChatBox: false,
      pageTransitionStyle: 'fadeIn',
      dropdownTransitionStyle: 'flipInX'
    }
    this.get = function(key) {
      return this.settings[key];
    };
    this.set = function(key, value) {
      this.settings[key] = value;
    };
    this.$get = function() {
    	return this.settings;
    }
  })
  .value('TplVersion', 0)
  .config(function($httpProvider){
    $httpProvider.interceptors.push(function($templateCache, TplVersion) {
      return {
        'request' : function(request) {
          if($templateCache.get(request.url) === undefined) { // cache miss
              // Item is not in $templateCache so add our query string
              if (request.url.match(/\.html$/) && TplVersion) {
                  request.url = request.url + '?_v=' + TplVersion;
              }
          }
          return request;
        }
      }
    });	
  })
  .service('ThemeService', function($rootScope, $window, $document, $themeInitialSettings) {
    'use strict';
    this.settings = $themeInitialSettings;

    var brandColors = {
      'default': '#ecf0f1',

      'inverse': '#95a5a6',
      'primary': '#3498db',
      'success': '#2ecc71',
      'warning': '#f1c40f',
      'danger': '#e74c3c',
      'info': '#1abcaf',

      'brown': '#c0392b',
      'indigo': '#9b59b6',
      'orange': '#e67e22',
      'midnightblue': '#34495e',
      'sky': '#82c4e6',
      'magenta': '#e73c68',
      'purple': '#e044ab',
      'green': '#16a085',
      'grape': '#7a869c',
      'toyo': '#556b8d',
      'alizarin': '#e74c3c'
    };

    this.getBrandColor = function(name) {
      if (brandColors[name]) {
        return brandColors[name];
      } else {
        return brandColors['default'];
      }
    };

    $document.ready(function() {
      $window.enquire.register('screen and (max-width: 767px)', {
        match: function() {
          $rootScope.$broadcast('themeEvent:maxWidth767', true);
        },
        unmatch: function() {
          $rootScope.$broadcast('themeEvent:maxWidth767', false);
        }
      });
    });

    this.get = function(key) {
      return this.settings[key];
    };
    this.set = function(key, value) {
      this.settings[key] = value;
      $rootScope.$broadcast('themeEvent:changed', {
        key: key,
        value: this.settings[key]
      });
      $rootScope.$broadcast('themeEvent:changed:' + key, this.settings[key]);
    };
    this.values = function() {
      return this.settings;
    };
    this.scrollToTop = function(){
      angular.element('body').scrollTop(0);
    }
  });

// mimic scripts/core/controller/mainController.js
// minus demo items, like chatters -> mainControllerChatters

angular.module('theme.core.main_controller', ['theme.core.services'])
  .controller('ThemeController', function($scope, ThemeService, $timeout) {
    'use strict';
    // this.layoutIsSmallScreen = false;
    this.layoutFixedHeader = ThemeService.get('fixedHeader');
    this.layoutPageTransitionStyle = ThemeService.get('pageTransitionStyle');
    this.layoutDropdownTransitionStyle = ThemeService.get('dropdownTransitionStyle');
    this.layoutPageTransitionStyleList = ['bounce',
      'flash',
      'pulse',
      'bounceIn',
      'bounceInDown',
      'bounceInLeft',
      'bounceInRight',
      'bounceInUp',
      'fadeIn',
      'fadeInDown',
      'fadeInDownBig',
      'fadeInLeft',
      'fadeInLeftBig',
      'fadeInRight',
      'fadeInRightBig',
      'fadeInUp',
      'fadeInUpBig',
      'flipInX',
      'flipInY',
      'lightSpeedIn',
      'rotateIn',
      'rotateInDownLeft',
      'rotateInDownRight',
      'rotateInUpLeft',
      'rotateInUpRight',
      'rollIn',
      'zoomIn',
      'zoomInDown',
      'zoomInLeft',
      'zoomInRight',
      'zoomInUp'
    ];

    var self = this;

    this.layoutLoading = true;
    $scope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams){
		self.layoutLoading = false;
	})
    
    this.get = function(key) {
      return ThemeService.get(key);
    };

    this.setNavbarClass = function(classname, $event) {
      $event.preventDefault();
      $event.stopPropagation();
      ThemeService.set('topNavThemeClass', classname);
    };

    this.setSidebarClass = function(classname, $event) {
      $event.preventDefault();
      $event.stopPropagation();
      ThemeService.set('sidebarThemeClass', classname);
    };

	/*
    this.$watch('layoutFixedHeader', function(newVal, oldval) {
      if (newVal === undefined || newVal === oldval) {
        return;
      }
      ThemeService.set('fixedHeader', newVal);
    });
    this.$watch('layoutLayoutBoxed', function(newVal, oldval) {
      if (newVal === undefined || newVal === oldval) {
        return;
      }
      ThemeService.set('layoutBoxed', newVal);
    });
    this.$watch('layoutLayoutHorizontal', function(newVal, oldval) {
      if (newVal === undefined || newVal === oldval) {
        return;
      }
      ThemeService.set('layoutHorizontal', newVal);
    });
    this.$watch('layoutPageTransitionStyle', function(newVal) {
      ThemeService.set('pageTransitionStyle', newVal);
    });
    this.$watch('layoutDropdownTransitionStyle', function(newVal) {
      ThemeService.set('dropdownTransitionStyle', newVal);
    });
	*/
	
    this.hideHeaderBar = function() {
      ThemeService.set('headerBarHidden', true);
    };

    this.showHeaderBar = function($event) {
      $event.stopPropagation();
      ThemeService.set('headerBarHidden', false);
    };

    this.toggleLeftBar = function() {
      if (this.layoutIsSmallScreen) {
        return ThemeService.set('leftbarShown', !ThemeService.get('leftbarShown'));
      }
      ThemeService.set('leftbarCollapsed', !ThemeService.get('leftbarCollapsed'));
    };

    this.toggleRightBar = function() {
      ThemeService.set('rightbarCollapsed', !ThemeService.get('rightbarCollapsed'));
    };

    this.toggleSearchBar = function($event) {
      $event.stopPropagation();
      $event.preventDefault();
      ThemeService.set('showSmallSearchBar', !ThemeService.get('showSmallSearchBar'));
    };

    // chatters - gone

    $scope.$on('themeEvent:maxWidth767', function(event, newVal) {
      $timeout(function() {
        self.layoutIsSmallScreen = newVal;
        if (!newVal) {
          ThemeService.set('leftbarShown', false);
        } else {
          ThemeService.set('leftbarCollapsed', false);
        }
      });
    });
    $scope.$on('themeEvent:changed:fixedHeader', function(event, newVal) {
      self.layoutFixedHeader = newVal;
    });
    $scope.$on('themeEvent:changed:layoutHorizontal', function(event, newVal) {
      self.layoutLayoutHorizontal = newVal;
    });
    $scope.$on('themeEvent:changed:layoutBoxed', function(event, newVal) {
      self.layoutLayoutBoxed = newVal;
    });

    
	window.ThemeService = ThemeService;
	window.ThemeServiceCtrl = this;
    
  });
/*
 *
 * https://github.com/fatlinesofcode/ngDraggable
 */
/* jshint ignore:start */
angular.module("ngDraggable", [])
  .directive('ngDrag', ['$rootScope', '$parse', '$document', '$window', function($rootScope, $parse, $document, $window) {
    return {
      restrict: 'A',
      scope: true,
      link: function(scope, element, attrs) {
        scope.value = attrs.ngDrag;
        var offset, _centerAnchor = false,
          _mx, _my, _tx, _ty, _mrx, _mry;
        var _hasTouch = ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch;
        var _pressEvents = 'touchstart mousedown';
        var _moveEvents = 'touchmove mousemove';
        var _releaseEvents = 'touchend mouseup';

        // to identify the element in order to prevent getting superflous events when a single element has both drag and drop directives on it.
        var _myid = scope.$id;
        var _data = null;

        var _dragEnabled = false;

        var _pressTimer = null;

        var onDragSuccessCallback = $parse(attrs.ngDragSuccess) || null;

        var initialize = function() {
          element.attr('draggable', 'false'); // prevent native drag
          toggleListeners(true);
        };

        // this same func is in ngDrop, it needs to be DRYed up but don't know if its
        // worth writing a service (or equivalent) for one function
        var _privoffset = function(docElem) {
          var box = {
            top: 0,
            left: 0
          };
          if (typeof docElem[0].getBoundingClientRect !== undefined) {
            box = docElem[0].getBoundingClientRect();
          }
          return {
            top: box.top + $window.pageYOffset - docElem[0].clientTop,
            left: box.left + $window.pageXOffset - docElem[0].clientLeft
          };
        }

        var toggleListeners = function(enable) {
          if (!enable) return;
          // add listeners.

          scope.$on('$destroy', onDestroy);
          scope.$watch(attrs.ngDrag, onEnableChange);
          scope.$watch(attrs.ngCenterAnchor, onCenterAnchor);
          scope.$watch(attrs.ngDragData, onDragDataChange);
          element.on(_pressEvents, onpress);
          if (!_hasTouch && element[0].nodeName.toLowerCase() == "img") {
            element.on('mousedown', function() {
              return false;
            }); // prevent native drag for images
          }
        };
        var onDestroy = function(enable) {
          toggleListeners(false);
        };
        var onDragDataChange = function(newVal, oldVal) {
          _data = newVal;
        };
        var onEnableChange = function(newVal, oldVal) {
          _dragEnabled = (newVal);
        };
        var onCenterAnchor = function(newVal, oldVal) {
          if (angular.isDefined(newVal))
            _centerAnchor = (newVal || 'true');
        }

        var isClickableElement = function(evt) {
          return (
            angular.isDefined(angular.element(evt.target).attr("ng-click")) || angular.isDefined(angular.element(evt.target).attr("ng-dblclick")) || angular.isDefined(angular.element(evt.target).attr("ng-cancel-drag"))
          );
        }

        // var isDragHandle = function (evt) {
        //     return !(angular.element(evt.target).closest("[ng-drag-handle]").length > 0);
        // }
        var isDragHandle = function(evt) {
          var attr = angular.element(evt.target).attr("ng-drag-handle");
          return (typeof attr !== typeof undefined && attr !== false);
        }

        /*
         * When the element is clicked start the drag behaviour
         * On touch devices as a small delay so as not to prevent native window scrolling
         */
        var onpress = function(evt) {
          if (!_dragEnabled || !isDragHandle(evt)) return;
          if (evt.type == "mousedown" && evt.button !== 0) return;
          element.css('width', element.width() + 'px');
          // disable drag on clickable element
          // if (isClickableElement(evt) || !isDragHandle(evt)) {
          // return;
          // }

          if (_hasTouch) {
            cancelPress();
            _pressTimer = setTimeout(function() {
              cancelPress();
              onlongpress(evt);
            }, 100);
            $document.on(_moveEvents, cancelPress);
            $document.on(_releaseEvents, cancelPress);
          } else {
            onlongpress(evt);
          }

        }
        var cancelPress = function() {
          clearTimeout(_pressTimer);
          $document.off(_moveEvents, cancelPress);
          $document.off(_releaseEvents, cancelPress);
        }
        var onlongpress = function(evt) {
          if (!_dragEnabled) return;
          evt.preventDefault();
          element.addClass('dragging');
          offset = _privoffset(element);

          element.centerX = element[0].offsetWidth / 2;
          element.centerY = element[0].offsetHeight / 2;

          _mx = (evt.pageX || evt.touches[0].pageX);
          _my = (evt.pageY || evt.touches[0].pageY);
          _mrx = _mx - offset.left;
          _mry = _my - offset.top;
          if (_centerAnchor) {
            _tx = _mx - element.centerX - $window.pageXOffset;
            _ty = _my - element.centerY - $window.pageYOffset;
          } else {
            _tx = _mx - _mrx - $window.pageXOffset;
            _ty = _my - _mry - $window.pageYOffset;
          }

          $document.on(_moveEvents, onmove);
          $document.on(_releaseEvents, onrelease);
          $rootScope.$broadcast('draggable:start', {
            x: _mx,
            y: _my,
            tx: _tx,
            ty: _ty,
            event: evt,
            element: element,
            data: _data
          });
        }

        var onmove = function(evt) {
          if (!_dragEnabled) return;
          evt.preventDefault();

          _mx = (evt.pageX || evt.touches[0].pageX);
          _my = (evt.pageY || evt.touches[0].pageY);

          if (_centerAnchor) {
            _tx = _mx - element.centerX - $window.pageXOffset;
            _ty = _my - element.centerY - $window.pageYOffset;
          } else {
            _tx = _mx - _mrx - $window.pageXOffset;
            _ty = _my - _mry - $window.pageYOffset;
          }

          moveElement(_tx, _ty);

          $rootScope.$broadcast('draggable:move', {
            x: _mx,
            y: _my,
            tx: _tx,
            ty: _ty,
            event: evt,
            element: element,
            data: _data,
            uid: _myid
          });
        }

        var onrelease = function(evt) {
          if (!_dragEnabled)
            return;
          evt.preventDefault();
          $rootScope.$broadcast('draggable:end', {
            x: _mx,
            y: _my,
            tx: _tx,
            ty: _ty,
            event: evt,
            element: element,
            data: _data,
            callback: onDragComplete,
            uid: _myid
          });
          element.removeClass('dragging');
          reset();
          $document.off(_moveEvents, onmove);
          $document.off(_releaseEvents, onrelease);
        }

        var onDragComplete = function(evt) {
          if (!onDragSuccessCallback) return;

          scope.$apply(function() {
            onDragSuccessCallback(scope, {
              $data: _data,
              $event: evt
            });
          });
        }

        var reset = function() {
          element.css({
            left: '',
            top: '',
            position: '',
            'z-index': '',
            margin: ''
          });
        }

        var moveElement = function(x, y) {
          element.css({
            left: (x + 'px'),
            top: (y + 'px'),
            position: 'fixed',
            'z-index': 99999
              //,margin: '0'  don't monkey with the margin, 
          });
        }
        initialize();
      }
    }
  }])

.directive('ngDrop', ['$parse', '$timeout', '$window', function($parse, $timeout, $window) {
    return {
      restrict: 'A',
      link: function(scope, element, attrs) {
        scope.value = attrs.ngDrop;

        var _myid = scope.$id;

        var _dropEnabled = false;

        var onDropCallback = ($parse(attrs.ngDropSuccess) == angular.noop) ? function(scope, obj) {
          element.find('.drag-placeholder').after(obj.$event.element);
          obj.$event.element.show();
        } : $parse(attrs.ngDropSuccess);

        var initialize = function() {
          toggleListeners(true);
        };

        var toggleListeners = function(enable) {
          // remove listeners

          if (!enable) return;
          // add listeners.
          attrs.$observe("ngDrop", onEnableChange);
          scope.$on('$destroy', onDestroy);
          //scope.$watch(attrs.uiDraggable, onDraggableChange);
          scope.$on('draggable:start', onDragStart);
          scope.$on('draggable:move', onDragMove);
          scope.$on('draggable:end', onDragEnd);
        };

        // this same func is in ngDrag, it needs to be DRYed up but don't know if its
        // worth writing a service (or equivalent) for one function
        var _privoffset = function(docElem) {
          var box = {
            top: 0,
            left: 0
          };
          if (typeof docElem[0].getBoundingClientRect !== undefined) {
            box = docElem[0].getBoundingClientRect();
          }
          return {
            top: box.top + $window.pageYOffset - docElem[0].clientTop,
            left: box.left + $window.pageXOffset - docElem[0].clientLeft
          };
        }

        var onDestroy = function(enable) {
          toggleListeners(false);
        };
        var onEnableChange = function(newVal, oldVal) {
          _dropEnabled = scope.$eval(newVal);
        }
        var onDragStart = function(evt, obj) {
          if (!_dropEnabled) return;
          $('.drag-placeholder').show();
          if (isTouching(obj.x, obj.y, obj.element)) {
            obj.element.css({
              position: 'fixed',
              top: obj.ty + 'px',
              left: obj.tx + 'px'
            });
            if (element.find('.drag-placeholder').length < 1) {
              var dragPlaceholder = $('<div class="drag-placeholder"></div>').css({
                height: obj.element.innerHeight() + 'px',
                width: '100%'
              });
              $(obj.element).after(dragPlaceholder);
            }
          }
        }
        var onDragMove = function(evt, obj) {
          if (!_dropEnabled) return;
          if (isTouching(obj.x, obj.y, obj.element)) {
            if (element.find('.drag-placeholder').length < 1) {
              var dragPlaceholder = $('<div class="drag-placeholder"></div>').css({
                height: obj.element.innerHeight() + 'px',
                width: '100%'
              });
              $(element).append(dragPlaceholder);
            }
            element.find('[ng-drag]:not(.dragging)').each(function() {
              if (hitTestElement(obj.x, obj.y, $(this))) {
                // $(this).css('border', '1px solid blue');
                if (($(this).offset().top + $(this).height() / 2) < obj.y) {
                  // $(this).css('border', '1px solid red');
                  // element.find('.drag-placeholder').before(this);
                  $(this).after(element.find('.drag-placeholder'));
                } else {
                  // element.find('.drag-placeholder').after(this);
                  $(this).before(element.find('.drag-placeholder'));
                }
                // else
              }
            })
          } else {
            if (element.find('.drag-placeholder').length > 0) {
              element.find('.drag-placeholder').remove();
            }
          }
        }

        var onDragEnd = function(evt, obj) {
          // don't listen to drop events if this is the element being dragged
          if (!_dropEnabled || _myid === obj.uid) return;
          $('.drag-placeholder').hide();
          obj.element.css('width', '');
          if (isTouching(obj.x, obj.y, obj.element)) {
            obj.element.hide();
            // call the ngDraggable ngDragSuccess element callback
            if (obj.callback) {
              obj.callback(obj);
            }

            $timeout(function() {
              onDropCallback(scope, {
                $data: obj.data,
                $event: obj
              });
              $('.drag-placeholder').remove();
            });
          }
          updateDragStyles(false, obj.element);
        }

        var isTouching = function(mouseX, mouseY, dragElement) {
          var touching = hitTest(mouseX, mouseY);
          updateDragStyles(touching, dragElement);
          return touching;
        }

        var updateDragStyles = function(touching, dragElement) {
          if (touching) {
            element.addClass('drag-enter');
            dragElement.addClass('drag-over');
          } else {
            element.removeClass('drag-enter');
            dragElement.removeClass('drag-over');
          }
        }

        var hitTest = function(x, y) {
          var bounds = _privoffset(element);
          bounds.right = bounds.left + element[0].offsetWidth;
          bounds.bottom = bounds.top + element[0].offsetHeight;
          return x >= bounds.left && x <= bounds.right && y <= bounds.bottom && y >= bounds.top;
        }

        var hitTestElement = function(x, y, element) {
          var bounds = _privoffset(element);
          bounds.right = bounds.left + element[0].offsetWidth;
          bounds.bottom = bounds.top + element[0].offsetHeight;
          return x >= bounds.left && x <= bounds.right && y <= bounds.bottom && y >= bounds.top;
        }

        initialize();
      }
    }
  }])
  .directive('ngDragClone', ['$parse', '$timeout', function($parse, $timeout) {
    return {
      restrict: 'A',
      link: function(scope, element, attrs) {
        var img, _allowClone = true;
        scope.clonedData = {};
        var initialize = function() {

          img = element.find('img');
          element.attr('draggable', 'false');
          img.attr('draggable', 'false');
          reset();
          toggleListeners(true);
        };


        var toggleListeners = function(enable) {
          // remove listeners

          if (!enable) return;
          // add listeners.
          scope.$on('draggable:start', onDragStart);
          scope.$on('draggable:move', onDragMove);
          scope.$on('draggable:end', onDragEnd);
          preventContextMenu();

        };
        var preventContextMenu = function() {
          //  element.off('mousedown touchstart touchmove touchend touchcancel', absorbEvent_);
          img.off('mousedown touchstart touchmove touchend touchcancel', absorbEvent_);
          //  element.on('mousedown touchstart touchmove touchend touchcancel', absorbEvent_);
          img.on('mousedown touchstart touchmove touchend touchcancel', absorbEvent_);
        }
        var onDragStart = function(evt, obj, elm) {
          _allowClone = true
          if (angular.isDefined(obj.data.allowClone)) {
            _allowClone = obj.data.allowClone;
          }
          if (_allowClone) {
            scope.$apply(function() {
              scope.clonedData = obj.data;
            });
            element.css('width', obj.element[0].offsetWidth);
            element.css('height', obj.element[0].offsetHeight);

            moveElement(obj.tx, obj.ty);
          }
        }
        var onDragMove = function(evt, obj) {
          if (_allowClone) {
            moveElement(obj.tx, obj.ty);
          }
        }
        var onDragEnd = function(evt, obj) {
          //moveElement(obj.tx,obj.ty);
          if (_allowClone) {
            reset();
          }
        }

        var reset = function() {
          element.css({
            left: 0,
            top: 0,
            position: 'fixed',
            'z-index': -1,
            visibility: 'hidden'
          });
        }
        var moveElement = function(x, y) {
          element.css({
            left: (x + 'px'),
            top: (y + 'px'),
            position: 'fixed',
            'z-index': 99999,
            'visibility': 'visible'
              //,margin: '0'  don't monkey with the margin, 
          });
        }

        var absorbEvent_ = function(event) {
          var e = event.originalEvent;
          e.preventDefault && e.preventDefault();
          e.stopPropagation && e.stopPropagation();
          e.cancelBubble = true;
          e.returnValue = false;
          return false;
        }

        initialize();
      }
    }
  }])
  .directive('ngPreventDrag', ['$parse', '$timeout', function($parse, $timeout) {
    return {
      restrict: 'A',
      link: function(scope, element, attrs) {
        var initialize = function() {

          element.attr('draggable', 'false');
          toggleListeners(true);
        };


        var toggleListeners = function(enable) {
          // remove listeners

          if (!enable) return;
          // add listeners.
          element.on('mousedown touchstart touchmove touchend touchcancel', absorbEvent_);
        };


        var absorbEvent_ = function(event) {
          var e = event.originalEvent;
          e.preventDefault && e.preventDefault();
          e.stopPropagation && e.stopPropagation();
          e.cancelBubble = true;
          e.returnValue = false;
          return false;
        }

        initialize();
      }
    }
  }])
  .directive('ngCancelDrag', [function() {
    return {
      restrict: 'A',
      link: function(scope, element, attrs) {
        element.find('*').attr('ng-cancel-drag', 'ng-cancel-drag');
      }
    }
  }]);
/* jshint ignore:end */
angular
  .module('theme.core.panels', [])
  .directive('panel', function() {
    'use strict';
    return {
      restrict: 'E',
      transclude: true,
      scope: {
        panelClass: '@',
        heading: '@',
        panelIcon: '@',
        isLoading: '=?',
        joggerType: '@'
      },
      templateUrl: 'framework/partials/ui-elements/panel.html',
      link: function(scope, element, attrs) {
        if (attrs.ngDrag === 'true') {  // ngDraggable support
          element.find('.panel-heading').attr('ng-drag-handle', '');
        }
        
        scope.$watch('isLoading', function(isLoading) {
          if (isLoading == true) {
            element.find('.panel-body').append('<div class="panel-loading"><div class="panel-loader-' + (scope.joggerType||'circular') + '"></div></div>');
          } else {
          	element.find('.panel-loading').remove();
          }
        });
      }
    };
  })
  .directive('panelControls', [function() {
    'use strict';
    return {
      restrict: 'E',
      require: '?^tabset',
      replace: true,
      link: function(scope, element) {
        var panel = angular.element(element).closest('.panel');
        if (panel.hasClass('.ng-isolate-scope') === false) {
          angular.element(element).children().appendTo(panel.find('.panel-ctrls'));
        }
        
      }
    };
  }])
  .directive('panelControlCollapse', function() {
    'use strict';
    return {
      restrict: 'EAC',
      link: function(scope, element) {
        element.html('<button class="button-icon"><i class="glyphicon glyphicon-minus"></i></button>');
        element.bind('click', function() {
          angular.element(element).find('i').toggleClass('glyphicon-plus glyphicon-minus');
          angular.element(element).closest('.panel').find('.panel-body').slideToggle({
            duration: 200
          });
          angular.element(element).closest('.panel-heading').toggleClass('rounded-bottom');
        });
        return false;
      }
    };
  })
  .directive('panelControlColors', ['$compile', function($compile) {
    'use strict';
    return {
      restrict: 'EAC',
      replace: true,
      link: function(scope, element) {
        var controls = '<span class="button-icon" uib-dropdown="" uib-dropdown-toggle="">' +
          '<i class="glyphicon glyphicon-tint"></i>' +
          '<ul uib-dropdown-menu="" class=" dropdown-tint" role="menu">' +
          '<li><span class="btn btn-default" data-class="panel-default"></span></li>' +
          '<li><span class="btn btn-midnightblue" data-class="panel-midnightblue"></span></li>' +
          '<li><span class="btn btn-danger" data-class="panel-danger"></span></li>' +
          '<li><span class="btn btn-success" data-class="panel-success"></span></li>' +
          '<li><span class="btn btn-primary" data-class="panel-primary"></span></li>' +
          '<li><span class="btn btn-inverse" data-class="panel-inverse"></span></li>' +
          '<li><span class="btn btn-indigo" data-class="panel-indigo"></span></li>' +
          '</ul>' +
          '</span>';
        element.append($compile(controls)(scope));
        element.find('li span').bind('click', function() {
          element.closest('.panel').removeClass(function(index, css) {
            return (css.match(/(^|\s)panel-\S+/g) || []).join(' ');
          });
          element.closest('.panel').removeClass('panel-*').addClass(angular.element(this).attr('data-class'));
        });
        return false;
      }
    };
  }])
  .directive('panelControlTitle', ['$compile', '$timeout', function($compile, $t) {
    'use strict';
    return {
      restrict: 'EAC',
      scope: true,
      link: function(scope, element) {
        var controls = '<span class="button-icon" uib-dropdown="" uib-dropdown-toggle="" is-open="showInputBox">' +
          '<i class="glyphicon glyphicon-edit"></i>' +
          '<ul uib-dropdown-menu="" class="dropdown-menu dropdown-edit" role="menu" ng-keyup="processKeyUp($event)">' +
          '<li><input class="form-control" type="text" ng-model="title" id="lolput" ng-click="$event.preventDefault();$event.stopPropagation()" /></li>' +
          '</ul>' +
          '</span>';
        element.append($compile(controls)(scope));
        scope.processKeyUp = function(event) {
          if (event.keyCode === 32) { // space pressed
            event.preventDefault();
          } else if (event.keyCode === 13) {
            scope.showInputBox = false;
          }
        };
        scope.$watch('showInputBox', function(n) {
          if (n) {
            $t(function() {
              element.find('input').val(element.closest('.panel').find('.panel-heading h2').text()).focus();
            }, 10);
          }
        });
        scope.$watch('title', function(n) {
          element.closest('.panel').find('.panel-heading h2').html(n);
        });
        return false;
      }
    };
  }]);


angular.module('theme.core.tiles', ['pascalprecht.translate'])

  .directive('tileLarge', function() {
    'use strict';
    return {
      restrict: 'E',
      scope: {
        item: '=data'
      },
      templateUrl: 'framework/partials/ui-elements/tile-large.html',
      replace: true,
      transclude: true
    };
  })
  .directive('tileSimple', function() {
    'use strict';
    return {
      restrict: 'E',
      scope: {
        item: '=data'
      },
      templateUrl: 'framework/partials/ui-elements/tile-simple.html',
      replace: true,
      transclude: true
    };
  })
  .directive('tileShortcut', function() {
    'use strict';
    return {
      restrict: 'E',
      scope: {
        item: '=data'
      },
      replace: true,
      templateUrl: 'framework/partials/ui-elements/tile-shortcut.html'
    };
  })
  .component('tileKpi', {
    bindings: {
      heading: '@',
      type: '@',
      histogram: '<?',
      labels: '<?',
      min: '<?',
      max: '<?',
      value: '@',
      widget: '@'
    },
    templateUrl: 'framework/partials/ui-elements/tile-kpi.html',
    link: function(scope, element) {
      var heading = element.find('tile-heading');
      if (heading.length) {
        heading.appendTo(element.find('.tiles-heading'));
      }
    },
    controller: function($scope) {
      var self = this;

      this.labels = [];

      $scope.$watch(function(){return self.labels}, function(labels){
        if (labels && labels.length) {
          self.ticks = labels.map(function(l){ return moment(l, "YYYY-MM-DD").format("DD.MM") });
        }
      })
      
      var removeFirstAndLastLabel = function(scaleInstance) {
        // set the first and last tick to null so it does not display
        // note, ticks[0] is the last tick and ticks[length - 1] is the first
        scaleInstance.ticks[0] = null;
        scaleInstance.ticks[scaleInstance.ticks.length - 1] = null;
        // reomove middle 30% - space for value
        var count = Math.floor(scaleInstance.ticks.length * .3 / 2);
        for (var i=Math.floor((scaleInstance.ticks.length - count)/2); i<Math.ceil((scaleInstance.ticks.length + count)/2); i++) {
          scaleInstance.ticks[i] = null;
        }
      };

      var removePaddingFormScale = function(me) {
        me.paddingLeft = 0;
        me.paddingRight = 0;
      };

      this.$onInit = function() {
        if (self.widget == 'line') {
          //self.ticks = self.labels.map(function(l){ return moment(l, "YYYY-MM-DD").format("DD.MM") });
          self.chart_options = {
            responsive: true, 
            maintainAspectRatio: false, 
            scales: {
              yAxes:[{ display: false, ticks: {suggestedMin:self.min, suggestedMax:self.max}}],
              //xAxes:[{ display: false}]
              xAxes:[{
                position: 'top',
                afterTickToLabelConversion: removeFirstAndLastLabel,
                gridLines: {drawBorder: false,},
                afterFit: removePaddingFormScale,
                maxRotation: 0,
             }]
            },
            tooltips: {
              displayColors: false,
              callbacks: {
                title: function(tooltipItems, data) {
                  return '';
                },
                label: function(tooltipItem, data) {
                  return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                },
              }
            }
          }
          self.chart_dataset_override = [{pointRadius:0, pointHitRadius: 20, borderColor: "rgba(100,100,100,0.3)", backgroundColor: "rgba(100,100,100,0.2)"}]
        }
      }
    },
    controllerAs: '$ctrl'
  })
  .directive('tile', function() {
    'use strict';
    return {
      restrict: 'E',
      scope: {
        heading: '@',
        type: '@'
      },
      transclude: true,
      templateUrl: 'framework/partials/ui-elements/tile-generic.html',
      link: function(scope, element) {
        var heading = element.find('tile-heading');
        if (heading.length) {
          heading.appendTo(element.find('.tiles-heading'));
        }
      },
      replace: true
    };
  })


angular.module('theme.core.progressbar', [])

.directive('contextualProgressbar', function() {
  return {
    replace: true,
    transclude: true,
    restrict: 'E',
    scope: {
      value: '=',
      max: '=?',
      type: '@',
      heading: '@',
    },
    templateUrl: 'framework/partials/ui-elements/contextual-progressbar.html',
  };
});
angular.module('theme.core.template_overrides', [])
  .config(['$provide', function($provide) {
    $provide.decorator('uibTabsetDirective', function($delegate) {
      var directive = $delegate[0];
      directive.templateUrl = function(element, attr) {
      	if (attr.panelTabs) {
      		if (typeof attr.heading == "undefined") {
      			return 'framework/partials/ui-elements/panel-tabs-without-heading.html';
      		} else {
      			return 'framework/partials/ui-elements/panel-tabs.html';
      		}
      	} else {
      	  if (attr.tabPosition === 'bottom') {
            return 'framework/partials/ui-elements/themed-tabs-bottom.html';
          } else {
          	return 'framework/partials/ui-elements/themed-tabs.html';
          }
      	}
      };

      directive.scope.heading = '@'
      directive.scope.panelClass = '@'
      directive.scope.panelIcon = '@'
      directive.scope.theme = '@tabTheme'
      directive.scope.position = '@tabPosition'
      directive.scope.draggable = '=?ngDrag'

      return $delegate;
    });
  }])

angular
  .module('theme.core.directives', [])
  .directive('fullscreen', function() {
    'use strict';
    return {
      restrict: 'AC',
      link: function(scope, element) {
        element.fseditor({
          maxHeight: 500
        });
      }
    };
  })
  .directive('wizard', function() {
    'use strict';
    return {
      restrict: 'A',
      scope: {
        options: '=wizard'
      },
      link: function(scope, element) {
        if (scope.options) {
          element.stepy(scope.options);

          //Make Validation Compability - see docs
          if (scope.options.validate === true) {
            element.validate({
              errorClass: 'help-block',
              validClass: 'help-block',
              highlight: function(element) {
                angular.element(element).closest('.form-group').addClass('has-error');
              },
              unhighlight: function(element) {
                angular.element(element).closest('.form-group').removeClass('has-error');
              }
            });
          }
        } else {
          element.stepy();
        }
        //Add Wizard Compability - see docs
        element.find('.stepy-navigator').wrapInner('<div class="pull-right"></div>');
      }
    };
  })
  .directive('maskinput', function() {
    'use strict';
    return {
      restrict: 'A',
      link: function(scope, element) {
        element.inputmask();
      }
    };
  })
  .directive('croppable', ['$timeout', function($t) {
    'use strict';
    return {
      restrict: 'A',
      replace: true,
      scope: {
        src: '@',
        imgSelected: '&',
        cropInit: '&'
      },
      link: function(scope, element) {
        var myImg;
        $t(function() {
          if (scope.src) {
            myImg = element;
            element.width(element.width()); // stupid width bug
            angular.element(myImg).Jcrop({
              trackDocument: true,
              onSelect: function(x) {
                $t(function() {
                  scope.imgSelected({
                    coords: x
                  });
                });
              },
              // aspectRatio: 1
            }, function() {
              // Use the API to get the real image size 
              scope.bounds = this.getBounds();
            });
          }
        });
        scope.$watch('bounds', function() {
          scope.cropInit({
            bounds: scope.bounds
          });
        });
      }
    };
  }]);
angular
  .module('theme.core.directives')
  .directive('disableAnimation', ['$animate', function($animate) {
    'use strict';
    return {
      restrict: 'A',
      link: function($scope, $element, $attrs) {
        $attrs.$observe('disableAnimation', function(value) {
          $animate.enabled(!value, $element);
        });
      }
    };
  }])
  .directive('slideOut', function() {
    'use strict';
    return {
      restrict: 'A',
      scope: {
        show: '=slideOut'
      },
      link: function(scope, element) {
        element.hide();
        scope.$watch('show', function(newVal, oldVal) {
          if (newVal !== oldVal) {
            element.slideToggle({
              complete: function() {
                scope.$apply();
              }
            });
          }
        });
      }
    };
  })
  .directive('slideOutNav', ['$timeout', function($t) {
    'use strict';
    return {
      restrict: 'A',
      scope: {
        show: '=slideOutNav'
      },
      link: function(scope, element) {
        scope.$watch('show', function(newVal) {
          if (angular.element('body').hasClass('sidebar-collapsed')) {
            if (newVal === true) {
              element.css('display', 'block');
            } else {
              element.css('display', 'none');
            }
            return;
          }
          if (newVal === true) {
            element.slideDown({
              complete: function() {
                $t(function() {
                  scope.$apply();
                });
              },
              duration: 100
            });
          } else if (newVal === false) {
            element.slideUp({
              complete: function() {
                $t(function() {
                  scope.$apply();
                });
              },
              duration: 100
            });
          }
        });
      }
    };
  }])
  .directive('pulsate', function() {
    'use strict';
    return {
      scope: {
        pulsate: '='
      },
      link: function(scope, element) {
        // stupid hack to prevent FF from throwing error
        if (element.css('background-color') === 'transparent') {
          element.css('background-color', 'rgba(0,0,0,0.01)');
        }
        angular.element(element).pulsate(scope.pulsate);
      }
    };
  })

  .directive('animatePageContent', ['$rootScope', '$timeout', function($rootScope, $timeout) {
    'use strict';
    return {
      restrict: 'A',
      link: function postLink() {
        $rootScope.$on('$routeChangeSuccess', function() {
          $timeout( function () {
            angular.element('.container-fluid .animated-content')
            .css('visibility', 'visible')
            .velocity('transition.slideUpIn', {stagger: 150});
          }, 10);
        });
      }
    };
  }])
  .directive('passwordVerify', function() {
    'use strict';
    return {
      require: 'ngModel',
      scope: {
        passwordVerify: '='
      },
      link: function(scope, element, attrs, ctrl) {
        scope.$watch(function() {
          var combined;

          if (scope.passwordVerify || ctrl.$viewValue) {
            combined = scope.passwordVerify + '_' + ctrl.$viewValue;
          }
          return combined;
        }, function(value) {
          if (value) {
            ctrl.$parsers.unshift(function(viewValue) {
              var origin = scope.passwordVerify;
              if (origin !== viewValue) {
                ctrl.$setValidity('passwordVerify', false);
                return undefined;
              } else {
                ctrl.$setValidity('passwordVerify', true);
                return viewValue;
              }
            });
          }
        });
      }
    };
  })
  .directive('backgroundSwitcher', function() {
    'use strict';
    return {
      restrict: 'EA',
      link: function(scope, element) {
        angular.element(element).click(function() {
          angular.element('body').css('background', angular.element(element).css('background'));
        });
      }
    };
  })
  .directive('icheck', ['$timeout', function($timeout) {
    'use strict';
    return {
      require: '?ngModel',
      link: function($scope, element, $attrs, ngModel) {
        return $timeout(function() {
          var parentLabel = element.parent('label');
          if (parentLabel.length) {
            parentLabel.addClass('icheck-label');
          }
          var value;
          value = $attrs.value;

          $scope.$watch($attrs.ngModel, function() {
            angular.element(element).iCheck('update');
          });

          return angular.element(element).iCheck({
            checkboxClass: 'icheckbox_minimal-blue',
            radioClass: 'iradio_minimal-blue'
          }).on('ifChanged', function(event) {
            if (angular.element(element).attr('type') === 'checkbox' && $attrs.ngModel) {
              $scope.$apply(function() {
                return ngModel.$setViewValue(event.target.checked);
              });
            }
            if (angular.element(element).attr('type') === 'radio' && $attrs.ngModel) {
              return $scope.$apply(function() {
                return ngModel.$setViewValue(value);
              });
            }
          });
        });
      }
    };
  }])
  .directive('knob', function() {
    'use strict';
    return {
      restrict: 'EA',
      template: '<input class="dial" type="text"/>',
      scope: {
        options: '='
      },
      replace: true,
      link: function(scope, element) {
        angular.element(element).knob(scope.options);
      }
    };
  })
  .directive('uiBsSlider', ['$timeout', function($timeout) {
    'use strict';
    return {
      link: function(scope, element) {
        // $timeout is needed because certain wrapper directives don't
        // allow for a correct calculation of width
        $timeout(function() {
          element.slider();
        });
      }
    };
  }])
  
  .directive('datepaginator', function() {
    'use strict';
    return {
      restrict: 'A',
      scope: {
        options: '=datepaginator'
      },
      link: function(scope, element) {
        setTimeout(function() {
          element.datepaginator(scope.options);
        }, 10);
      }
    };
  })
  .directive('stickyScroll', function() {
    'use strict';
    return {
      restrict: 'A',
      link: function(scope, element, attr) {
        function stickyTop() {
          var topMax = parseInt(attr.stickyScroll);
          var headerHeight = angular.element('header').height();
          if (headerHeight > topMax) {
            topMax = headerHeight;
          }
          if (angular.element('body').hasClass('static-header') === false) {
            return element.css('top', topMax + 'px');
          }
          var windowTop = angular.element(window).scrollTop();
          if (windowTop < topMax) {
            element.css('top', (topMax - windowTop) + 'px');
          } else {
            element.css('top', 0 + 'px');
          }
        }

        angular.element(function() {
          angular.element(window).scroll(stickyTop);
          stickyTop();
        });
      }
    };
  })
  .directive('rightbarRightPosition', function() {
    'use strict';
    return {
      restrict: 'A',
      scope: {
        isFixedLayout: '=rightbarRightPosition'
      },
      link: function(scope) {
        scope.$watch('isFixedLayout', function(newVal, oldVal) {
          if (newVal !== oldVal) {
            setTimeout(function() {
              var $pc = angular.element('#wrapper');
              var endingRight = (angular.element(window).width() - ($pc.offset().left + $pc.outerWidth()));
              if (endingRight < 0) {
                endingRight = 0;
              }
              angular.element('.infobar').css('right', endingRight);
            }, 100);
          }
        });
      }
    };
  })
  .directive('backToTop', function() {
    'use strict';
    return {
      restrict: 'AE',
      link: function(scope, element) {
        element.click(function() {
          angular.element('body').scrollTop(0);
        });
      }
    };
  })
  .directive('toTopOnLoad', ['$rootScope', function($rootScope) {
    'use strict';
    return {
      restrict: 'AE',
      link: function() {
        $rootScope.$on('$routeChangeSuccess', function() {
          angular.element('body').scrollTop(0);
        });
      }
    };
  }])
  .directive('scrollToBottom', function() {
    'use strict';
    return {
      restrict: 'A',
      scope: {
        model: '=scrollToBottom',
        scrollWait: '=scrollWait'
      },
      link: function(scope, element) {
        scope.$watch('model', function(n, o) {
          if (n !== o) {
            if (scope.scrollWait) {
              setTimeout(function(){element[0].scrollTop = element[0].scrollHeight;}, scope.scrollWait)
            } else {
              element[0].scrollTop = element[0].scrollHeight;
            }
          }
        });
      }
    };
  })
  
  ;


angular.module('theme.core.filters', ['ng'])


// formatuje date za pomocą momentjs

angular.module('theme.core.filters')
.filter('moment', function() {
	return function(date, format) {
		return moment(date).format(format)
	}
})


angular.module('theme.core.filters')

.filter('money', function($filter) {
	return function(amount, fractionsize) {
		if (!Intl || !Intl.NumberFormat) return amount;
		fractionsize = fractionsize || 2;
		var formatter = new Intl.NumberFormat('pl-PL', {
			style: 'decimal',
			minimumFractionDigits: fractionsize,
			maximumFractionDigits: fractionsize
		});
		str = formatter.format(amount);
		return str;
	}
});




angular.module('theme.core.filters')
.filter('numberpl', function($filter) {
	var numberFilter = $filter('number');
	return function(amount, fractionsize) {
		var str = numberFilter(amount, fractionsize);
		/*
		if (typeof str == "string") {
			str = str.replace(/,/, ' ');
			str = str.replace(/\./, ',');
		}
		*/
		return str;
	}
})



// z ciągu znaków typu 1|234|5, np. "wiaderko|wiaderka|wiaderek"
// wybiera formę odpowiadającą liczbie podanej jako parametr

angular.module('theme.core.filters')
.filter('pluralpl', function() {
	return function(str, number) {
		var options = str.split('|');
		if (options.length == 1) {
			return options[0];
		} else if (options.length == 2) {
			if (number == 1) {
				return options[0];
			} else {
				return options[1];
			}
		} else {
			if (number == 1) {
				return options[0];
			} else if (number % 10 >= 2 && number % 10 <= 4 && Math.floor((number % 100) / 10) != 1) {
				return options[1];
			} else {
				return options[2];
			}
		}
	}
})


angular.module('theme.core.filters')

.filter('replace', function () {
  return function (input, from, to) {
    if(input === undefined) {
      return;
    }
    var regex = new RegExp(from, 'g');
    return input.replace(regex, to);
  };
})


angular.module('theme.core.filters')

.filter('trust', function($sce) {
  return function(value, type) {
    return $sce.trustAs(type || 'html', value);
  }
})
angular
  .module('theme', [
    'ngCookies',
    'ngSanitize',
    'ngAnimate',
    'ui.bootstrap',
    'theme.core.template_overrides',
    'theme.core.panels',
    'theme.core.tiles',
    'theme.core.tiles',
    'theme.core.progressbar',
    'theme.core.main_controller',
    'theme.core.directives',
    'theme.core.filters',
  ]);
angular.module('analytics', ['ng']).service('analytics', [
    '$rootScope', '$window', '$location', function($rootScope, $window, $location) {
        var track = function() {
            if ($window._gaq) $window._gaq.push(['_trackPageview', $location.path()]);
            if ($window.ga) $window.ga('send', 'pageview', {page: $location.url()});
        };
        $rootScope.$on('$viewContentLoaded', track);
        $rootScope.$on('$routeChangeSuccess', track);
    }
]);


(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.ClassFactory = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = require('./utils');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

if (!Object.assign) {
	Object.defineProperty(Object, 'assign', {
		enumerable: false,
		configurable: true,
		writable: true,
		value: function value(target) {
			'use strict';

			if (target === undefined || target === null) {
				throw new TypeError('Cannot convert first argument to object');
			}

			var to = Object(target);
			for (var i = 1; i < arguments.length; i++) {
				var nextSource = arguments[i];
				if (nextSource === undefined || nextSource === null) {
					continue;
				}
				nextSource = Object(nextSource);

				var keysArray = Object.keys(Object(nextSource));
				for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
					var nextKey = keysArray[nextIndex];
					var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
					if (desc !== undefined && desc.enumerable) {
						to[nextKey] = nextSource[nextKey];
					}
				}
			}
			return to;
		}
	});
}

var ClassFactory = function () {
	function ClassFactory(ApiRootUrl, $http, $q) {
		_classCallCheck(this, ClassFactory);

		this.ApiRootUrl = ApiRootUrl;
		this.$http = $http;
		this.Promise = $q || Promise; // implementacja promise w Angular jest zintegrowana z digest()

		this.urlToClasses = {};
	}

	_createClass(ClassFactory, [{
		key: 'loadClasses',
		value: function loadClasses(url) {
			var _this = this;

			if (url in this.urlToClasses) {
				// Promise.resolve == $q.when
				return (this.Promise.resolve || this.Promise.when)(this.urlToClasses[url]);
			}

			var absolute_url = this.ApiRootUrl + (url || '/api/v1/meta/classes');
			return this.$http.get(absolute_url).then(function (response) {
				var info = typeof response.data == "string" ? JSON.parse(response.data) : response.data;
				console.debug("Loaded url", url);

				var classes = {};
				_this.makeClasses(info, classes);

				_this.urlToClasses[url] = classes;

				return classes;
			}, function (error) {
				// failed to load classes
				console.debug("Failed to load url", url, error);
				return this.Promise.reject(error);
			});
		}
	}, {
		key: 'classnameToPath',
		value: function classnameToPath(classname) {
			return classname.replace(/([A-Z])/g, '-$1').replace(/^-/, '').toLowerCase();
		}
	}, {
		key: 'getInstance',
		value: function getInstance(classes, data) {
			var classname = data.__class;
			if (!classname) {
				throw "getInstance: No __class property in object";
			}
			if (!(classname in classes)) {
				//throw "getInstance: Unknown class: " + classname;
				console.warn("getInstance: Unknown class: " + classname + ". Returning raw data...");
				return data;
			}
			if (typeof data.__id == "undefined" && typeof data.__vid == "undefined") {
				//throw "No __id in data to instantiate class: " + classname;
				return classes[classname].create(data);
			}
			if ((data.__vid || data.__id) === null) {
				return null;
			}
			var obj = classes[classname].get(data.__vid || data.__id, data);
			return obj;
		}
	}, {
		key: 'activateClasses',
		value: function activateClasses(classes, data) {
			if (data instanceof Object) {
				if ((0, _utils.isArray)(data)) {
					for (var i = 0; i < data.length; i++) {
						if (data[i].__class) {
							data[i] = this.getInstance(classes, data[i]);
						}
					}
				} else if (data.__class) {
					data = this.getInstance(classes, data);
				} else {
					for (var key in data) {
						if (data[key] instanceof Object && data[key].__class) {
							data[key] = this.getInstance(classes, data[key]);
						} else {
							this.activateClasses(classes, data[key]);
						}
					}
				}
			}
			return data;
		}

		// wymuś ponowne pobranie obiektów, po zapisie do bazy

	}, {
		key: 'setDirty',
		value: function setDirty(classes) {
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = (0, _utils.entries)(classes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var _step$value = _slicedToArray(_step.value, 2),
					    classname = _step$value[0],
					    klass = _step$value[1];

					var _iteratorNormalCompletion2 = true;
					var _didIteratorError2 = false;
					var _iteratorError2 = undefined;

					try {
						for (var _iterator2 = (0, _utils.entries)(klass.cache)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
							var _step2$value = _slicedToArray(_step2.value, 2),
							    id = _step2$value[0],
							    obj = _step2$value[1];

							if (obj.__fetched) delete obj.__fetched;
						}
					} catch (err) {
						_didIteratorError2 = true;
						_iteratorError2 = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion2 && _iterator2.return) {
								_iterator2.return();
							}
						} finally {
							if (_didIteratorError2) {
								throw _iteratorError2;
							}
						}
					}
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}
		}
	}, {
		key: 'makeClasses',
		value: function makeClasses(info, classes) {
			var _iteratorNormalCompletion3 = true;
			var _didIteratorError3 = false;
			var _iteratorError3 = undefined;

			try {

				for (var _iterator3 = (0, _utils.entries)(info)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
					var _step3$value = _slicedToArray(_step3.value, 2),
					    classname = _step3$value[0],
					    classinfo = _step3$value[1];

					if (classname[0] == '$') return; // Angular stuff
					classes[classname] = this.makeClass(classname, classinfo, classes);
				}
			} catch (err) {
				_didIteratorError3 = true;
				_iteratorError3 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion3 && _iterator3.return) {
						_iterator3.return();
					}
				} finally {
					if (_didIteratorError3) {
						throw _iteratorError3;
					}
				}
			}

			return classes;
		}
	}, {
		key: 'makeClass',
		value: function makeClass(classname, classinfo, classes) {
			var _this2 = this;

			var factory = this;
			var klass = void 0;

			console.debug('Creating class:', classname);

			try {
				eval('klass = function ' + classname + '() {}');
				//klass = eval(classname);
			} catch (e) {
				klass = function klass() {};
			}

			// Class information
			var _iteratorNormalCompletion4 = true;
			var _didIteratorError4 = false;
			var _iteratorError4 = undefined;

			try {
				for (var _iterator4 = (0, _utils.entries)(classinfo)[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
					var _step4$value = _slicedToArray(_step4.value, 2),
					    key = _step4$value[0],
					    _value = _step4$value[1];

					klass[key] = _value;
				}

				// Static methods
			} catch (err) {
				_didIteratorError4 = true;
				_iteratorError4 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion4 && _iterator4.return) {
						_iterator4.return();
					}
				} finally {
					if (_didIteratorError4) {
						throw _iteratorError4;
					}
				}
			}

			klass.classname = classname;

			klass.cache = {};

			// Datastore methods
			klass.get = function (vid) {
				var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

				if (data && data.__classname) {
					// actual class instance
					return data;
				}
				if (!klass.cache[vid]) {
					klass.cache[vid] = new klass();
					data = data || { __vid: vid };
					data.__class = klass.classname;
				}
				var obj = klass.cache[vid];
				if (data && (typeof data === 'undefined' ? 'undefined' : _typeof(data)) == "object") obj.fill(data);
				return obj;
			};

			// create new instance of the class
			klass.create = function () {
				var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

				if (data && data.__classname) {
					// actual class instance
					return data;
				}
				var obj = new klass();
				// assign perms
				if (klass.perms && klass.perms.create) {
					obj.__perms = klass.perms.create;
				}
				// fill data
				if (data) {
					if (data.__vid || data.__id || data.id) {
						throw "Class create: data contains id information";
					}
					data.__class = klass.classname;
					obj.fill(data);
				}
				return obj;
			};

			klass.getObjectPayload = function (obj) {
				var group = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
				var omit_fieldname = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

				var payload = {};
				if (obj.__vid) payload.__vid = obj.__vid;
				if (obj.__id) payload.__id = obj.__id;
				if (obj.__class) payload.__class = obj.__class;
				if (obj.__title) payload.__title = obj.__title;
				var _iteratorNormalCompletion5 = true;
				var _didIteratorError5 = false;
				var _iteratorError5 = undefined;

				try {
					for (var _iterator5 = klass.get_fields(group)[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
						var field = _step5.value;

						var fieldname = field.name;
						var value = obj[fieldname];
						if (typeof value == "undefined") continue;

						if (fieldname == omit_fieldname) continue;

						if (!field.join) {
							payload[fieldname] = value; // not a reference type
						}

						if (field.join && field.join.type == 'foreignKey') {
							if (value && (value.__vid != null || value.__id != null || value.id != null || value.__class != null)) {
								payload[fieldname] = {};
								if (value.getClass) payload[fieldname] = value.getClass().getObjectPayload(value, group || 'essential');else if (value.__class && classes[value.__class]) payload[fieldname] = classes[value.__class].getObjectPayload(value, group || 'essential');
								if (value.__CONTEXT_OBJECT__) payload[fieldname].__CONTEXT_OBJECT__ = value.__CONTEXT_OBJECT__;
							} else {
								payload[fieldname] = value;
							}
						}

						if (field.join && field.join.type == 'backRef') {
							var ret = [];
							if (value && value.length >= 0) {
								var _iteratorNormalCompletion6 = true;
								var _didIteratorError6 = false;
								var _iteratorError6 = undefined;

								try {
									for (var _iterator6 = value[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
										var item = _step6.value;

										ret.push(classes[field.join.foreignClass].getObjectPayload(item, group, field.join.backref));
									}
								} catch (err) {
									_didIteratorError6 = true;
									_iteratorError6 = err;
								} finally {
									try {
										if (!_iteratorNormalCompletion6 && _iterator6.return) {
											_iterator6.return();
										}
									} finally {
										if (_didIteratorError6) {
											throw _iteratorError6;
										}
									}
								}
							}
							payload[fieldname] = ret;
						}
					}
				} catch (err) {
					_didIteratorError5 = true;
					_iteratorError5 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion5 && _iterator5.return) {
							_iterator5.return();
						}
					} finally {
						if (_didIteratorError5) {
							throw _iteratorError5;
						}
					}
				}

				return payload;
			};

			klass.updateObject = function (obj) {
				var group = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
				var payload = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

				// TODO - validation
				var orig_vid = obj.__vid;
				if (group && (typeof group === 'undefined' ? 'undefined' : _typeof(group)) == 'object') group = JSON.stringify(group);
				var config = {
					method: 'post',
					url: klass.ApiRootPath + (orig_vid ? '/' + orig_vid : '') + (group ? '?group=' + group : ''),
					data: payload || klass.getObjectPayload(obj)
				};
				return factory.$http(config).then(function (result) {

					factory.setDirty(classes); // kasuj wszystko, nie wiadomo co się zmieniło :)

					obj.fill(result.data, true); // aktualizuje backref, ale poprzez wymianę niezapisanych obiektów
					obj.__fetched = (_this2.Promise.resolve || _this2.Promise.when)(obj);
					if (!orig_vid) {
						// utworzono nowy obiekt - aktualzuj cache
						klass.cache[obj.__vid] = obj;
					}

					return obj;
				});
			};

			klass.deleteObject = function (obj) {
				var orig_vid = obj.__vid;
				var config = {
					method: 'delete',
					url: klass.ApiRootPath + (orig_vid ? '/' + orig_vid : '')
				};
				return factory.$http(config).then(function (result) {
					delete obj.__fetched;
					if (!orig_vid) {
						// skasowano obiekt - aktualzuj cache
						delete klass.cache[obj.__vid];
					}

					factory.setDirty(classes); // kasuj wszystko, nie wiadomo co się zmieniło :)

					return true;
				});
			};

			klass.find = function (params) {
				var config = {
					method: 'get',
					url: klass.ApiRootPath,
					params: params
				};
				return factory.$http(config).then(function (result) {
					var ret = [];
					if ((0, _utils.isArray)(result.data)) {
						var _iteratorNormalCompletion7 = true;
						var _didIteratorError7 = false;
						var _iteratorError7 = undefined;

						try {
							for (var _iterator7 = result.data[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
								var item = _step7.value;

								ret.push(factory.getInstance(classes, item));
							}
						} catch (err) {
							_didIteratorError7 = true;
							_iteratorError7 = err;
						} finally {
							try {
								if (!_iteratorNormalCompletion7 && _iterator7.return) {
									_iterator7.return();
								}
							} finally {
								if (_didIteratorError7) {
									throw _iteratorError7;
								}
							}
						}
					}
					return ret;
				});
			};

			var intersection = function intersection(a1, a2) {
				var res = [];
				var _iteratorNormalCompletion8 = true;
				var _didIteratorError8 = false;
				var _iteratorError8 = undefined;

				try {
					for (var _iterator8 = a1[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
						var item = _step8.value;

						if (a2.indexOf(item) >= 0) res.push(item);
					}
				} catch (err) {
					_didIteratorError8 = true;
					_iteratorError8 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion8 && _iterator8.return) {
							_iterator8.return();
						}
					} finally {
						if (_didIteratorError8) {
							throw _iteratorError8;
						}
					}
				}

				return res;
			};

			// Api methods
			klass.get_fields = function (group) {
				group = typeof group == "string" ? [group] : group;
				var fields = [];
				for (var fname in klass.fields) {
					if (group == null || intersection(klass.fields[fname].groups || [], group).length > 0) fields.push(klass.fields[fname]);
				}
				return fields;
			};

			// pobieranie listy metod (z opcjonalnym filterm grupy)
			klass.get_methods = function (group) {
				group = typeof group == "string" ? [group] : group;
				var methods = [];
				// class/object methods
				for (var fname in klass.methods) {
					if (group == null || intersection(klass.methods[fname].groups || [], group).length > 0) {
						var m = klass.methods[fname];
						m.path = m.field ? m.field + '.' + m.name : m.name;
						methods.push(m);
					}
				}
				/*
    if (group == null) {
    	// field methods
    	for (let fname in klass.fields) {
    		let field = klass.fields[fname];
    		if (field.methods) {
    			for (let mname in field.methods) {
    				let m = = field.methods[mname];
    				m.path = fname + '.' + mname;
    				methods.push(m);
    			}
    		}
    	}
    	// class/object method param methods
    	for (let aname in klass.methods) {
    		for (let param of klass.methods[aname]) {
    			if (param.field && param.field.methods) {
    				for (let mname in param.field.methods) {
    					let m = = param.field.methods[mname];
    					m.path = aname + '.' + param.field.name + '.' + mname;
    					methods.push(m);
    				}
    			}
    		}	
    	}
    }
    */
				return methods;
			};

			klass.get_form_params = function () {
				var object = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
				var fields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
				var perms = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

				var operms, clsfields;
				if (object) {
					operms = perms || object.__perms || {};
				} else {
					operms = perms || klass.perms.create || {};
				}
				var clsfields = fields || klass.get_fields('edit');
				var clsmethods = klass.get_methods();
				var fields = [];
				var _iteratorNormalCompletion9 = true;
				var _didIteratorError9 = false;
				var _iteratorError9 = undefined;

				try {
					for (var _iterator9 = clsfields[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
						var clsfield = _step9.value;

						var field = {
							"title": clsfield.title,
							"type": clsfield.type,
							"name": clsfield.name,
							"groups": clsfield.groups || ['edit'],
							"required": clsfield.required,
							"visible": operms[clsfield.viewperm] ? clsfield.enable || 'true' : 'false',
							"editable": operms[clsfield.editperm] ? 'true' : 'false',
							"default": clsfield['default'],
							"redefault_on": (clsfield.client || {}).redefault_on || 'never',
							"client": clsfield.client
							// "dictionary"
							// "dict"
							// "depends"
							// "fields"
						};
						if (clsfield.depends) {
							field.depends = clsfield.depends;
						}
						if (clsfield.dictionary) {
							field.dictionary = clsfield.dictionary;
						}
						if (clsfield.join) {
							// ReferenceField or BackReferenceField or GridReferenceField
							field.join = clsfield.join;
							if (clsfield.type == "BackReferenceField" || clsfield.type == "GridReferenceField") {
								if (!classes[field.join.foreignClass]) {
									throw "Invalid ref, no foreignClass: " + field.join.foreignClass;
								}
								var subfields = classes[field.join.foreignClass].get_fields((field.client || {}).editgroup || 'edit');
								field.fields = classes[field.join.foreignClass].get_form_params(null, subfields, perms);
							}
						}
						if (clsfield.client && clsfield.client.fields && typeof clsfield.client.fields.length == "number") {
							field.fields = klass.get_form_params(object, clsfield.client.fields, perms);
						}
						if (clsfield.client && clsfield.client.actions && typeof clsfield.client.actions.length == "number") {
							var actions = [];
							var _iteratorNormalCompletion10 = true;
							var _didIteratorError10 = false;
							var _iteratorError10 = undefined;

							try {
								for (var _iterator10 = clsfield.client.actions[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
									var action = _step10.value;

									action.form = klass.get_form(action.formname);
									actions.push(action);
								}
							} catch (err) {
								_didIteratorError10 = true;
								_iteratorError10 = err;
							} finally {
								try {
									if (!_iteratorNormalCompletion10 && _iterator10.return) {
										_iterator10.return();
									}
								} finally {
									if (_didIteratorError10) {
										throw _iteratorError10;
									}
								}
							}

							field.client.actions = actions;
						}
						// "dict" and other methods
						/*for (var clsmethod of clsmethods) {
      	if (clsmethod.field == (clsfield.path||clsfield.name)) {
      		// bind method to the field
      		if (clsmethod.is_static) {
      			field[clsmethod.name] = klass[clsmethod.path.replace('.', '__')];
      		} else if (object) {
      			field[clsmethod.name] = object[clsmethod.path.replace('.', '__')];
      		}
      	}
      }*/
						if (clsfield.methods != null && _typeof(clsfield.methods) == "object") {
							for (var mname in clsfield.methods) {
								var funcname = clsfield.methods[mname].replace(/\./g, '__');
								field[mname] = object && object[funcname] || klass[funcname]; // instance or static method
							}
						}
						fields.push(field);
					}
				} catch (err) {
					_didIteratorError9 = true;
					_iteratorError9 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion9 && _iterator9.return) {
							_iterator9.return();
						}
					} finally {
						if (_didIteratorError9) {
							throw _iteratorError9;
						}
					}
				}

				return fields;
			};

			klass._method_to_form = function (method, object) {
				var form = {
					title: method.title,
					prompt: method.prompt,
					btn: method.title,
					templateUrl: method.templateUrl || null, // used in form-service
					/*'name': method.name,
     'path': method.path,
     'context': method.is_static? klass : object,*/
					perm: method.perm, // used in actions visibility
					params: [],
					layout: ['edit'],
					submit: function submit(values) {
						var context = method.is_static ? klass : object;
						return context[method.path.replace(/\./g, '__')](values);
					}
				};
				var fields = [];
				for (var p in method.params) {
					if (!method.params[p].field) continue;
					var field = angular.copy(method.params[p].field);
					field.path = method.path + '.' + field.name;
					fields.push(field);
				}
				var perms = method.is_static ? klass.perms : object.__perms;
				form.params = klass.get_form_params(object, fields, perms);
				return form;
			};

			klass.get_forms = function (group, object) {
				var methods = klass.get_methods(group);
				var forms = [];
				for (var i = 0; i < methods.length; i++) {
					var method = methods[i];
					if (!method.is_static && !object) continue;
					var form = klass._method_to_form(method, object);
					forms.push(form);
				}
				return forms;
			};

			klass.get_form = function (method_name, object) {
				var methods = klass.get_methods();
				var forms = [];
				for (var i = 0; i < methods.length; i++) {
					var method = methods[i];
					if (method.name == method_name) {
						return klass._method_to_form(method, object);
					}
				}
				return null;
			};

			klass.clone_instance = function (original) {
				var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
				var group = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'edit';

				return original.fetch(false, 2).then(function (original) {
					data = data || {};
					var waitables = [];
					var fields = klass.get_fields(group);
					var _iteratorNormalCompletion11 = true;
					var _didIteratorError11 = false;
					var _iteratorError11 = undefined;

					try {
						var _loop = function _loop() {
							var field = _step11.value;

							var value = void 0;
							if (!field.join) {
								value = original[field.name]; // not a reference type
							}

							if (field.join && field.join.type == 'foreignKey') {
								value = original[field.name]; // do not clone foreign key objects
							}

							if (field.join && field.join.type == 'backRef') {
								// cascade clone to editable backref objects
								value = [];
								var foreignKlass = classes[field.join.foreignClass];
								if (!foreignKlass) throw "Invalid backRef, no foreignClass: " + field.join.foreignClass;
								if (original[field.name] && original[field.name].length >= 0) {
									var _iteratorNormalCompletion13 = true;
									var _didIteratorError13 = false;
									var _iteratorError13 = undefined;

									try {
										for (var _iterator13 = original[field.name][Symbol.iterator](), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
											var item = _step13.value;

											var promise = foreignKlass.clone_instance(item, null, group).then(function (instance) {
												instance[field.join.backref] = null;
												value.push(instance);
												return function (parent) {
													instance[field.join.backref] = parent;
												};
											});
											waitables.push(promise);
										}
									} catch (err) {
										_didIteratorError13 = true;
										_iteratorError13 = err;
									} finally {
										try {
											if (!_iteratorNormalCompletion13 && _iterator13.return) {
												_iterator13.return();
											}
										} finally {
											if (_didIteratorError13) {
												throw _iteratorError13;
											}
										}
									}
								}
							}
							data[field.name] = value;
						};

						for (var _iterator11 = fields[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
							_loop();
						}
					} catch (err) {
						_didIteratorError11 = true;
						_iteratorError11 = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion11 && _iterator11.return) {
								_iterator11.return();
							}
						} finally {
							if (_didIteratorError11) {
								throw _iteratorError11;
							}
						}
					}

					return factory.Promise.all(waitables).then(function (initializers) {
						var instance = klass.create(data);
						var _iteratorNormalCompletion12 = true;
						var _didIteratorError12 = false;
						var _iteratorError12 = undefined;

						try {
							for (var _iterator12 = initializers[Symbol.iterator](), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
								var initializer = _step12.value;

								initializer(instance);
							}
						} catch (err) {
							_didIteratorError12 = true;
							_iteratorError12 = err;
						} finally {
							try {
								if (!_iteratorNormalCompletion12 && _iterator12.return) {
									_iterator12.return();
								}
							} finally {
								if (_didIteratorError12) {
									throw _iteratorError12;
								}
							}
						}

						return instance;
					});
				});
			};

			klass.get_text_search_query = function () {
				var fields = klass.get_fields('list').filter(function (field) {
					return klass.perms[field.listperm];
				});
				var textfields = ["''"]; // in case of no fields
				for (var i in fields) {
					var f = fields[i];
					if (f.type == 'TextField' || f.type == 'Field') textfields.push("coalesce(" + f.name + ",'')");else if (f.type == 'IntField' || f.type == 'DecimalField') textfields.push("coalesce(" + f.name + "::text,'')");else if (f.type == 'ReferenceField') {
						if (classes[f.join.foreignClass].fields['title']) textfields.push("coalesce(" + f.name + ".title,'')");else textfields.push("coalesce((" + f.sort_expr + ")::text,'')");
					} else if (f.type.match(/CalculatedField$/)) textfields.push("coalesce((" + f.sort_expr + ")::text,'')");else if (f.client && f.client.widget == 'Field' && intersection(f.groups || [], 'filter').length > 0) textfields.push("coalesce((" + f.sort_expr + ")::text,'')");
				}
				return "array_to_string(ARRAY[" + textfields.join(", ") + "], ' ') ~* ALL(string_to_array(?, ' '))";
			};

			klass.get_sortcol = function (fieldname) {
				var field = klass.fields[fieldname];
				if (!field) return null;
				return field.sort_expr;
			};

			klass.get_url = function (verb, params) {
				var to_query_string = function to_query_string(obj) {
					var str = [];
					for (var p in obj) {
						if (obj.hasOwnProperty(p)) {
							var v = _typeof(obj[p]) == "object" ? angular.toJson(obj[p]) : obj[p];
							str.push(encodeURIComponent(p) + "=" + encodeURIComponent(v));
						}
					}return str.join("&");
				};
				var url = this.ApiRootPath + '/' + verb + '?' + to_query_string(params);
				return url;
			};

			var class_path = factory.classnameToPath(classname);
			klass.ApiRootPath = factory.ApiRootUrl + '/api/v1/' + class_path;

			// remote static methods
			var methods = klass.get_methods();
			var _iteratorNormalCompletion14 = true;
			var _didIteratorError14 = false;
			var _iteratorError14 = undefined;

			try {
				for (var _iterator14 = methods[Symbol.iterator](), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
					var method = _step14.value;

					if (!method.is_static || method.http['default']) continue;

					(function (method, classname) {
						var path = method.path.replace(/\./g, '__');
						//console.debug('Adding class method:', path, method);
						klass[path] = function (args) {
							var config = {
								method: method.http.method.toLowerCase(),
								url: klass.ApiRootPath + '/' + method.path
							};
							if (config.method == 'post' || config.method == 'put') {
								config.data = args;
							} else {
								config.params = args;
							}

							var promise = factory.$http(config).then(function (result) {
								if (config.method != 'get') {
									factory.setDirty(classes); // po metodzie POST wszystko się mogło zmienić.
								}
								var data = result.data;
								return factory.activateClasses(classes, data);
							});

							return promise;
						};
						klass[path].method = method;
					})(method, classname);
				}

				// remote instance methods
			} catch (err) {
				_didIteratorError14 = true;
				_iteratorError14 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion14 && _iterator14.return) {
						_iterator14.return();
					}
				} finally {
					if (_didIteratorError14) {
						throw _iteratorError14;
					}
				}
			}

			var _iteratorNormalCompletion15 = true;
			var _didIteratorError15 = false;
			var _iteratorError15 = undefined;

			try {
				for (var _iterator15 = methods[Symbol.iterator](), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
					var _method = _step15.value;

					if (_method.is_static || _method.http['default']) continue;
					(function (method, classname) {
						var path = method.path.replace(/\./g, '__');
						var global_config = {
							method: method.http.method.toLowerCase()
							//console.debug('Adding class method:', path, method);
						};klass.prototype[path] = function (args) {
							var config = Object.assign({}, global_config);
							config.url = klass.ApiRootPath + '/' + this.__vid + '/' + method.path;
							if (config.method == 'post' || config.method == 'put') {
								config.data = args;
							} else {
								config.params = args;
							}

							var promise = factory.$http(config).then(function (result) {
								if (config.method != 'get') {
									factory.setDirty(classes); // po metodzie POST/PUT/DELETE wszystko się mogło zmienić.
								}
								var data = result.data;
								return factory.activateClasses(classes, data);
							});

							return promise;
						};
						klass.prototype[path].method = method;
					})(_method, classname);
				}
			} catch (err) {
				_didIteratorError15 = true;
				_iteratorError15 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion15 && _iterator15.return) {
						_iterator15.return();
					}
				} finally {
					if (_didIteratorError15) {
						throw _iteratorError15;
					}
				}
			}

			var mapField = function mapField(fieldname, value, oldvalue) {
				var field = klass.fields[fieldname];
				if (!field) {
					console.warn('Attempted to get() nonexisting field: ' + fieldname);
					return null;
				}

				if (!field.join) {
					return value; // not a reference type
				}

				if (field.join && field.join.type == 'foreignKey') {
					if (value === null) return null;
					if (typeof value === "undefined") return null;
					if (value.__vid != null || value.__id != null) {
						return factory.getInstance(classes, value);
						//return classes[field.join.foreignClass].get(value.__vid, value);
					} else {
						return null;
					}
				}

				if (field.join && field.join.type == 'backRef') {
					var ret = oldvalue || [];
					ret.length = 0;
					if (value && value.length >= 0) {
						var _iteratorNormalCompletion16 = true;
						var _didIteratorError16 = false;
						var _iteratorError16 = undefined;

						try {
							for (var _iterator16 = value[Symbol.iterator](), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
								var item = _step16.value;

								//ret.push(classes[field.join.foreignClass].get(item.__vid, item));
								ret.push(factory.getInstance(classes, item));
							}
						} catch (err) {
							_didIteratorError16 = true;
							_iteratorError16 = err;
						} finally {
							try {
								if (!_iteratorNormalCompletion16 && _iterator16.return) {
									_iterator16.return();
								}
							} finally {
								if (_didIteratorError16) {
									throw _iteratorError16;
								}
							}
						}
					}
					return ret;
				}
			};

			// Instance methods
			klass.prototype.__classname = classname;

			/*
    * This method updates the object with data provided from an external source, API
    */
			klass.prototype.fill = function (data, force) {
				// extract metadata
				if (data.__class) this.__class = data.__class;
				if (data.__id) this.__id = data.__id;
				if (data.__vid) this.__vid = data.__vid;
				if (data.__title) this.__title = data.__title;
				if (data.__perms) this.__perms = data.__perms;
				if (data.__callstatus) this.__callstatus = data.__callstatus;
				// update actual object data
				for (var fieldname in data) {
					if (!klass.fields[fieldname]) continue; // only actual fields
					// don't update user-modified fields, only unseen or unmodified.
					// this is important when someone has modified things, yet more information comes from API.
					if (force || klass.fields[fieldname].join || typeof this[fieldname] == "undefined" || this[fieldname] == this._original[fieldname]) {
						this[fieldname] = mapField(fieldname, data[fieldname], this[fieldname]);
					}
				}
				// update the original data cache
				this._original = this._original || {};
				Object.assign(this._original, data);
			};

			/*
    * Rollback user changes to the object
    */
			klass.prototype.rollback = function () {
				for (var fieldname in this._original) {
					if (!klass.fields[fieldname]) continue; // only actual fields
					this[fieldname] = mapField(fieldname, this._original[fieldname], this[fieldname]);
				}
			};

			klass.prototype.tmp_title = function () {
				return this.title;
			};

			klass.prototype.has_perm = function (perms) {
				if (typeof perms == "undefined") {
					console.debug('Undefined perm argument passed to ' + this.__classname + '(' + this.__vid + ').has_perm()');
					return false;
				}
				if (typeof perms == "string") perms = [perms];
				for (var i = 0; i < perms.length; i++) {
					if (this.__perms[perms[i]]) return true;
				}
				return false;
			};

			klass.prototype.get_forms = function (group) {
				return klass.get_forms(group, this);
			};

			klass.prototype.get_form = function (method_name) {
				return klass.get_form(method_name, this);
			};

			klass.prototype.get_form_params = function () {
				var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
				var perms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

				return klass.get_form_params(this, fields, perms);
			};

			klass.prototype.parent_field = function () {
				var field;
				for (var i in klass.fields) {
					if (klass.fields[i].is_parent) {
						field = klass.fields[i];
						break;
					}
				}
				return field;
			};

			klass.prototype.get_parent = function () {
				//return null;
				var field = this.parent_field();
				if (field && this[field.name]) {
					return this[field.name];
				}
				return null;
			};

			// Zwraca tą samą instancję po pobraniu danych z serwera
			klass.prototype.fetch = function (force) {
				var _this3 = this;

				var levels = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

				if (!this.__fetched && this._original.__loaded >= levels) {
					this.__fetched = (factory.Promise.resolve || factory.Promise.when)(this);
				}
				if (this.__fetched && !force) {
					return this.__fetched.then(function () {
						return _this3;
					});
				}
				var config = {
					method: 'get',
					url: klass.ApiRootPath + '/' + this.__vid + (levels ? '?levels=' + levels : '')
				};
				return this.__fetched = factory.$http(config).then(function (result) {
					_this3.fill(result.data);
					return _this3;
				});
			};

			// eg. get('landlord')
			//     get('landlord.last_name'), etc.
			klass.prototype.get = function (fieldpath) {
				var _this4 = this;

				var path = fieldpath.split('.');
				var fieldname = path.shift();
				return new factory.Promise(function (resolve, reject) {
					var loaded = void 0;
					if (typeof _this4[fieldname] == "undefined") {
						// field is curently not loaded
						loaded = _this4.fetch();
					} else {
						// field is loaded
						loaded = (factory.Promise.resolve || factory.Promise.when)(_this4);
					}

					loaded.then(function () {
						if (path.length > 0) {
							if (_this4[fieldname] === null) {
								resolve(null);
							} else {
								_this4[fieldname].get(path.join('.')).then(resolve, reject);
							}
						} else {
							resolve(_this4[fieldname]);
						}
					}, reject);
				});
			};

			/*var define_properties = function() {
   	for (let field_name in klass.fields) {
   		(function(field_name){
   			console.log('Defining property ', field_name);
   			var field = klass.fields[field_name];
   			Object.defineProperty(klass.prototype, field_name, {
   	            get: function(){ return this.get(field_name) },
   	            set: function(new_value){
   	                this._data[field_name] = new_value;
   	            },
   	            enumerable: true,
   				configurable: true,
   	        });
   	    })(field_name);
       }
   }
   define_properties()
   */

			// alias to update?
			klass.prototype.save = function () {
				var groups = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
				var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

				return klass.updateObject(this, groups, payload);
			};

			klass.prototype.delete = function () {
				return klass.deleteObject(this);
			};

			klass.prototype.getClass = function () {
				return klass;
			};

			return klass;

			// TODO
			/*
    x usunąć define_properties, przy fill przerabiać referencje na obiekty
    x dodać fetch() - wczytuje obiekt -> Promise.
    X dodać metody instancji
    * opracować metodę wykrywania zmian w obiekcie, observe?
   */
		}
	}]);

	return ClassFactory;
}();

exports.ClassFactory = ClassFactory;

},{"./utils":7}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Classes = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _classFactory = require("./classFactory");

var _utils = require("./utils");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Classes = function Classes(ApiRootUrl, $http, $q) {
	_classCallCheck(this, Classes);

	if (_typeof(Classes.info) === "object") {
		var cf = new _classFactory.ClassFactory(ApiRootUrl, $http, $q);
		var classes = {};
		cf.makeClasses(Classes.info, classes);
		Object.assign(this, classes);
		window.Classes = classes;
	} else {
		(console.error || console.log).call(console, "Classes: Classes.info is not an object");
	}
};

Classes.setInfo = function (json) {
	if ((typeof json === "undefined" ? "undefined" : _typeof(json)) === 'object' && json !== null) {
		Classes.info = json;
	} else {
		throw "setInfo: Expected an object, got " + (typeof json === "undefined" ? "undefined" : _typeof(json));
	}
};

exports.Classes = Classes;

},{"./classFactory":1,"./utils":7}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CurrentUser = function () {

	//instance;
	//logoutRequest;
	//classes;

	// param: Classes - instance of  Persistent.Classes
	function CurrentUser(Classes) {
		_classCallCheck(this, CurrentUser);

		this.classes = Classes;
		if (_typeof(CurrentUser.info) === "object") {
			if (CurrentUser.info.__id) {
				// użytkownik zalogowany
				this.instance = Classes.Person.get(CurrentUser.info.__id, CurrentUser.info);
			}
		} else {
			(console.debug || console.log).call(console, "CurrentUser: CurrentUser.info is not an object");
		}
	}

	_createClass(CurrentUser, [{
		key: "isLoggedIn",
		value: function isLoggedIn() {
			return this.instance != null;
		}
	}, {
		key: "logout",
		value: function logout() {
			var self = this;
			if (!this.logoutRequest) {
				this.logoutRequest = this.classes.Person.logout().then(function () {
					self.instance = null;
					self.logoutRequest = null;
				});
			}
			return this.logoutRequest;
		}
	}]);

	return CurrentUser;
}();

CurrentUser.setInfo = function (json) {
	if ((typeof json === "undefined" ? "undefined" : _typeof(json)) === 'object' && json !== null) {
		CurrentUser.info = json;
	} else {
		throw "setInfo: Expected an object, got " + (typeof json === "undefined" ? "undefined" : _typeof(json));
	}
};

exports.CurrentUser = CurrentUser;

},{}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CurrentUserPrefs = function () {

	//user;
	//cache;


	// param: Classes - instance of  Persistent.Classes
	function CurrentUserPrefs(CurrentUser, $q) {
		_classCallCheck(this, CurrentUserPrefs);

		this.cache = {};
		this.Promise = $q || Promise; // implementacja promise w Angular jest zintegrowana z digest()
		if (_typeof(CurrentUser.instance) === "object") {
			this.user = CurrentUser;
		} else {
			(console.error || console.log).call(console, "CurrentUserPrefs: CurrentUser.instance is not an object");
		}
	}

	// zapisuje ustawienie value w preferencjach uzytkownika
	// value - string | number | object
	// value - null - usuwa preferencję z ustawień użytkownika


	_createClass(CurrentUserPrefs, [{
		key: "put",
		value: function put(key, value) {
			// do something with $http to put value
			this.cache[key] = value;
			if (this.user && this.user.instance) {
				return this.user.instance.set_preference({ key: key, value: value }).then(function () {
					return true;
				});
			}
			return (this.Promise.resolve || this.Promise.when)(true);
		}

		// pobiera preferencję z ustawień użytkownika
		// zwraca Promise

	}, {
		key: "get",
		value: function get(key) {
			var _this = this;

			// do something with $http to get value
			if (typeof this.cache[key] == "undefined") {
				this.cache[key] == null;
				if (this.user && this.user.instance && this.user.instance.prefs) {
					for (var name in this.user.instance.prefs) {
						this.cache[name] = this.user.instance.prefs[name];
					}
				} else {
					console.debug('Preferences are not loaded in CurrentUser.instance');
					return this.user.instance.fetch().then(function (object) {
						for (var _name in object.prefs) {
							_this.cache[_name] = object.prefs[_name];
						}
						return _this.cache[key];
					});
				}
			}
			return (this.Promise.resolve || this.Promise.when)(this.cache[key]);
		}
	}]);

	return CurrentUserPrefs;
}();

exports.CurrentUserPrefs = CurrentUserPrefs;

},{}],5:[function(require,module,exports){
'use strict';

var _classFactory = require('./classFactory');

var _classes = require('./classes');

var _currentUser = require('./currentUser');

var _currentUserPrefs = require('./currentUserPrefs');

var _simpleObservable = require('./simpleObservable');

window.Persistent = {
	ClassFactory: _classFactory.ClassFactory,
	Classes: _classes.Classes,
	CurrentUser: _currentUser.CurrentUser,
	CurrentUserPrefs: _currentUserPrefs.CurrentUserPrefs,
	SimpleObservable: _simpleObservable.SimpleObservable
};

},{"./classFactory":1,"./classes":2,"./currentUser":3,"./currentUserPrefs":4,"./simpleObservable":6}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var SimpleObservable = function SimpleObservable(PromiseMaker) {

	var observer = function callAndCatchThePromise() {
		var promise = PromiseMaker.apply(this, arguments);
		if ((typeof promise === "undefined" ? "undefined" : _typeof(promise)) == "object" && typeof promise.then == "function") {
			// returns promise
			promise.then(function (result) {
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;

				try {
					for (var _iterator = observer._subscribers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var callback = _step.value;

						callback.call(null, result);
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}
			});
		} else {
			// returns straight value
			var result = promise;
			var _iteratorNormalCompletion2 = true;
			var _didIteratorError2 = false;
			var _iteratorError2 = undefined;

			try {
				for (var _iterator2 = observer._subscribers[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
					var callback = _step2.value;

					callback.call(null, result);
				}
			} catch (err) {
				_didIteratorError2 = true;
				_iteratorError2 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion2 && _iterator2.return) {
						_iterator2.return();
					}
				} finally {
					if (_didIteratorError2) {
						throw _iteratorError2;
					}
				}
			}
		}
		return promise;
	};
	observer._subscribers = [];
	observer.subscribe = function (func) {
		observer._subscribers.push(func);
	};

	return observer;
};

exports.SimpleObservable = SimpleObservable;

},{}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
   value: true
});

/*
function* entries(obj) {
   for (let key of Object.keys(obj)) {
     yield [key, obj[key]];
   }
}
*/
var entries = function entries(obj) {
   var ret = [];
   var _iteratorNormalCompletion = true;
   var _didIteratorError = false;
   var _iteratorError = undefined;

   try {
      for (var _iterator = Object.keys(obj)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
         var key = _step.value;

         ret.push([key, obj[key]]);
      }
   } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
   } finally {
      try {
         if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
         }
      } finally {
         if (_didIteratorError) {
            throw _iteratorError;
         }
      }
   }

   return ret;
};

var isArray = function isArray(arg) {
   //return Object.prototype.toString.call(arg) === '[object Array]';
   return arg.constructor === Array;
};

exports.entries = entries;
exports.isArray = isArray;

},{}]},{},[5])





angular.module('persistent', [])
	.service('ClassFactory', Persistent.ClassFactory)
	.service('Classes', Persistent.Classes)
	.service('CurrentUser', Persistent.CurrentUser)
	.service('CurrentUserPrefs', Persistent.CurrentUserPrefs)
	.factory('SimpleObservable', function() {return Persistent.SimpleObservable;})
	


angular.module('languages', ['pascalprecht.translate', 'ngCookies', 'tmh.dynamicLocale', 'ui.bootstrap'])




	.config(function ($translateProvider, LOCALES) {
		$translateProvider.useStaticFilesLoader({
			prefix: LOCALES.dir + '/locale-',
			suffix: '.json'
		});
		$translateProvider.preferredLanguage(LOCALES.preferredLocale || 'en_US');// is applied on first load
		$translateProvider.useLocalStorage();// saves selected language to localStorage
		$translateProvider.useMissingTranslationHandlerLog();
		$translateProvider.useSanitizeValueStrategy(null);  // http://angular-translate.github.io/docs/#/guide/19_security
	})

	.config(function (tmhDynamicLocaleProvider) {
		tmhDynamicLocaleProvider.localeLocationPattern('bower_components/angular-i18n/angular-locale_{{locale}}.js');
	})

	.service('LocaleService', function ($translate, LOCALES, $rootScope, $injector, $timeout) {
		'use strict';

		var localesObj = LOCALES.locales;

		var _LOCALES = Object.keys(localesObj);
		if (!_LOCALES || _LOCALES.length === 0) {
			console.log('There are no _LOCALES provided');
		}

		var _LOCALES_DISPLAY_NAMES = [];
		_LOCALES.forEach(function (locale) {
			_LOCALES_DISPLAY_NAMES.push(localesObj[locale]);
		});

		$rootScope.currentLocale = $translate.use() || LOCALES.preferredLocale;
		var currentLocale = $translate.use() || LOCALES.preferredLocale;
		self.currentLocale = $translate.use() || LOCALES.preferredLocale;


		// check avaliable locales
		var checkLocaleIsValid = function (locale) {
			return _LOCALES.indexOf(locale) !== -1;
		};

    
		// set current locale
    		var setLocale = function (locale) {
			if (!checkLocaleIsValid(locale)) {
				console.log('Locale name "' + locale + '" is invalid');
				return false;
			}
			$rootScope.currentLocale = locale;
			self.currentLocale = locale;
			currentLocale = locale;

			// asking angular-translate to load and apply proper translations
			$translate.use(locale);
			if (window.moment) {
				window.moment.locale(locale.replace('/_.*/', ''));
			}
		
			return true;
    		};
    

		var onLocaleChange = function(currentLocale) {
			if ($injector.has('tmhDynamicLocale')) {
				var tmhDynamicLocale = $injector.get('tmhDynamicLocale');
				tmhDynamicLocale.set(currentLocale.replace('_', '-').toLowerCase());
			}
			if ($injector.has('uibDatepickerPopupConfig')) {
				var uibDatepickerPopupConfig = $injector.get('uibDatepickerPopupConfig');
				uibDatepickerPopupConfig.closeText = $translate.instant('Close');
				uibDatepickerPopupConfig.currentText = $translate.instant('Today');
				uibDatepickerPopupConfig.clearText = $translate.instant('Clear');
			}
		}
		onLocaleChange(currentLocale);
		$rootScope.$on('$translateChangeSuccess', function(event, current, previous) {
			// Language has changed
			onLocaleChange(current.language);
		});

		// on successful applying translations by angular-translate
		$rootScope.$on('$translateChangeSuccess', function (event, data) {
			document.documentElement.setAttribute('lang', data.language);
		});

		return {
		getLocale: function() {
			return currentLocale;
		},
		getLocaleCurrentOrProposed: function () {
			return $translate.use() || $translate.proposedLanguage();
		},
			getLocaleDisplayName: function () {
				return localesObj[currentLocale];
			},
			setLocaleByDisplayName: function (localeDisplayName) {
				if (setLocale(
					_LOCALES[_LOCALES_DISPLAY_NAMES.indexOf(localeDisplayName)]
				))
					return true;
				else
					return false;
			},
			getLocalesDisplayNames: function () {
				return _LOCALES_DISPLAY_NAMES;
			}
		};
	})

	.controller('LanguageSelect', function (LocaleService, $rootScope) {
		this.currentLocaleDisplayName = LocaleService.getLocaleDisplayName();
	this.currentLocale = LocaleService.getLocale();
		this.localesDisplayNames = LocaleService.getLocalesDisplayNames();
		this.visible = this.localesDisplayNames && this.localesDisplayNames.length > 1;

		$rootScope.currentLocaleDisplayName = LocaleService.getLocaleDisplayName();
	$rootScope.currentLocale = LocaleService.getLocale();
		//console.log(this.currentLocaleDisplayName);

		this.changeLanguage = function (locale) {
			LocaleService.setLocaleByDisplayName(locale);
			this.currentLocaleDisplayName = locale;
		this.currentLocale = LocaleService.getLocale();
			$rootScope.currentLocaleDisplayName = locale;
		$rootScope.currentLocale = LocaleService.getLocale();
		};
	})

	// translate string template, e.g: "{{Person}} > {{Custome r}}"
	.filter('tpltranslate', function ($translate) {
		return function (value) {
			var ret = "";
			if (!value) return ret;
			var parts = value.split(/({{[^}]+}})/)
			if (parts.length == 1 && parts[0][0] != '{') {
				return $translate.instant(parts[0])
			}
			for (var i = 0; i < parts.length; i++) {
				var part = parts[i];
				if (part.match(/^{{(.*)}}$/)) {
					ret += $translate.instant(part.replace(/^{{(.*)}}$/, '$1'))
				} else {
					ret += part;
				}
			}
			return ret;
		}
	})





angular.module('languages')

.directive('ngTranslateLanguageSelect', function () { 

	'use strict';

	return {
		restrict: 'A',
		replace: true,
		template: ''+
		'<div class="btn-group dropup" uib-dropdown>'+
		'	<div uib-dropdown-toggle>'+
		'		{{langCtrl.currentLocaleDisplayName}} <span class="caret"></span>'+
		'	</div>'+
		'	<ul class="dropdown-menu" role="menu" uib-dropdown-menu>'+
		'		<li><a href="#" ng-repeat="localesDisplayName in langCtrl.localesDisplayNames" ng-click="langCtrl.changeLanguage(localesDisplayName)" eat-click>{{localesDisplayName}}</a></li>'+
		'	</ul>'+
		'</div>',
		controller: 'LanguageSelect as langCtrl',
	};
})





angular.module('forms', [
	'ui.select',
	'monospaced.elastic',  // textarea autoresize
	'angularFileUpload',
	'ngFileUpload',  // (backreference) TODO choose one :)

	'forms.fields.binary',
	'forms.fields.currency',
	'forms.fields.date',
	'forms.fields.dictionary',
	'forms.fields.filterreference',
	'forms.fields.gridreference',
	'forms.fields.backreference',
	'forms.fields.interval',
	'forms.fields.password',
	'forms.fields.password_single',
	'forms.fields.reference',
	'forms.fields.composite',
	'forms.fields.text',
	'forms.fields.tags',
	'forms.fields.formbuilder',
	//'forms.fields.datelist',   // requires 'gm.datepickerMultiSelect'
	//'forms.fields.position',   // requires 'uiGmapgoogle-maps'
	//'forms.fields.daterange',  // requires 'daterangepicker'
	//'forms.fields.html.medium',// requiers 'angular-medium-editor'
])

.value('FormsTplDir', 'framework/partials/forms/')
.value('FormsFormGridTplUrl', null)  // evaluates to FormsTplDir + 'form-grid.html'
.value('FormsFormPaneTplUrl', null)  // evaluates to FormsTplDir + 'form-pane.html'
.value('FormsFieldBoxTplUrl', null)  // evaluates to FormsTplDir + 'field-box.html'



/*
var form = {
	'title': method.title,
	'prompt': method.prompt,
	'btn': method.title,
	'templateUrl': method.templateUrl || null,  // used in form-service
	'submit': function(data) { ... }       // returns a promise
	'params': [{
		'title': 'Login',
		'type': 'Field',
		'name': 'login'
		'groups': ['edit'],
		?'required': false,
		?'default': 'name + "12"',
		?'redefault_on': 'never' | 'depends&always' | 'depends&unedited'
		'visible': 'userId == 1',
		'editable': 'true',
		?'dictionary': [['1', 'One'], ['2', 'Two']],
		?'depends': 'first_name',
		...  --  field functions like dict()
	}, ... ],
	'layout': ['edit'],
	'options': { anything },
	'modalOptions': {} // $modal options  - special for activateFormModal
}
*/

function Form(config, values, $rootScope, $q) {

    var self = this;
    this.message = null;
    this.is_busy = false;
    this.is_completed = false;

    this.field_errors = null;
    this.values = values;
	this.fieldStates = {}
	
	self.config = {
		layout: config.layout || ['edit'],
		title: config.title,
		prompt: config.prompt,
		btn: config.btn || 'OK',
		templateUrl: config.templateUrl,
		params: config.params || [],
		submit: config.submit,
		options: config.options,  // addtional options
	}

    this.submit = function(){
		if (this.is_busy) return;
		this.message = null;
		this.is_busy = true;
		var combined_state = this.getFieldCombinedState();
		if (combined_state.busy) {
			self.is_busy = false;
			self.message = {type: 'warning', body: 'Some fields are busy. Wait for the work to finish.'};
			return $q.reject({data:{message:self.message.body}});
		}
		if (combined_state.invalid) {
			self.is_busy = false;
			self.message = {type: 'warning', body: 'Form field values were entered incorrectly'};
			return $q.reject({data:{message:self.message.body}});
		}
		return this.config.submit(this.values).then(function(result){
			// success
			console.log("Form result:", result);
			self.is_busy = false;
            self.is_completed = true;
			if (result && result.__callstatus && result.__callstatus.message) {
				self.message = {type: 'info', body: result.__callstatus.message, parameters: result.__callstatus.message_parameters};
			}
			return result;
		},function(data, status, headers, config){
			// failure
			console.debug('Form error', data.data);
			self.is_busy = false;
			if (typeof data.data == "string") {
				self.field_errors = null;
				self.message = {type: 'danger', body: 'HTTP error: ' + data.statusText}
			} else {
				self.message = {type: 'warning', body: data.data.message};
				self.field_errors = data.data.data;
				if (data.data.code == 401) {
					$rootScope.$broadcast('unauthorized');
				}
			}
			return $q.reject(data);
		});
		
	}; // end submit

	this.reset = function(values) {
		this.message = null;
    	this.is_busy = false;
    	this.is_completed = false;
   		this.field_errors = null;
    	angular.extend(this.values, values);
	}

	this.setFieldState = function(id, field, state, message) {
		console.log(field.title + ' state set to: ' + state, message);
		if (state === null) {
			if (this.fieldStates[id]) {
				delete this.fieldStates[id];
			}
		} else {
			this.fieldStates[id] = {field:field, state:state, message:message}
		}
	}

	this.getFieldCombinedState = function() {
		var state = {busy: false, invalid: false};
		for (var id in this.fieldStates) {
			if (this.fieldStates[id].state != 'valid') {
				state[this.fieldStates[id].state] = true;
			}
		}
		return state;
	}
}

angular.module('forms')

.config(function($uibModalProvider){
	$uibModalProvider.options.size = 'lg';
	
})

.service('FormService', function($injector, $parse, Classes, CurrentUser, $q, $uibModal){

    var self = this;
    
    this.createForm = function(config, values) {
        return $injector.instantiate(Form, {config:config, values:values});
    }

	this.fetchDefaultInstance = function(fields, defaults) {
		var defaults = defaults || {};
		for (var k in fields) {
    		var field = fields[k];
			if (field && typeof field['default'] != "undefined" && typeof defaults[field['name']] == "undefined") {
				var func = $parse(field['default']);  // function(context, locals)
				defaults[field['name']] = func({$moment: moment, $user: CurrentUser.instance}, Classes); 
			}
    	}
    	return $q.all(defaults);
	}

	this.activateFormModal = function(formconfig, defaults) {
		var defaults = defaults || {}
		var modalOptions = formconfig.modalOptions || {}
		modalOptions.controller = 'modalFormCtrl as $ctrl';
		modalOptions.templateUrl = formconfig.templateUrl || 'framework/partials/admin/form-modal.html';
		modalOptions.resolve = {
			formconfig: function(){return formconfig},
			values: function(){
				// setup field values so all params are present even if empty 
				// evaluates default parameters (supports promises)
				return self.fetchDefaultInstance(formconfig.params, defaults)
			},
		}
		var dlg = $uibModal.open(modalOptions);
		return dlg.result;
	}

	


})



.service('FormNewInstanceFactory', function($injector, $parse, CurrentUser, Classes){
	this.ContextService = null;
	if ($injector.has('ContextService')) {
		this.ContextService = $injector.get('ContextService');
	}

	this.fetchNewInstance = function(classname, defaults) {
		if (this.ContextService) {
			return this.newInstanceFromContext(classname, defaults)
		} else {
			return this.newInstanceFromClass(classname, defaults)
		}
	}

	// this function is called when admin is not loaded
	this.newInstanceFromClass = function(classname, defaults) {
		defaults = defaults || {}
		var klass = Classes[classname]
		if (!klass) {
			throw "FormNewInstanceFactory: No class defined for: " + classname
		}
		return this.fetchClassDefaults().then(function(class_defaults){
			var data = angular.extend({}, class_defaults, defaults);
			var object = klass.create(data)
			return object;
		})
	}

	// this function is called when admin is active and configured
	// some additional default values might be available depending on context
	this.newInstanceFromContext = function(classname, defaults) {
		var module = this.ContextService.getContext(classname);
		return module.fetchNewInstance(defaults)
	}

	this.fetchClassDefaults = function(klass) {
		var defaults = {};
		var fields = klass.get_form_params();    // was: cls.fields
		for (var k in fields) {
    		var field = fields[k];
			if (field && typeof field['default'] != "undefined") {
				var func = $parse(field['default']);  // function(context, locals)
				defaults[field['name']] = func({$moment: moment, $user: CurrentUser.instance}, Classes); 
			}
    	}
    	return $q.all(defaults);
	}
})



.controller('modalFormCtrl',function($scope, $uibModalInstance, $q, $translate, dialogs, FormService, formconfig, values){
	//-- Variables --//

	var self = this;
	this.form = FormService.createForm(formconfig, values);

	window.modalFormCtrl = this;
	window.$modalFormScope = $scope;
	
	//-- Methods --//
	
	this.cancel = function(){
		$uibModalInstance.dismiss(null);
	}; // end cancel
	
	this.submit = function(){
		if (this.form.is_busy) return;
		this.form.submit().then(function(result){
			// success
			$uibModalInstance.close(result);
			if (result && result.__callstatus && result.__callstatus.message) {
				dialogs.notify($translate.instant(self.form.title), $translate.instant(result.__callstatus.message, result.__callstatus.message_parameters));
			}
		});
	}; // end submit
	
	$scope.$on('submitonenter', function(){
		self.submit();
	});

	
})





angular.module('forms')
.component('formGrid', {
	templateUrl: function(FormsTplDir, FormsFormGridTplUrl) {return FormsFormGridTplUrl || FormsTplDir+'form-grid.html'},
	bindings: {
		object: '=*formObject',
		errors: '<formErrors',
		fields: '<formFields',
		layout: '<formLayout',			    // optional
		compact: '<formCompact',			// optional
		labelClass: '@?formLabelClass',		// optional
		editorClass: '@?formEditorClass',	// optional
		boxClass: '@?formBoxClass',	// optional
		horizontal: '<?gridHorizontal',
		fieldStateNotify: '&?',
	},
	controller: function($scope) {
		var self = this;
		this.items = [];

		this.processLayout = function(layout, isHorizontal, labelClass, editorClass, boxClass, compact, col12) {
			var gridLayout;
			if (typeof layout == 'string') {
				gridLayout = {
					groups: layout,  // string is pane
					col12: col12,
					isHorizontal: isHorizontal,
					type: 'pane',
					editorClass: editorClass,
					labelClass: labelClass,
					boxClass: boxClass,
					compact: compact
				}
			} else if (typeof layout == "object" && typeof layout.length == "number") {
				gridLayout = {
					items: layout.map(function(item) {
						var new_col12 = layout.length? Math.max(1, 0 | (12.0 / layout.length)) : 0;
						return self.processLayout(item, !isHorizontal, labelClass, editorClass, boxClass, compact, new_col12);
					}),  // array is grid
					col12: col12,
					isHorizontal: isHorizontal,
					type: 'grid',
					editorClass: editorClass,
					labelClass: labelClass,
					boxClass: boxClass,
					compact: compact
				}
			} else if (typeof layout == "object" && layout) {
				gridLayout = angular.extend({
					type: layout.groups? 'pane' : 'grid',
					col12: col12,
					isHorizontal: isHorizontal,
					editorClass: editorClass,
					labelClass: labelClass,
					boxClass: boxClass,
					compact: compact
				}, layout);
				if (gridLayout.type == 'grid') {
					gridLayout.items = layout.items.map(function(item) {
						var new_col12 = layout.items.length? Math.max(1, 0 | (12.0 / layout.items.length)) : 0;
						return self.processLayout(item, !gridLayout.isHorizontal, gridLayout.labelClass, gridLayout.editorClass, gridLayout.boxClass, gridLayout.compact, new_col12);
					});
				}
			}
			return gridLayout;
		}

		$scope.$watch(function(){return self.layout}, function(){
			//self.gridLayout.items.length = 0;
			var new_col12 = self.layout.length? Math.max(1, 0 | (12.0 / self.layout.length)) : 0;
			self.gridLayout = self.processLayout(self.layout, self.horizontal, self.labelClass, self.editorClass, self.boxClass, self.compact, new_col12);
		}, true);
		
	},
	controllerAs: '$grid',
})

.component('formPane', {
	templateUrl: function(FormsTplDir, FormsFormPaneTplUrl) {return FormsFormPaneTplUrl || FormsTplDir+'form-pane.html'},
	bindings: {
		object: '=*formObject',
		errors: '<formErrors',
		fields: '<formFields',
		groups: '<formFieldGroups',			// optional
		compact: '<formCompact',			// optional
		labelClass: '@?formLabelClass',		// optional
		editorClass: '@?formEditorClass',	// optional
		boxClass: '@?formBoxClass',	// optional
		fieldStateNotify: '&?',
	},
	controller: function($parse) {
		this.errors = this.errors || {}
	
		this.inGroup = function(groups) {
			if (!this.groups) {
				return true;
			}
			if (typeof groups == "string") groups = [groups];
			var ourgroups = typeof this.groups == "string"? [this.groups] : this.groups;
			return !!_.intersection(ourgroups, groups).length
		}
		
		this.isFieldVisible = function(field) {
			var visible_test = $parse(field.visible);
			var visible = visible_test(this.object);
			var in_group = this.inGroup(field.groups)
			return visible && in_group;
		}
		
		this.isFieldEditable = function(field) {
			var editable_test = $parse(field.editable);
			is_field_editable = editable_test(this.object);
			return is_field_editable;
		}
	},
})

.component('fieldBox', {
	templateUrl: function(FormsTplDir, FormsFieldBoxTplUrl) { return FormsFieldBoxTplUrl || FormsTplDir+'field-box.html' },
	bindings: {
		compact: '<fieldCompact',   // =* shallow watch	
		object: '=*fieldObject',     // < one-way binding, * shallow watch
		errors: '<fieldErrors',
		field: '<field',
		labelClass: '@?fieldLabelClass',
		editorClass: '@?fieldEditorClass',
		boxClass: '@?fieldBoxClass',
		fieldStateNotify: '&?',  // vars: field=$box.field, state='valid'|'invalid'|'busy'|null,  message='The data is being uploaded',  id: $scope.$id
	},
	controller: function($parse, $scope, FormService) {
		var self = this;
		var required_test = typeof this.field.required=="string"? $parse(this.field.required) : function(){return self.field.required};
		this.isFieldRequired = function(field) {
			is_field_required = required_test(this.object);
			return is_field_required;
		}
		this.setFieldState = function(state, message) {
			if (self.fieldStateNotify) {
				self.fieldStateNotify({field:self.field, state:state, message:message, id:$scope.$id});
			}
		}
		this.$onDestroy = function() {
			self.setFieldState(null, null);
		}
		this.setFieldState('valid', null);

		this.activateFieldForm = function(form, formdata) {
			var formdata = angular.copy(self.object)
			return FormService.activateFormModal(form, formdata).then(function(result){
				angular.extend(self.object, result);
			});
		}
	},
	controllerAs: '$box',
})


.component('fieldWidget', {
	template: function(FormsTplDir) {
		return	'<span ng-if="$widget.isFieldVisible() && $widget.isFieldEditable()" ng-include="$widget.field.client.edit_template_url||\''+FormsTplDir+'field-widget-\'+($widget.field.client.widget.toLowerCase()||$widget.field.type.toLowerCase())+\'.html\'"></span>' +
				'<span ng-if="$widget.isFieldVisible() && !$widget.isFieldEditable()" ng-include="$widget.field.client.view_template_url||\''+FormsTplDir+'field-view-\'+($widget.field.client.widget.toLowerCase()||$widget.field.type.toLowerCase())+\'.html\'"></span>' + 
				'<span ng-if="!$widget.isFieldVisible()"><i class="fa fa-eye-slash"></i></span>'
	},
	bindings: {
		compact: '<fieldCompact',   // =* shallow watch	
		object: '=fieldObject',     // < one-way binding, * shallow watch
		errors: '<?fieldErrors',	// optional
		field: '<field',
		visible: '<?fieldVisible',
		editable: '<?fieldEditable',
	},
	//priority: 1,
	controller: function($parse, FormsTplDir, $scope, $q, Classes, CurrentUser) {
		var self = this;
		this.visible = (typeof this.visible === "undefined") ? this.field.visible : this.visible;
		this.editable = (typeof this.editable === "undefined") ? this.field.editable : this.editable;
		var visible_test = typeof this.visible == "string"? $parse(this.visible) : function(){return self.visible};
		var editable_test = typeof this.editable == "string"? $parse(this.editable) : function(){return self.editable};
		
		this.isFieldVisible = function() {
			var visible = visible_test(this.object);
			return visible;
		}
		
		this.isFieldEditable = function() {
			is_field_editable = editable_test(this.object);
			return is_field_editable;
		}

		this.testSubmitOnEnter = function(evt){
			if (this.field.client && this.field.client.submitOnEnter) {
				if(evt.key == "Enter" || angular.equals(evt.which||evt.keyCode,13)) {
					$scope.$emit('submitonenter');
				}
			}
		};

		// recalculate default if necessary
		if (this.field.redefault_on && this.field.redefault_on != 'never') {
			var default_func = $parse(this.field.default);
			var depends_func = $parse(this.field.depends);
			var last_value = self.object[self.field.name];
			var orig_value = last_value;
			$scope.$watch(function(){return depends_func(self.object)}, function(){
				var context = angular.extend({$moment: moment, $user: CurrentUser.instance}, self.object)
				if (self.field.redefault_on == 'depends&always' 
					|| (self.field.redefault_on == 'depends&unedited' && last_value == self.object[self.field.name] && (orig_value == null || orig_value == ""))
				) {
					$q.resolve(default_func(context, Classes)).then(function(value){
						self.object[self.field.name] = value;
						last_value = self.object[self.field.name];
					}).catch(function(e){
						self.errors[self.field.name] = e.data.message || 'Recalculation error';
					})
				}
			}, true)
		}
		
		this.formsTplDir = FormsTplDir
	},
	controllerAs: '$widget',
})




angular.module('forms')

.directive('serverValidation', function() {
	return {
	    restrict: 'A',
	    require: 'ngModel',
	    link: function(scope, element, attrs, ctrl) {
	    	/*ctrl.$validators.server = function(modelValue, viewValue) {
	    		console.log('Validity', attrs.serverError, scope.$eval(attrs.serverError));
		        return scope.$eval(attrs.serverError);
		    };*/
		    
		    scope.$watch(attrs.serverValidation, function(message) {
		    	var valid = !message;
		    	console.log('Validity', attrs.serverValidation, message);
		    	ctrl.$setValidity('server', valid);
		    });
		    
		    // TODO - instant server-side validation with $asyncValidators
		    // https://docs.angularjs.org/guide/forms
	    }
	}
});



var productGrid = function() {
return {

	bindToController: {
		items: '<productGrid'
	},
	controller: function($scope) {
		
		//this.items = $scope.refCtrl.items;
		this.opensNewGroup = function(index) {
			if (index == 0) return true;
			return this.items[index-1].sg_product.sg_product_group != this.items[index].sg_product.sg_product_group;
		}
		this.rowSpan = function(index) {
			var group = this.items[index].sg_product.sg_product_group;
			var count = 0;
			var i;
			for (i=index-1; i>0 && this.items[i].sg_product.sg_product_group == group; i--) count++;
			for (i=index; i<this.items.length && this.items[i].sg_product.sg_product_group == group; i++) count++;
			return count;
		}
	},
	controllerAs: '$grid',
}}

angular.module('forms')
.directive('productGrid', productGrid)


.filter('addGroup', function($parse) {
  return function( items, group_expression) {
    var filtered = [];
	var group_func = $parse(group_expression)
	var lastGroup = undefined;
	var lastGroupCount = 0;
	var lastGroupItems = [];
	var updateCount = function() {
		for (var i=0; i<lastGroupItems.length; i++) {
			lastGroupItems[i].count = lastGroupCount;
		}
	}
    angular.forEach(items, function(item) {
	  var group = group_func(item);
	  if (lastGroup != group) {
		  updateCount();
		  lastGroup = group;
		  lastGroupCount = 0;
		  lastGroupItems = [];
	  }
	  item.$group = {
		  index: lastGroupCount,
		  count: null,
	  }
	  lastGroupCount += 1;
	  lastGroupItems.push(item.$group)
      filtered.push(item);
    });
	updateCount();
    return filtered;
  };
});

function DateListController($scope, ModuleService) {

	var self = this;
	this.opened = false;
	this.selectedDates = [];
	this.currentDate = null;
	this.dateOptions = {
		closeOnDateSelection: false
	}
	
	/* from backreference */
	if (!$scope.object[$scope.field.name]) {
		$scope.object[$scope.field.name] = [];
	}
	self.items = $scope.object[$scope.field.name];
	//self.selectedDates = _.pluck(self.items, 'start_date');
	$scope.$watch('object[field.name]', function(items) {
		self.items = items;
		self.selectedDates = _.map(_.pluck(self.items, 'start_date'), function(date){return parseInt(moment(date).format('x'))});
		if (self.selectedDates.length > 0 && this.currentDate == null) {
			self.currentDate = moment(self.selectedDates[self.selectedDates.length - 1]).toDate()
		}
	});
	
	this.fetch_new = function(data) {
		var classname = $scope.field.join.foreignClass;
		var module = ModuleService.getModule(classname);
		module.addContext($scope.field.join.backref, $scope.object);
		return module.fetchNewObject().then(function(obj){
			if (typeof data == "object") obj.fill(data);
			return obj;
		});
	}
	
	this.remove = function(obj) {
		for (var i in self.items) {
			if (self.items[i] === obj) {
				self.items.splice(i, 1);
				break;
			}
		}
	}
	/* end from */

	this.open = function($event) {
		$event.preventDefault();
		$event.stopPropagation();
		console.log('open dates');
		self.opened = true;
	}
	
	$scope.$watchCollection(function(){return self.selectedDates;}, function(newdates, olddates) {
		var to_remove = [];
		// append new
		_.each(_.difference(newdates, olddates), function(datenum) {
			if (!datenum) return;
			var date = moment(datenum).format('YYYY-MM-DD')
			self.fetch_new({start_date: date}).then(function(obj){
				var i=0;
				for (i in self.items) {
					if (self.items[i].start_date > date) {
						self.items.splice(i, 0, obj);
						return;
					}
				}
				self.items.push(obj);
			});
		});
		// remove old
		_.each(_.difference(olddates, newdates), function(datenum) {
			if (!datenum) return;
			var date = moment(datenum).format('YYYY-MM-DD')
			var i=0;
			for (i in self.items) {
				if (self.items[i].start_date == date) self.items.splice(i, 1);
			}
		});
	});
	
	this.today = function(){
		self.currentDate = (new Date()).setHours(0, 0, 0, 0);
	}
	
	this.clear = function() {
		self.selectedDates = [];
	}

	window.dlCtrl = this;
}


angular.module('forms.fields.datelist', ['gm.datepickerMultiSelect'])
.controller('DateListController', DateListController)


function DateField() {
	return {
		bindToController: {
			field: '<',
			object: '=fieldObject',
		},
		controller: function($parse) {
			var self = this;
			
			this.opened = false;
			this.dateOptions = {
				//closeOnDateSelection: true,
				//locale:{firstDay:1}
				startingDay: 1
			}
			
			this.open = function($event) {
				$event.preventDefault();
				$event.stopPropagation();
				this.opened = true;
			};
			
			this.isDisabledFunc = null;
			
			this.isDisabled = function(date, mode) {
				if (self.field.client && self.field.client.isDisabled) {
					if (!this.isDisabledFunc) {
						this.isDisabledFunc = $parse(self.field.client.isDisabled);
					}
					return this.isDisabledFunc(self.object, {date:date, mode:mode, moment:window.moment})
				}
				return false;
			}
			
			this.minDate = function() {
				if (self.field.client && self.field.client.minDate) {
					var func = $parse(self.field.client.minDate);
					return func(self.object, {moment:window.moment});
				}
				return null;
			}
			
			this.maxDate = function() {
				if (self.field.client && self.field.client.maxDate) {
					var func = $parse(self.field.client.maxDate);
					return func(self.object, {moment:window.moment});
				}
				return null;
			}

		},
		controllerAs: '$date'
	}
}


function DateController($scope, $parse) {

	var self = this;
	this.opened = false;
	this.dateOptions = {
		//closeOnDateSelection: true,
		//locale:{firstDay:1}
		startingDay: 1
	}
	
	this.open = function($event) {
      $event.preventDefault();
      $event.stopPropagation();

      this.opened = true;
    };
	
	this.isDisabledFunc = null;
	
	this.isDisabled = function(date, mode, field) {
		if (field.client && field.client.isDisabled) {
			if (!this.isDisabledFunc) {
				this.isDisabledFunc = $parse(field.client.isDisabled);
			}
			return this.isDisabledFunc($scope.object, {date:date, mode:mode, moment:window.moment})
		}
		return false;
	}
	
	this.minDate = function(field) {
		if (field.client && field.client.minDate) {
			var func = $parse(field.client.minDate);
			return func($scope.object, {moment:window.moment});
		}
		return null;
	}
	
	this.maxDate = function(field) {
		if (field.client && field.client.maxDate) {
			var func = $parse(field.client.maxDate);
			return func($scope.object, {moment:window.moment});
		}
		return null;
	}

	window.dCtrl = this;
}


function datepickerTextModel() {
	return {
		require: 'ngModel',
		link: function (scope, elem, attrs, ngModel) {
			var format = attrs.datepickerTextModel || "YYYY-MM-DD";

			ngModel.$formatters.push(function(value){
				if (!value) return null;
				var m = moment(value, format);
				return m.isValid()? m.toDate() : null;
			});
			
			ngModel.$parsers.push(function(value){
				if (value) {
					return moment(value).format(format);
				} else {
					return null;
				}
			});
		}
		
	}
}

function datetimepickerTextModel() {
	return {
		require: 'ngModel',
		link: function (scope, elem, attrs, ngModel) {
			ngModel.$formatters.push(function(value){
				if (!value) return null;
				var m = moment(value);
				return m.isValid()? m.toDate() : null;
			});
			
			ngModel.$parsers.push(function(value){
				if (value) {
					return moment(value).format("YYYY-MM-DD HH:mm:ss");
				} else {
					return null;
				}
			});
		}
		
	}
}

angular.module('forms.fields.date', [])
.controller('DateController', DateController)
.directive('datepickerTextModel', datepickerTextModel)
.directive('datetimepickerTextModel', datetimepickerTextModel)
.directive('dateField', DateField)



function PositionMap() {
	return {
		bindToController: {
			field: '<',
			object: '=fieldObject',
		},
		controller: function($parse, $scope, FormService, $q) {
			var self = this;
			this.geocodeAddress = '';

			this.map = {
				show: true,
				control: {},
				position: {},
				zoom: 6,
				events: {
					click: function(map, type, args){
						$scope.$apply(function(){
							console.log('map click', args);
							self.object[self.field.name] = self.object[self.field.name] || {}
							self.object[self.field.name].latitude = args[0].latLng.lat();
							self.object[self.field.name].longitude = args[0].latLng.lng();
						})
					}
				},
				marker: {
					position: {},
					events: {
						dragend: function(map, type, args){
							$scope.$apply(function(){
								console.log('drag end', args);
								self.object[self.field.name].latitude = args.getGMarker().position.lat();
								self.object[self.field.name].longitude = args.getGMarker().position.lng();
							})
						}
					}
				}
			}
			
			self.map.position = {latitude:52,longitude:19};
			
			$scope.$watch(function(){return self.object[self.field.name];}, function(location) {
				if (location && location.latitude && location.longitude) {
					if (self.map.position.latitude == 52) {
						if (self.map.control.refresh) self.map.control.refresh();
						self.map.position = angular.copy(self.object[self.field.name]);
						self.map.zoom = 8;
					}
					self.map.marker.position = self.object[self.field.name];
				}
			}, true);

			if (self.field.client && self.field.client.default_address) {
				var func = $parse(self.field.client.default_address);
				$scope.$watch(function(){return func(self.object);}, function(addr){
					self.geocodeAddress = addr;
				})
			}
			
			
			self.refresh = function(){
				if (self.map.control.refresh) {
					self.map.control.refresh();
					self.map.control.getGMap().setCenter({lat: self.map.position.latitude, lng: self.map.position.longitude});
				}
			}
			
			/*$scope.$watch('geocodeAddress', function(address){
				$scope.geocode(address);
			});*/
			self.geocode = function(address) {
				console.log('Geocoding', address);
				var geocoder = new google.maps.Geocoder;
				geocoder.geocode({address: address}, function(results, status) {
					if (status == 'OK') {
						console.log('Found', results);
					var latlng = results[0].geometry.location;
					self.map.control.getGMap().setCenter(latlng);
					self.map.control.getGMap().setZoom(15);
					$scope.$apply(function(){
						//self.map.zoom = 15;
						self.object[self.field.name] = self.object[self.field.name] || {}
						self.object[self.field.name].latitude = latlng.lat();
						self.object[self.field.name].longitude = latlng.lng();
					})
					
					}
				});
			}
			
			$scope.$on('editTabOn', function(){
				self.map.show = true;
				setTimeout($scope.refresh, 10);
			});
			
			window.$mapscope = $scope;

		},
		controllerAs: '$map'
	}
}


PositonMapController = function($scope, $parse) {
	
	$scope.geocodeAddress = '';

	$scope.map = {
		show: true,
		control: {},
		position: {},
		zoom: 6,
		events: {
			click: function(map, type, args){
				$scope.$apply(function(){
					console.log('map click', args);
					$scope.object.location = $scope.object.location || {}
					$scope.object.location.latitude = args[0].latLng.lat();
					$scope.object.location.longitude = args[0].latLng.lng();
				})
			}
		},
		marker: {
			position: {},
			events: {
				dragend: function(map, type, args){
					$scope.$apply(function(){
						console.log('drag end', args);
						$scope.object.location.latitude = args.gMarker.position.lat();
						$scope.object.location.longitude = args.gMarker.position.lng();
					})
				}
			}
		}
	}
	
	$scope.map.position = {latitude:52,longitude:19};
	//$scope.map.marker = {latitude:43,longitude:11};
	
	$scope.$watch('object.location', function(location) {
		if (location && location.latitude && location.longitude) {
			if ($scope.map.position.latitude == 52) {
				if ($scope.map.control.refresh) $scope.map.control.refresh();
				$scope.map.position = angular.copy($scope.object.location);
				$scope.map.zoom = 8;
			}
			$scope.map.marker.position = $scope.object.location;
			
		}
	}, true);

	if ($scope.field.client && $scope.field.client.default_address) {
		var func = $parse($scope.field.client.default_address);
		$scope.$watch(function(){return func($scope.object);}, function(addr){
			$scope.geocodeAddress = addr;
		})
	}
	 
	
	$scope.refresh = function(){
		if ($scope.map.control.refresh) {
        	$scope.map.control.refresh();
        	$scope.map.control.getGMap().setCenter({lat: $scope.map.position.latitude, lng: $scope.map.position.longitude});
        }
	}
	
	/*$scope.$watch('geocodeAddress', function(address){
		$scope.geocode(address);
	});*/
	$scope.geocode = function(address) {
		console.log('Geocoding', address);
		var geocoder = new google.maps.Geocoder;
		geocoder.geocode({address: address}, function(results, status) {
		    if (status == 'OK') {
		    	console.log('Found', results);
		      var latlng = results[0].geometry.location;
		      $scope.map.control.getGMap().setCenter(latlng);
		      $scope.map.control.getGMap().setZoom(15);
			  $scope.$apply(function(){
				//$scope.map.zoom = 15;
				$scope.object.location = $scope.object.location || {}
				$scope.object.location.latitude = latlng.lat();
				$scope.object.location.longitude = latlng.lng();
			  })
		      
		    }
		});
	}
	
	$scope.$on('editTabOn', function(){
		$scope.map.show = true;
		setTimeout($scope.refresh, 10);
	});
	
	window.$mapscope = $scope;
	
}


angular.module('forms.fields.position', ['uiGmapgoogle-maps'])
.controller('PositonMapController', PositonMapController)
.directive('positionMap', PositionMap);


var ReferenceFieldCtrl = function($scope, $parse, $uibModal, $injector) {

	var self = this;
	this.createMode = !$scope.object.__vid;
	
	this.dictInitialized = false;
	this.filter_depends = function(object) {
		var klass = object.getClass();
		return klass.getObjectPayload(object, 'essential');
	}
	
	this.make_title = function(object) {
		var field = $scope.field;
		if (field.client && field.client.title) {
			var title_expr = field.client.title;
			var title = $parse(field.client.title);
			return title(object, window);
		} else {
			return object? object.__title : null;
		}
	}

	this.items = [];
	this.groups = [];

	this.update_dict = function() {
		return $scope.object.getClass()[$scope.field.name + '__dict']({
			//filter:Module.getFilterForContextField(fieldname)($scope.field.name),
			filter:{},
			data: self.filter_depends($scope.object)
		}).then(function(dict){
			var empty = {__title:'-- wybierz --', __vid:null};
			self.items = [];  // [empty]
			[].push.apply(self.items, dict);
			// kasuj niesutniejace (tylko bez effective_time)
			var found = false;
			if ($scope.object[$scope.field.name] && $scope.object[$scope.field.name].__vid && $scope.object[$scope.field.name].__vid.search(':') == -1) {
				for (var i=0; i<self.items.length; i++) {
					if ($scope.object[$scope.field.name].__id == self.items[i].__id) found = true;
				}
				if (!found) {
					$scope.object[$scope.field.name] = null;  //empty;
				}
			}
			
			// groupping
			if ($scope.field.parent_object) {
				self.groups = [];
				self.selected_group = $scope.$eval($scope.field.parent_object, $scope.object[$scope.field.name]);
				console.log('selected group', $scope.selected_group, $scope.object);
				self.orig_dict = [];
				self.orig_dict.push.apply(self.orig_dict, self.items);
				var seen_vids = [];
				for (var i=0; i<self.items.length; i++) {
					var parent = $scope.$eval($scope.field.parent_object, self.items[i]);
					if (!parent || !parent.__vid) continue;
					if (seen_vids.indexOf(parent.__vid) == -1) {
						self.groups.push(parent);
						seen_vids.push(parent.__vid);
					}
				}
				if (self.selected_group && seen_vids.indexOf(self.selected_group.__vid) == -1) self.selected_group = null;
			}
			
			self.dictInitialized = true;
		});
	}
	
	this.set_default = function() {
		// ustaw default
		if ($scope.object && $scope.object[$scope.field.name] && typeof $scope.object[$scope.field.name].__title != "undefined") return;
		if (self.items.length == 1) {
			$scope.object[$scope.field.name] = self.items[0];
		}
	}
	
	if ($scope.field.depends) {
		var depends = $parse($scope.field.depends);
		var getDepends = function() {
			var ret = depends($scope.object);
			if (!ret) return [null];
			return ret.__class? [ret.__id] : (ret.length? ret : [ret]);
		}
		$scope.$watchCollection(getDepends, function(x){
			if ((!$scope.object || !$scope.object.id) && !self.createMode) return;
			if (self.dictInitialized) self.update_dict().then(self.set_default);
		});
	}
	
	$scope.$watch('object.effective_time', function(ef_time){
		console.log('reference-filter-reload', self.createMode);
		if ((!$scope.object || !$scope.object.id) && !self.createMode) return;
		if (self.dictInitialized) {
			self.update_dict().then(function(){
				if (self.createMode) self.set_default();
			});
		}
	}, true);

	if ($scope.field.parent_object) {
		$scope.$watch(function(){return self.selected_group}, function(selected){
			console.log('Changed combo group', selected);
			if (!selected) {
				self.items = angular.copy(self.orig_dict);
			} else {
				self.items.length = 0;
				var found = false;
				for (var i=0; i<self.orig_dict.length; i++) {
					var parent = $scope.$eval($scope.field.parent_object, self.orig_dict[i]);
					if (parent && parent.__vid == selected.__vid) {
						self.items.push(self.orig_dict[i]);
						if ($scope.object[$scope.field.name] && $scope.object[$scope.field.name].__vid == self.orig_dict[i].__vid) found = true;
					}
				}
				if (!found) $scope.object[$scope.field.name] = null;  //empty;
			}
		});
	}
	
	this.update_dict();


	// Creating new objects

	this.append_new = function(data) {
		if ($scope.field.client && $scope.field.client.type == 'image') {
			data['download'] = [{href: data.data, thumb: data.data}]
			$scope.object[$scope.field.name] = data;
			this.items.push(data);
		}
	}

	this.imageSelectDialog = function() {
		var classname = $scope.field.join.foreignClass;
		if ($injector.has('ContextService')) {
			var module = $injector.get('ContextService').getContext(classname);
		} else {
			var module = null;
		}
		var dlg = $uibModal.open({
		      animation: true,
		      templateUrl: 'partials/fields/field-edit-reference-images.html',
		      controller: 'SubmitCancelDialogCtrl as dCtrl',
		      size: 'lg',
		      resolve: {
		        params: function ($q) {
		          return $q.all({
		          	data: {
						items: self.items, 
						selected: $scope.object[$scope.field.name],
						moduleName: module.getName(), 
						imageMode: ($scope.field.client && $scope.field.client.imagemode)? $scope.field.client.imagemode : 'cover',  // contain
					},
		          	submit:function(data) {
						$scope.object[$scope.field.name] = data.selected;
						return $q.resolve(data.selected);
					},
		          });
		        }
		      }
		});
	}

	window.rCtrl = this;

}



angular.module('forms.fields.reference', [])
.controller('ReferenceFieldCtrl', ReferenceFieldCtrl);
function FilterReferenceFieldController($scope, $parse) {
	var self = this;
	this.items = null;
	this.dictInitialized = false;
	this.update_dict = function() {
		if (!self.items) {
			return $scope.cls[$scope.field.name + '__dict']({
				filter:{},
				data: {}
			}).then(function(dict){
				self.items = dict
				self.dictInitialized = true;
			});
		} else {
			return self.items;
		}
	}
	this.update_dict();
	
	this.make_title = function(object) {
		var field = $scope.field;
		if (field.client && field.client.title) {
			var title_expr = field.client.title;
			var title = $parse(field.client.title);
			return title(object, window);
		} else {
			return object? object.__title : null;
		}
	}
	
	this.titleForKey = function(dict, key) {
		for (var i in dict) {
			if (dict[i].__id == key) return this.make_title(dict[i]);
		}
		return null;
	}
	
	this.allTitles = function(dict, values) {
		var titles = [];
		for (var i in values) {
			var key = values[i];
			titles.push(self.titleForKey(dict, key));
		}
		return titles.join(', ');
	}
	
	this.toggleOption = function(values, option) {
		if (!values) return;
		var pos = values.indexOf(option);
		if (pos >= 0) {
			values.splice(pos,1);
		} else {
			values.push(option);
		}
		
		return values;
	}
	
	this.hasOption = function(values, option) {
		if (!values) return false;
		return (values||[]).indexOf(option) >= 0;
	}
	
	window['fr_' + $scope.field.name] = this;
}

angular.module('forms.fields.filterreference', [])
.controller('FilterReferenceFieldController', FilterReferenceFieldController);


function GridReference() {
	return {
		bindToController: {
			field: '<',
			object: '=fieldObject',
			errors: '<fieldErrors',
		},
		controller: function($parse, $scope, FormService, $q, Classes) {
			var self = this;
			
			this.setupObjects = function(objects) {
				this.items = [];
				this.loaded_objects = objects;
				var newitems = [];
				var target_identity = (self.field.client && self.field.client.identity)? self.field.client.identity : '__vid';
				for (var i=0; i<objects.length; i++) {
					(function(target){
						var current_object = null;
						var object_index = null;
						if (self.object[self.field.name] && self.object[self.field.name].length) {
							for (var i=0; i<self.object[self.field.name].length; i++) {
								var item = self.object[self.field.name][i];
								if (item[self.field.join.aheadref] == target
									|| target_identity && item[self.field.join.aheadref] && item[self.field.join.aheadref][target_identity] == target[target_identity]) {
									current_object = item;
									object_index = i;
								}
							}
						}
						var item = {
							value: current_object,
							title: self.getObjectTitle(target),
							selected: current_object != null || (self.field.client && self.field.client.autoselect_all),
							object: target,
							error_index: null,
							clear: function() {
								return FormService.fetchDefaultInstance(self.field.fields).then(function(instance){
									instance.__title = target.__title;
									if (self.field.join.foreignClass) {
										instance = Classes[self.field.join.foreignClass].create(instance)
									}
									Object.defineProperty(instance, self.field.join.aheadref, {
										enumerable: false,
										configurable: true,
										writable: false,
										value: (target.__class && Classes[target.__class])? Classes[target.__class].getObjectPayload(target) : target
									});
									item.value = instance;
									return instance;
								})
							}
						}
						if (!self.errorInitialized) {
							item.error_index = object_index;
						}
						if (!current_object) {
							newitems.push(item.clear())
						}
						self.items.push(item)
					})(objects[i])
				}
				$q.all(newitems).then(function(){
					self.dictInitialized = true;
					self.errorInitialized = true;
				})
			}

			/* begin same as dictionary */

			this.getObjectTitle = function(object) {
				if (this.field.client && this.field.client.title) {
					var title_expr = this.field.client.title;
					var title = $parse(title_expr);
					return title(object, window);
				} else {
					return object? object.__title : null;
				}
			}

			this.items = [];
			this.loaded_objects = [];
			this.errorInitialized = false;
			this.dictInitialized = false;
			this.dictRequestEssentialDataJson = null;  // aby sprawdzać, czy trzeba robić reload dict
			this.reloadDict = false;
			this.isDictLoading = false;
			
			this.getEssentialData = function() {
				if (this.object.__class && Classes[this.object.__class]) {
					var klass = Classes[this.object.__class];
					if (klass) {
						return klass.getObjectPayload(this.object, 'essential');
					}
				}
				return this.object;
			}
			/* end same as dictionary */

			this.updateDict = function() {
				self.dictRequestEssentialDataJson = angular.toJson(self.getEssentialData())
				self.isDictLoading = true;
				return this.field.dict({
					filter:{},
					data: self.getEssentialData()
				}).then(function(items){
					if (self.reloadDict) {
						// nastapiła zmiana depends w czasie trwania request
						console.debug('Reloading dict', self.field.name)
						self.reloadDict = false;
						return self.updateDict();
					}
					self.setupObjects(items);
					self.isDictLoading = false;
				});
			}

			// update selection
			self.object[self.field.name] = self.object[self.field.name] || [];
			$scope.$watch(function(){return _.map(self.items, function(o){return {title:o.title,s:o.selected,o:o.value}})}, function(dict, old) {
				if (dict == old) return;
				if (!self.dictInitialized) return;
				self.object[self.field.name].length = 0;
				for (var i in self.items) {
					var r = self.items[i];
					if (r && r.selected) {
						var value = angular.copy(r.value)
						value[self.field.join.aheadref] = r.value[self.field.join.aheadref]
						self.object[self.field.name].push(value);
					}
				}
			}, true);
			

			// init
			if (this.field.depends) {
				var depends = $parse(this.field.depends);
				var getDepends = function() {
					var ret = depends(self.object);
					if (!ret) return [null];
					return ret.__class? [ret.__id] : (ret.length? ret : [ret]);
				}
				$scope.$watchCollection(getDepends, function(x){
					if (self.dictInitialized) self.updateDict();
					if (self.isDictLoading && self.dictRequestEssentialDataJson != angular.toJson(self.getEssentialData())) {
						self.reloadDict = true;
					} else if (!self.isDictLoading) {
						self.updateDict().then(self.setDefault);
					}
				});
				self.updateDict();
			} else {
				self.updateDict();
			}
			$scope.$watchCollection(function(){return self.object[self.field.name]}, function(values, old){
				if (values == old) return;
				if (!self.dictInitialized) return;
				var target_identity = (self.field.client && self.field.client.identity)? self.field.client.identity : '__vid';
				if (target_identity) {
					values = values.map(function(v){return v[self.field.join.aheadref][target_identity]});
				}
				for (var i in self.items) {
					var r = self.items[i];
					var target = target_identity? r.value[self.field.join.aheadref][target_identity] : r.value;
					r.selected = (values.indexOf(target) >= 0);
				}
			});
			$scope.$watchCollection(function(){return self.errors}, function(errors, old){
				if (errors == old) return;
				if (!self.dictInitialized) return;
				self.errorInitialized = false;
				self.setupObjects(self.loaded_objects);
			});


			// utility
			this.isFieldVisible = function(field, object) {
				var visible_test = $parse(field.visible);
				var visible = visible_test(object);
				return visible;
			}
			
			this.isFieldEditable = function(field) {
				var editable_test = $parse(field.editable);
				is_field_editable = editable_test(object);
				return is_field_editable;
			}


		},
		controllerAs: '$ref'
	}
}


var GridReferenceFieldCtrl = function($scope, FormNewInstanceFactory, $q, $controller, $parse, Classes, FieldTplDir) {

	var self = this;
	this.createMode = !$scope.object.__vid;
	this.Class = Classes[$scope.field.join.foreignClass];
	$scope.fieldTplDir = FieldTplDir
	
	this.dictInitialized = false;
	this.filter_depends = function(object) {
		var klass = object.getClass();
		return klass.getObjectPayload(object, 'essential');
	}

	this.items = [];
	
	var aheadref = $scope.field.join.aheadref;  // nazwa pola wskasujacego na zdalny obiekt
	var backref = $scope.field.join.backref;  // nazwa pola wskasujacego na ten obiekt
	var field = $scope.field;
	//var mod = ContextService.getContext(field.join.foreignClass);

	this.update_dict = function() {
		self.dictInitialized = false;
		return $scope.object.getClass()[$scope.field.name + '__dict']({
			//filter:Module.getFilterForContextField(fieldname)($scope.field.name),
			filter:{},
			data: self.filter_depends($scope.object)
		}).then(function(objects){
			console.log('GridReferenceFieldCtrl - dict', objects);
			self.items.length = 0;
			var newitems = [];
			for (var i=0; i<objects.length; i++) {
				var found = false;
				var ahead_id = objects[i].id;
				for (var c=0; c<($scope.object[field.name]||[]).length; c++) {
					var r = $scope.object[field.name][c];
					console.log('test ahead', ahead_id, r[aheadref]);
					if (r[aheadref] && ahead_id == r[aheadref].__id) {
						found = true;
						console.log('found!');
						r.__selected = true;
						r.__title = r[aheadref].__title;
						r[backref] = null;
						newitems.push(r);
					}
				}
				if (!found) {
					(function(target){
						var r = FormNewInstanceFactory.fetchNewInstance(field.join.foreignClass).then(function(object){  // todo - use ModuleService to create object with defaults
							object[aheadref] = target;
							object.__title = target.__title;
							return object;
						})
						newitems.push(r);
					})(objects[i]);
				}
				
			}
			return $q.all(newitems).then(function(items){
				self.dictInitialized = true;
				self.items = items;
			});
		});
	}
	
	$scope.$watch($scope.field.depends, function(x){
		var depends = $parse($scope.field.depends);
		var getDepends = function() {
			var ret = depends($scope.object);
			if (!ret) return [null];
			return ret.__class? [ret.__id] : (ret.length? ret : [ret]);
		}
		$scope.$watchCollection(getDepends, function(x){
			if ((!$scope.object || !$scope.object.id) && !self.createMode) return;
			if (self.dictInitialized) self.update_dict().then(self.set_default);
		});
	}, true);
	
	$scope.$watch('object.effective_time', function(ef_time){
		if ((!$scope.object || !$scope.object.id) && !self.createMode) return;
		if (self.dictInitialized) self.update_dict();
	}, true);

	// selection
	$scope.$watch(function(){return _.map(self.items, function(o){return {title:o.__title,s:o.__selected}})}, function(dict, old) {
		if (dict == old) return;
		if (!self.dictInitialized) return;
		$scope.object[field.name] = $scope.object[field.name] || [];
		$scope.object[field.name].length = 0;
		for (var i in self.items) {
			var r = self.items[i];
			if (r && r.__selected) $scope.object[field.name].push(r);
		}
	}, true);
	
	
	this.itemCtrl = function(Object) {
		var ctrl = $controller('ObjectController', {$scope:$scope.$new(), Object:Object, createMode:false});
		return ctrl;
	}
	
	this.update_dict();
	window.refCtrl = this;

}



angular.module('forms.fields.gridreference', [])
.controller('GridReferenceFieldCtrl', GridReferenceFieldCtrl)
.directive('gridReference', GridReference)
;

// https://github.com/fragaria/angular-daterangepicker/blob/master/js/angular-daterangepicker.js

(function() {
  var picker;

  picker = angular.module('daterangepicker', []);

  picker.constant('dateRangePickerConfig', {
    separator: ' - ',
    format: 'YYYY-MM-DD',
    clearLabel: 'Clear'
  });

  picker.directive('dateRangePicker', ['$compile', '$timeout', '$parse', 'dateRangePickerConfig', function($compile, $timeout, $parse, dateRangePickerConfig) {
    return {
      require: 'ngModel',
      restrict: 'A',
      scope: {
        dateMin: '=min',
        dateMax: '=max',
        model: '=ngModel',
        opts: '=options',
        clearable: '=',
        sqlRange: '=',
      },
      link: function($scope, element, attrs, modelCtrl) {
        var clear, customOpts, el, opts, _formatted, _init, _picker, _setEndDate, _setStartDate, _validateMax, _validateMin;
        el = $(element);
        customOpts = $scope.opts;
        opts = angular.extend({}, dateRangePickerConfig, customOpts);
        _picker = null;
        clear = function() {
          _picker.setStartDate();
          _picker.setEndDate();
          return el.val('');
        };
        _setStartDate = function(newValue) {
          return $timeout(function() {
            var m;
            if (_picker) {
              if (!newValue) {
                return clear();
              } else {
                m = moment(newValue);
                if (_picker.to < m) {
                  _picker.setEndDate(m);
                }
                return _picker.setStartDate(m);
              }
            }
          });
        };
        _setEndDate = function(newValue) {
          return $timeout(function() {
            var m;
            if (_picker) {
              if (!newValue) {
                return clear();
              } else {
                m = moment(newValue);
                if (_picker.from > m) {
                  _picker.setStartDate(m);
                }
                return _picker.setEndDate(m);
              }
            }
          });
        };
        /*
        $scope.$watch('model.from', function(newValue) {
          return _setStartDate(newValue);
        });
        $scope.$watch('model.to', function(newValue) {
          return _setEndDate(newValue);
        });
        */
        _formatted = function(viewVal) {
          var f;
          f = function(date) {
            if (!moment.isMoment(date)) {
              return moment(date).format(opts.format);
            }
            return date.format(opts.format);
          };
          if (opts.singleDatePicker) {
            return f(viewVal.from);
          } else {
            return [f(viewVal.from), f(viewVal.to)].join(opts.separator);
          }
        };
        _validateMin = function(min, start) {
          var valid;
          min = moment(min);
          start = moment(start);
          valid = min.isBefore(start) || min.isSame(start, 'day');
          modelCtrl.$setValidity('min', valid);
          return valid;
        };
        _validateMax = function(max, end) {
          var valid;
          max = moment(max);
          end = moment(end);
          valid = max.isAfter(end) || max.isSame(end, 'day');
          modelCtrl.$setValidity('max', valid);
          return valid;
        };
        modelCtrl.$formatters.push(function(val) {
          if (val && val.from && val.to) {
            _setStartDate(val.from);
            _setEndDate(val.to);
            return val;
          }
          return '';
        });
        modelCtrl.$parsers.push(function(val) {
          if (!angular.isObject(val) || !(val.hasOwnProperty('from') && val.hasOwnProperty('to'))) {
            return modelCtrl.$modelValue;
          }
          if ($scope.dateMin && val.from) {
            _validateMin($scope.dateMin, val.from);
          } else {
            modelCtrl.$setValidity('min', true);
          }
          if ($scope.dateMax && val.to) {
            _validateMax($scope.dateMax, val.to);
          } else {
            modelCtrl.$setValidity('max', true);
          }
          return val;
        });
        
        if ($scope.sqlRange) {
        	modelCtrl.$parsers.push(function(val) {
	          if (val) {
	          	return '[' + val.from + ',' + val.to + ']';
	          }
	          return null;
	        });
	        modelCtrl.$formatters.push(function(val) {
	          var match
	          if (val && (match = val.match(/[\[(]([0-9-]*),([0-9-]*)[\])]/))) {
	          	return {from: match[1], to:match[2]}
	          }
	          return val;
	        });
        }
        
        modelCtrl.$isEmpty = function(val) {
          return !val || val.from === null || val.to === null;
        };
        modelCtrl.$render = function() {
          if (!modelCtrl.$viewValue) {
            return el.val('');
          }
          if (modelCtrl.$viewValue.from === null) {
            return el.val('');
          }
          return el.val(_formatted(modelCtrl.$viewValue));
        };
        _init = function() {
          var callbackFunction, eventType, locale, _ref;
          el.daterangepicker(opts, function(start, end) {
            $timeout(function() {
              modelCtrl.$setViewValue({
                from: start.format('YYYY-MM-DD'),
                to: end.format('YYYY-MM-DD'),
              });
              modelCtrl.$render();
              return;
            });
            return modelCtrl.$render();
          });
          _picker = el.data('daterangepicker');
          _ref = opts.eventHandlers;
          for (eventType in _ref) {
            callbackFunction = _ref[eventType];
            el.on(eventType, callbackFunction);
          }
          if (attrs.clearable) {
            locale = opts.locale || {};
            locale.cancelLabel = opts.clearLabel;
            opts.locale = locale;
            el.on('cancel.daterangepicker', function() {
              modelCtrl.$setViewValue({
                from: null,
                to: null
              });
              modelCtrl.$render();
              return el.trigger('change');
            });
          }
        };
        _init();
        el.change(function() {
          if ($.trim(el.val()) === '') {
            return $timeout(function() {
              return modelCtrl.$setViewValue({
                from: null,
                to: null
              });
            });
          }
        });
        if (attrs.min) {
          $scope.$watch('dateMin', function(date) {
            if (date) {
              if (!modelCtrl.$isEmpty(modelCtrl.$viewValue)) {
                _validateMin(date, modelCtrl.$viewValue.from);
              }
              opts['minDate'] = moment(date);
            } else {
              opts['minDate'] = false;
            }
            return _init();
          });
        }
        if (attrs.max) {
          $scope.$watch('dateMax', function(date) {
            if (date) {
              if (!modelCtrl.$isEmpty(modelCtrl.$viewValue)) {
                _validateMax(date, modelCtrl.$viewValue.to);
              }
              opts['maxDate'] = moment(date);
            } else {
              opts['maxDate'] = false;
            }
            return _init();
          });
        }
        if (attrs.options) {
          $scope.$watch('opts', function(newOpts) {
            opts = angular.extend(opts, newOpts);
            return _init();
          }, true);
        }
        return $scope.$on('$destroy', function() {
          return _picker != null ? _picker.remove() : void 0;
        });
      }
    };
  }]);

}).call(this);

angular.module('forms.fields.daterange', ['daterangepicker'])
//.controller('PositonMapController', PositonMapController);

function DictionaryField() {
	return {
		bindToController: {
			field: '<',
			object: '=fieldObject',
		},
		controller: function($parse, $scope, Classes, $injector, $uibModal, $q, $translate, FormService) {
			var self = this;
		
			this.target_identity = null;
			this.currentItem = null;
			this.currentItemIndex = null;
			this.items = [];
			this.dictInitialized = false;
			this.dictRequestEssentialDataJson = null;  // aby sprawdzać, czy trzeba robić reload dict
			this.reloadDict = false;
			this.isDictLoading = false;
			
			this.dictionaryAsPairs = function(dict) {
				if (dict.length) return dict;
				var ret = [];
				for (var key in dict) {
					ret.push([key, dict[key]]);
				}
				return ret;
			}
			
			this.setupPairs = function(items) {
				this.items = [];
				for (var i=0; i<items.length; i++) {
					var item = {
						value: items[i][0],
						title: items[i][1],
					}
					this.items.push(item);
				}
				this.dictInitialized = true;
			}
			
			this.setupObjects = function(objects) {
				this.items = [];
				for (var i=0; i<objects.length; i++) {
					var item = {
						//value: objects[i],
						value: (objects[i].__class && Classes[objects[i].__class])? Classes[objects[i].__class].getObjectPayload(objects[i]) : objects[i],
						object: objects[i],
						title: this.getObjectTitle(objects[i]),
					}
					this.items.push(item)
				}
				this.dictInitialized = true;
			}
			
			this.getObjectTitle = function(object) {
				if (this.field.client && this.field.client.title) {
					var title_expr = this.field.client.title;
					var title = $parse(title_expr);
					return title(object, window);
				} else {
					return object? object.__title : null;
				}
			}
			
			
			
			this.getEssentialData = function() {
				if (this.object.__class && Classes[this.object.__class]) {
					var klass = Classes[this.object.__class];
					if (klass) {
						return klass.getObjectPayload(this.object, 'essential');
					}
				}
				return this.object;
			}
			
			this.updateDict = function() {
				self.dictRequestEssentialDataJson = angular.toJson(self.getEssentialData())
				self.isDictLoading = true;
				return (this.field.dict)({
					filter:{},
					data: self.getEssentialData()
				}).then(function(items){
					if (self.reloadDict) {
						// nastapiła zmiana depends w czasie trwania request
						console.debug('Reloading dict', self.field.name)
						self.reloadDict = false;
						return self.updateDict();
					}
					if (items && items.length && items[0].__class) {
						self.setupObjects(items);
						self.target_identity = (self.field.client && self.field.client.identity)? self.field.client.identity : '__vid';
					} else {
						self.setupPairs(items);
						self.target_identity = null;
					}
					// set null if new value doesn't contain the selected item
					var found = false;
					for (var i=0; i<self.items.length; i++) {
						if (self.object[self.field.name] == self.items[i].value || 
							(self.target_identity && self.object[self.field.name] && self.object[self.field.name][self.target_identity] == self.items[i].value[self.target_identity])) 
						{
							found = true;
							self.items[i].value = self.object[self.field.name]  // link selected item value to the current value
							self.currentItem = self.items[i];
							self.currentItemIndex = i;
						}
					}
					if (!found) self.object[self.field.name] = null;
					self.isDictLoading = false;
					return items;
				})
			}
			
			this.setDefault = function() {
				if (self.object.__id) return;
				if (self.items.length == 1) {
					self.object[self.field.name] = self.items[0].value;
				}
			}
			
			if (this.field.depends || !this.field.dictionary) {
				var depends = $parse(this.field.depends);
				var getDepends = function() {
					var ret = depends(self.object);
					if (!ret) return [null];
					return ret.__class? [ret.__id] : (ret.length? ret : [ret]);
				}
				self.updateDict().then(self.setDefault);
				$scope.$watchCollection(getDepends, function(x){
					//if (self.dictInitialized) self.updateDict().then(self.setDefault);
					if (self.isDictLoading && self.dictRequestEssentialDataJson != angular.toJson(self.getEssentialData())) {
						self.reloadDict = true;
					} else if (!self.isDictLoading) {
						self.updateDict().then(self.setDefault);
					}
				});
				
			} else {
				var pairs = this.dictionaryAsPairs(this.field.dictionary);
				this.setupPairs(pairs);
			}

			$scope.$watch(function(){return self.object[self.field.name]}, function(values, old){
				//console.debug("Update watch for field fired:", self.field.name);
				if (values == old) return;
				if (!self.dictInitialized) return;
				if (true || self.target_identity) {
					// set null if new value doesn't contain the selected item
					var found = false;
					for (var i=0; i<self.items.length; i++) {
						if (self.object[self.field.name] == self.items[i].value || 
							(self.target_identity && self.object[self.field.name] && self.items[i].value && self.object[self.field.name][self.target_identity] == self.items[i].value[self.target_identity])) 
						{
							found = true;
							self.items[i].value = self.object[self.field.name]  // link selected item value to the current value
							self.currentItem = self.items[i];
							self.currentItemIndex = i;
						}
					}
					if (!found) {
						self.object[self.field.name] = null;
						self.currentItem = null;
						self.currentItemIndex = null;
					}
				}
			});


			// suport images selector
			this.append_new = function(data) {
				if (self.field.client && self.field.client.type == 'image') {
					var item = {
						value: data,
						object: {download: [{href: data.data, thumb: data.data}], __title: data.filename},
						title: data.filename,
					}
					self.object[self.field.name] = item.value;
					this.items.push(item);
				} else if (self.field.join.foreignClass) {
					var classname = self.field.join.foreignClass;
					var item = {
						value: data,
						object: Classes[classname]? Classes[classname].create(data) : data,
						title: self.getObjectTitle(data) || data.title || $translate.instant('New object')
					}
					self.object[self.field.name] = item.value;
					this.items.push(item);
				}
			}

			this.imageSelectDialog = function() {
				var classname = self.field.join.foreignClass;
				if ($injector.has('ContextService')) {
					var module = $injector.get('ContextService').getContext(classname);
				} else {
					var module = null;
				}
				var dlg = $uibModal.open({
					animation: true,
					templateUrl: 'framework/partials/forms/field-dialog-referencefield-images.html',
					controller: 'SubmitCancelDialogCtrl as dCtrl',
					size: 'lg',
					resolve: {
						params: function ($q) {
						return $q.all({
							data: {
								items: self.items, 
								selected: self.object[self.field.name],
								moduleName: module.getName(), 
								imageMode: (self.field.client && self.field.client.imagemode)? self.field.client.imagemode : 'cover',  // contain
							},
							submit:function(data) {
								self.object[self.field.name] = data.selected;
								return $q.resolve(data.selected);
							},
						});
						}
					}
				});
			}

			this.createNewDialog = function(layout, savegroups, defaults) {
				savegroups = savegroups || ['edit'];
				layout = layout || savegroups;
				defaults = defaults || {}
				var classname = self.field.join.foreignClass;
				if ($injector.has('ContextService')) {
					var module = $injector.get('ContextService').getContext(classname);
				}

				var fields = Classes[classname].get_fields(savegroups)
				var formconfig = {
					title: module? module.getTitle(): 'New item',
					btn: module? module.getCreateLabel() : 'Create',
					params: Classes[classname].get_form_params(null, fields),
					submit: function(data) {
						return Classes[classname].validate(data).then(function(){
							self.append_new(data);
							return $q.resolve(data);
						});
					},
					layout: layout,
				}
				return FormService.activateFormModal(formconfig, defaults);
			}
			
			window.dictCtrls = window.dictCtrls || [];
			window.dictCtrls.push(this);
			
		},
		controllerAs: '$dict'
	}
}


function DictionaryMap() {
	return {
		bindToController: {
			items: '<',
			field: '<',
			defaultAddress: '@',
			coords: '@',
			pinColor: '@',
			labelExpression: '@',
			object: '=fieldObject',
		},
		controller: function DictionaryMapCtrl($parse, $scope, FormService, $q) {
			var self = this;
			self.markers = [];
			this.geocodeAddress = '';
			this.geocodeAddressError = false;

			this.map = {
				show: true,
				control: {},
				position: {},
				zoom: 6,
				events: {
					click: function(map, type, args){
						/*$scope.$apply(function(){
							console.log('map click', args);
							self.object[self.field.name] = self.object[self.field.name] || {}
							self.object[self.field.name].latitude = args[0].latLng.lat();
							self.object[self.field.name].longitude = args[0].latLng.lng();
						})*/
					}
				},
				marker: {
					position: {},
					events: {
						/*dragend: function(map, type, args){
							$scope.$apply(function(){
								console.log('drag end', args);
								self.object[self.field.name].latitude = args.gMarker.position.lat();
								self.object[self.field.name].longitude = args.gMarker.position.lng();
							})
						}*/
					}
				}
			}
			
			self.map.position = {latitude:52,longitude:19};

			// http://stackoverflow.com/questions/7095574/google-maps-api-3-custom-marker-color-for-default-dot-marker
			var custom_icon = function(pinColor, selected, icon) {
				pinColor = pinColor || 'FE7569';
				starColor = 'ffff00';
				icon = icon || 'home';
				var style = selected? 'pin_star' : 'pin';
				//var icon_url = "http://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=%E2%80%A2|" + pinColor;
				var icon_url = "http://chart.apis.google.com/chart?chst=d_map_xpin_icon&chld=" 
					+style+ "|" +icon+ "|" + pinColor+ "|" + starColor;
				return icon_url;
			}

			$scope.$watchCollection(function(){return self.items}, function(items) {
				self.markers.length = 0;
				var coords_func = $parse(self.coords);
				var pinColor_func = $parse(self.pinColor);
				var labelExpression_func = $parse(self.labelExpression);
				for (var i=0; i<items.length; i++) {
					var item = items[i];
					if (!item.value[self.coords]) {
						continue;
					}
					self.markers.push({
						id: item.value.__id,
						position: coords_func(item.value),
						title: item.title,
						value: item.value,
						options: self.labelExpression? {labelClass:'label label-default',labelAnchor:/*'12 60'*/ '-5 5' ,labelContent:labelExpression_func(item.value)} : {},
						pinColor: pinColor_func(item.value),
						icon: custom_icon(pinColor_func(item.value), false)
					});
				}
			});
			if (self.defaultAddress) {
				var func = $parse(self.defaultAddress);
				$scope.$watch(function(){return func(self.object);}, function(addr){
					self.geocodeAddress = addr;
				})
			}
			$scope.$watch(function(){return self.object[self.field.name];}, function(value) {
				var pinColor_func = $parse(self.pinColor);
				for (var i=0; i<self.markers.length; i++) {
					var marker = self.markers[i];
					marker.icon = custom_icon(pinColor_func(marker.value), value? marker.id == value.__id : false);
				}
			}, true);

			self.select = function(marker, eventName, model, mousearg) {
				self.object[self.field.name] = model.value;
			}
			
			self.refresh = function(){
				if (self.map.control.refresh) {
					self.map.control.refresh();
					self.map.control.getGMap().setCenter({lat: self.map.position.latitude, lng: self.map.position.longitude});
				}
			}
			
			self.geocode = function(address) {
				console.log('Geocoding', address);
				var geocoder = new google.maps.Geocoder;
				geocoder.geocode({address: address}, function(results, status) {
					$scope.$apply(function(){
						if (status == 'OK') {
							var latlng = results[0].geometry.location;
							self.map.control.getGMap().setCenter(latlng);
							self.map.control.getGMap().setZoom(15);
							self.geocodeAddressError = false;
						} else {
							
							self.geocodeAddressError = 'Not found';
						}
					})
					
				});
			}
			
			$scope.$on('editTabOn', function(){
				self.map.show = true;
				setTimeout($scope.refresh, 10);
			});
			
			window.$map = self;

		},
		controllerAs: '$map'
	}
}


// deprecated
function DictionaryFieldController($scope) {

	var self = this;
	// field.dictionary może mieć postać {a: "b"} lub [["a","b"]]. 
	// Potrzebujemy tą drugą do listy opcji w edycji.
	this.dictionaryAsPairs = function(dict) {
		if (dict.length) return dict;
		var ret = [];
		for (var key in dict) {
			ret.push([key, dict[key]]);
		}
		return ret;
	}
	
	// field.dictionary może mieć postać {a: "b"} lub [["a","b"]]. 
	// Potrzebujemy tą pierwszą do przerabiania value => title w widokach.
	this.dictionaryAsMap = function(dict) {
		if (typeof dict.length == "number") {
			var ret = {};
			for (var i=0; i<dict.length; i++) {
				ret[dict[i][0]] = dict[i][1];
			}
			return ret;
		} else {
			return dict;
		}
	}
	
	this.titleForKey = function(dict, key) {
		if (key === null) return null;
		var dict = self.dictionaryAsMap(dict);
		if (typeof key == "string" || typeof key == "number") {
			return dict.hasOwnProperty(key)? dict[key] : null;
		} else {
			var titles = [];
			for (var i=0; i<key.length; i++) {
				titles.push(dict.hasOwnProperty(key[i])? dict[key[i]] : null);
			}
			return titles.join(', ');
		}
	}
	
	this.toggleOption = function(values, option) {
		var pos = values.indexOf(option);
		if (pos >= 0) {
			values.splice(pos,1);
		} else {
			values.push(option);
		}
		return values;
	}
	
	this.hasOption = function(values, option) {
		return (values||[]).indexOf(option) >= 0;
	}
}


angular.module('forms.fields.dictionary', [])
.directive('dictionaryField', DictionaryField)
.controller('DictionaryFieldController', DictionaryFieldController)
.directive('dictionaryMap', DictionaryMap)










angular.module('forms.fields.currency', [])
//.controller('CurrencyFieldController', CurrencyFieldController);
.directive('currencyField', function(){
return {
	require: 'ngModel',
	restrict: 'A',
	scope: true,
	link: function($scope, element, attrs, ngModel) {
		$scope.val = {
			currency:$scope.defaultCurrency || $scope.$root.defaultCurrency,
			amount: null
		};
		$scope.$watch('val', function(val) {
			var value = {};
			if (val && val.currency && val.amount !== null && val.amount !== '') value[val.currency] = parseFloat(val.amount);
			ngModel.$setViewValue(value);
		}, true);
		
		ngModel.$render = function() {
			$scope.val.currency = $scope.defaultCurrency || $scope.$root.defaultCurrency;
			$scope.val.amount = null;
			for (var currency in ngModel.$modelValue) {
				$scope.val.currency = currency;
				$scope.val.amount = ngModel.$modelValue[currency];
			}
    	};
    	window.ngModel = ngModel;
	},
}

});

function IntervalField() {
	return {
		require: ['ngModel', '^^?fieldBox'],
		restrict: 'A',
		scope: true,
		link: function($scope, element, attrs, controllers) {
			var ngModel = controllers[0];
			var fieldBox = controllers[1];
			$scope.i = {years:0, mons:0, days:0, hours:0, mins:0, secs:0};
			var hide = $scope.$eval(attrs.hide) || {}

			ngModel.$formatters.push(function(value){
				var i = {years:0, mons:0, days:0, hours:0, mins:0, secs:0, sign:"+"};
				if (!value) value = "00:00:00";
				var split = value.split(/ *(year|mon|day)s? */)
				while(split.length) {
					var val = split.shift();
					if (split.length) {
						var unit = split.shift() + 's';
						i[unit] = parseInt(val);
						if (i[unit] < 0 && fieldBox && fieldBox.field.client && fieldBox.field.client.sign_fields) {
							i.sign = "-";
							i[unit] = - i[unit]
						}
					} else if (val.indexOf(":")) {
						i.time = val
					}
				}
				if (hide.years) i.mons += 12 * i.years;
				if (hide.mons) i.days += 30 * i.mons;  // fuzzy
				return i;
			});
			
			ngModel.$parsers.push(function(i){
				if (!i) return;
				var interval = '';
				var sign = i.sign == '+' ? '' : '-'
				if (i.years && !hide.years) interval += sign + i.years + ' years '
				if (i.mons && !hide.mons) interval += sign + i.mons + ' mons '
				if (i.days && !hide.days) interval += sign + i.days + ' days '
				if (i.time && !hide.time) {
					interval += sign + i.time;
				}
				interval = interval.replace(/ $/, '')
				return interval;
			});

			$scope.$watchCollection('i', function(value) {
				if (!value) return;
				value = angular.copy(value)
				ngModel.$setViewValue(value);
			}, true);
			
			ngModel.$render = function() {
				$scope.i = ngModel.$viewValue;
				//$scope.pass.repeat = ngModel.$modelValue;
			};
		},
	}
}

function IntervalFieldController($scope) {
		$scope.i = {};
		// eg "1 year 5 mons 31 days 24:00:00"
		$scope.$watch('object[field.name]', function(value) {
			$scope.i.years = 0;
			$scope.i.mons = 0;
			$scope.i.days = 0;
			$scope.i.hours = 0;
			$scope.i.mins = 0;
			$scope.i.secs = 0;
			if (!value) value = "00:00:00";
			var split = value.split(/ *(year|mon|day)s? */)
			while(split.length) {
				var val = split.shift();
				if (split.length) {
					var unit = split.shift() + 's';
					$scope.i[unit] = parseInt(val);
				} else {
					var parts = val.split(':');
					$scope.i.hours = parseInt(parts[0]) || 0
					$scope.i.mins = parseInt(parts[1]) || 0
					$scope.i.secs = parseInt(parts[2]) || 0
				}
			}
			var hide = $scope.field.hide_fields || {};
			if (hide.years) $scope.i.mons += 12 * $scope.i.years;
			if (hide.mons) $scope.i.days += 30 * $scope.i.mons;  // fuzzy
		});
		$scope.$watch('i', function(i){
			var hide = $scope.field.hide_fields || {};
			if (!i) return;
			var interval = '';
			if (i.years && !hide.years) interval += i.years + ' years '
			if (i.mons && !hide.mons) interval += i.mons + ' mons '
			if (i.days && !hide.days) interval += i.days + ' days '
			if (i.hours || i.mins || i.secs) {
				if (i.secs > 59) i.secs = 59;
				if (i.secs < 0) i.secs = 0;
				if (i.mins > 59) i.mins = 59;
				if (i.mins < 0) i.mins = 0;
				if (i.hours < 0) i.hours = 0;
				var parts = _.map([i.hours, i.mins, i.secs], function(n){return n<10?('0'+n):n;});
				interval += parts.join(':');
			}
			interval = interval.replace(/ $/, '')
			$scope.object[$scope.field.name] = interval;
		}, true);
		
}



angular.module('forms.fields.interval', [])
.controller('IntervalFieldController', IntervalFieldController)
.directive('intervalField', IntervalField)
.filter('inverval_to_pl', function() {
    return function(input) {
    	if (!input) return 'brak';
		var out = input
			.replace(/^1 years?/, '1 rok')
			.replace(/([234]) years?/, '$1 lata')
			.replace(/years?/, 'lat')
			.replace(/ 1 mons?/, ' 1 miesiąc')
			.replace(/([234]) mons?/, '$1 miesiące')
			.replace(/mons?/, 'miesięcy')			
			.replace(/ 1 days?/, ' 1 dzień')
			.replace(/([234]) days?/, '$1 dni')
			.replace(/days?/, 'dni')
		return out;
  }
});

function BackReference() {
	return {
		bindToController: {
			field: '<',
			object: '=fieldObject',
			errors: '<?fieldErrors'
		},
		controller: function($parse, $scope, FormService, $q, Classes) {
			var self = this;
			
			if (!this.object[this.field.name]) {
				this.object[this.field.name] = [];
			}
			this.items = this.object[this.field.name];

			this.subfields = [];
			for (var i in this.field.fields) {
				if (this.field.fields[i].name != this.field.join.backref) {
					this.subfields.push(this.field.fields[i])
				}
			}

			this.isSubfieldVisible = function(field, object) {
				var visible_test = $parse(field.visible);
				var visible = visible_test(object);
				return visible;
			}

			$scope.$watch(function(){return self.object[self.field.name]}, function(items){
				self.items = items;
				if (self.field.join.foreignClass) {   
					for (var i in items) {
						if (items[i].hasOwnProperty(self.field.join.backref)) continue;
						Object.defineProperty(items[i], self.field.join.backref, {
							enumerable: false,
							configurable: true,
							writable: false,
							value: self.object
						});
					}
				}
			});

			this.update_sequence = function() {
				if (self.field.client && self.field.client.sort_field) {
					for (var i=0; i<self.items.length; i++) {
						self.items[i][self.field.client.sort_field] = i + 1;
					}
				}
			}

			this.append_new = function(data) {
				return FormService.fetchDefaultInstance(self.field.fields).then(function(instance){
					if (typeof data == "object") angular.extend(instance, data)
					if (self.field.join.foreignClass) {   
						instance = Classes[self.field.join.foreignClass].create(instance)
						//instance[self.field.join.backref] = self.object;  // causes circural refences when saving
						Object.defineProperty(instance, self.field.join.backref, {
							enumerable: false,
							configurable: true,
							writable: false,
							value: self.object
						});
					}
					self.items.push(instance);
					self.update_sequence();
					self.errors = null;
					return instance;
				});
			}

			this.remove = function(obj) {
				for (var i in self.items) {
					if (self.items[i] === obj) {
						self.items.splice(i, 1);
						break;
					}
				}
				self.update_sequence();
			}

			this.editModal = function(obj, groups, layout) {
				groups = groups || 'edit';
				layout = layout || ['edit'];
				if (typeof groups == "string") groups = [groups];
				var formfields = [];
				for (f in self.field.fields) {
					var field = self.field.fields[f];
					var fgroups = (typeof field.groups == "string"? [field.groups] : field.groups);
					var match = false;
					for (g in groups) {
						for (fg in fgroups) {
							if (groups[g] == fgroups[fg]) match = true;
						}
					}
					if (match) {
						formfields.push(field);
					}
				}
				var form = {
					'title': 'Edit image',
					'prompt': '',
					'btn': 'Save',
					'templateUrl': null,  // form-service default
					'params': formfields,
					'layout': layout,
					'submit': function(data) {
						for (f in formfields) {
							var field = formfields[f];
							obj[field.name] = data[field.name];
						}
						return $q.resolve(data);
					},
					'modalOptions': {} // $modal options
				}
				return FormService.activateFormModal(form, angular.copy(obj));
			}




		},
		controllerAs: '$ref'
	}
}


var BackReferenceFieldCtrl = function($scope, FormNewInstanceFactory, Classes, $state) {

	var self = this;
	this.createMode = !$scope.oCtrl.createMode;
	this.Class = Classes[$scope.field.join.foreignClass];
	if (!$scope.object[$scope.field.name]) {
		$scope.object[$scope.field.name] = [];
	}
	self.items = $scope.object[$scope.field.name];
	$scope.$watch('object[field.name]', function(items) {
		self.items = items;
	});
	
	this.append_new = function(data) {
		var classname = $scope.field.join.foreignClass;
		return FormNewInstanceFactory.fetchNewInstance(classname).then(function(obj){
			if (typeof data == "object") obj.fill(data);
			obj[$scope.field.join.backref] = $scope.object;
			self.items.push(obj);
			return obj;
		});
	}
	
	this.remove = function(obj) {
		for (var i in self.items) {
			if (self.items[i] === obj) {
				self.items.splice(i, 1);
				break;
			}
		}
	}

	this.gotoObject = function(oClass, vid, event/*=null*/) {
		if(event && (event.ctrlKey || event.metaKey)){
			var url = $state.href('module.detail', {page:oClass, vid: vid});
			window.open(url,'_blank');
		}else{
			$state.go('module.detail', {page:oClass, vid: vid});
		}
	}
	
	window.brefCtrl = this;

}


var FileBackreferenceFieldCtrl = function(ReferenceCtrl, $q) {

	var slice = Array.prototype.slice;
	
	var self = this;
	this.message = null;
	this.busy = false;

	this.readFile = function (file) {
        var deferred = $q.defer();

		var reader = new FileReader()
        reader.onload = function(e){
            deferred.resolve({
    			mime: file.type,
				filename: file.name,
				data: e.target.result,
				title: file.name.replace(/\.[a-z0-9]+$/, '').replace(/[_\\-]/g, ' ')
	    	});
        }
        reader.onerror = function(e) {
            deferred.reject(e);
        }
        reader.readAsDataURL(file);

        return deferred.promise;
    }
    
    this.uploadFiles = function(files) {
    	self.is_busy = true;
        return $q.all(slice.call(files, 0).map(self.readFile)).then(function(values){
    		for (var i in values) {
    			ReferenceCtrl.append_new(values[i]);
    		}
			self.is_busy = false;
    	}).catch(function(e){
    		self.message={type:'danger', body:e}
			self.is_busy = false;
    	});
    }
}


var CroppieBackreferenceFieldCtrl = function(ReferenceCtrl, $q, $uibModal) {

	var slice = Array.prototype.slice;
	
	var self = this;
	this.message = null;
	this.is_busy = false;
	
	self.openModal = function(item, ReferenceCtrl){
		$uibModal.open({
			animation: true,
			//ariaLabelledBy: 'modal-title',
			//ariaDescribedBy: 'modal-body',
			templateUrl: 'framework/partials/forms/field-widget-backreferencefield-images-croppie-modal.html',
			controller: function ($uibModalInstance, ApiRootUrl, item, ReferenceCtrl) {
				var modal = this;

				modal.croppie_instance = null;
				modal.croppie_image = null;				
				modal.croppie_options = {
					viewport: { width: 200, height: 200, type: 'circle' },
					boundary: { width: 300, height: 300 },
				}	

				modal.croppie_init = function(){

					modal.croppie_image = item;	
					if(ReferenceCtrl.field.client && ReferenceCtrl.field.client.croppie_options){
						modal.croppie_options = ReferenceCtrl.field.client.croppie_options;
					}
					modal.croppie_instance = $('#croppie-container').croppie(modal.croppie_options);
					modal.croppie_instance.croppie('bind', {
						url: item.data
					});
					
				}
				setTimeout(function(){ modal.croppie_init(); }, 400);

				modal.croppie_result = function(){
					modal.croppie_instance.croppie('result', {type:'base64', size:'original', format:'jpeg', circle:false}).then(function(resp) {			
						if(modal.croppie_image){
							modal.croppie_image.data = resp;
							
							if(ReferenceCtrl.field.client && ReferenceCtrl.field.client.only_single_image)
								ReferenceCtrl.items.length = 0
							
							ReferenceCtrl.append_new(modal.croppie_image);
						}
						modal.croppie_cancel();
					});
				}				

				modal.croppie_cancel = function () {
					modal.croppie_instance.croppie('destroy');
					modal.croppie_instance = null;
					modal.croppie_image = null;
					$uibModalInstance.dismiss('cancel');
				};
			},
			controllerAs: '$modal',
			size: 'lg',
			appendTo: undefined,
			resolve: {
				item: function () {
					return item;
				},
				ReferenceCtrl: function() {
					return ReferenceCtrl;
				}
			}
		});				
		
	}

	this.readFile = function (file) {
        var deferred = $q.defer();

		var reader = new FileReader()
        reader.onload = function(e){
            deferred.resolve({
    			mime: file.type,
				filename: file.name,
				data: e.target.result,
				title: file.name.replace(/\.[a-z0-9]+$/, '').replace(/[_\\-]/g, ' ')
	    	});
        }
        reader.onerror = function(e) {
            deferred.reject(e);
        }
        reader.readAsDataURL(file);

        return deferred.promise;
    }
    
    this.uploadFiles = function(files) {
    	self.is_busy = true;
        return $q.all(slice.call(files, 0).map(self.readFile)).then(function(values){
    		for (var i in values) {
    			//ReferenceCtrl.append_new(values[i]);
				//self.croppie_init(values[i]);
				self.openModal(values[i], ReferenceCtrl);
    		}
			self.is_busy = false;
    	}).catch(function(e){
    		self.message={type:'danger', body:e}
			self.is_busy = false;
    	});
    }
}


angular.module('forms.fields.backreference', [])
.controller('BackReferenceFieldCtrl', BackReferenceFieldCtrl)
.controller('FileBackreferenceFieldCtrl', FileBackreferenceFieldCtrl)
.controller('CroppieBackreferenceFieldCtrl', CroppieBackreferenceFieldCtrl)
.directive('backReference', BackReference)



.directive('fullscreenGallery', function() {
	return {
		bindToController: {
			fullscreenGallery: '=',
		},
		controller: function($scope, $rootScope, $element, $attrs, $uibModal, $q) {
	    	var self = this;
	    	this.focus = null;
	    	this.gallery = this.fullscreenGallery;
	    	
	    	var parent = $element.parent();
	    	this.is_fullscreen = false;
	    	this.openFullscreen = function() {
	    		if (self.is_fullscreen) return;
	    		console.log('openFullscreen');
	    		window.scrollTo(0,0);
	    		$element.appendTo('body').addClass('fullscreen');
	    		$('body').css({'overflow-y':'hidden'});
	    		self.is_fullscreen = true;
	    	}
	    	
	    	this.closeFullscreen = function() {
	    		if (!self.is_fullscreen) return;
	    		$element.appendTo(parent).removeClass('fullscreen');
	    		$('body').css({'overflow-y':'auto'});
	    		self.is_fullscreen = false;
	    	}
	    	
	    	this.setFocus = function(file) {
				var url = file.data || file.download[0].href;
				self.focus = file;
				if (!self.focus.src) {
					var img = new Image;
					self.focus.src = file.data || null;
					img.onload = function() {
						$rootScope.$apply(function(){
							self.focus.src = url;
						});
					}
					img.src = url;
				}
			}
			
			this.fastFocus = function(file) {
				self.focus = file;
			}
			
			this.next = function(offset) {
				var curr = this.gallery.indexOf(self.focus);
				var next = curr+offset;
				if (next < 0) next = this.gallery.length - 1;
				if (next >= this.gallery.length) next = 0;
				self.setFocus(this.gallery[next]);
			}
			
			
			this.editFile = function(file) {
				var save = function(data) {
					file.title = data.title;
					return $q.resolve(true);
				}
				//var dlg = dialogs.create('partials/grid/dialog-save-tab.html','SaveCancelDialogCtrl',{data:tab,save:save},{size:'lg'});
				var dlg = $uibModal.open({
				      animation: true,
				      templateUrl: 'partials/dialog-image-title.html',
				      controller: 'SubmitCancelDialogCtrl as dCtrl',
				      size: 'md',
				      resolve: {
				        params: function () {
				          return {data:{title:file.title},submit:save}
				        }
				      }
				});
			}
	    	
		},
		controllerAs: 'gallery'
	}
})








angular.module('forms.fields.password', [])
.directive('passwordField', function($translate){
return {
	require: ['ngModel', '^^?fieldBox'],
	restrict: 'A',
	scope: true,
	link: function($scope, element, attrs, controllers) {
		var ngModel = controllers[0];
		var fieldBox = controllers[1];

		$scope.pass = {pass:'', repeat:''};
		$scope.$watchCollection('pass', function(pass) {
			if (!pass) return;
			var value = '';

			if (!pass.repeat || (pass.pass == pass.repeat)) {
				value = pass.pass;
				if (fieldBox) {
					delete fieldBox.errors[fieldBox.field.name];
					if (pass.repeat) {
						fieldBox.setFieldState('valid', null);
					} else if (pass.pass) {
						fieldBox.setFieldState('invalid', 'Both password fields must match!');  // invisible error - wait for editing the second field, but stop form from sending
					}
				}
			} else {
				if (fieldBox) {
					fieldBox.errors[fieldBox.field.name] = 'Both password fields must match!';
					fieldBox.setFieldState('invalid', 'Both password fields must match!');
				}
			}
			ngModel.$setViewValue(value);
		}, true);
		
		ngModel.$render = function() {
			$scope.pass.pass = ngModel.$modelValue;
			$scope.pass.repeat = ngModel.$modelValue;
    	};
	},
}

});


function PasswordStrengthValidator($parse, $translate, $timeout) {
	return {
		bindToController: {
			config: '<passwordRequirements',
            value: '=value'
		},
		restrict: 'A',
        require:  'ngModel',
        controller: function($element, $scope) {
			
			var self = this;

			this.validators = {
				min_length: {
					validate: function(pass, config) {return pass.length >= config.min_length;},
					label: 'The password should be at least {{min_length}} characters long',
					is_valid: false,
					in_use: false,
				},
				one_digit: {
					validate: function(pass, config) {return (new RegExp("^(?=.*\\d)", "u")).test(pass);},
					label: 'The password must contain at least 1 digit',
					is_valid: false,
					in_use: false,
				},
				one_uppercase: {
					validate: function(pass, config) {return (new RegExp("^(?=.*\\p{Lu})", "u")).test(pass);},
					label: 'The password must contain at least 1 capital letter',
					is_valid: false,
					in_use: false,
				},
				one_lowercase: {
					validate: function(pass, config) {return (new RegExp("^(?=.*\\p{Ll})", "u")).test(pass);},
					label: 'The password must contain at least 1 lowercase letter',
					is_valid: false,
					in_use: false,
				}
			}

			this.pass_strength_validator = {}
			this.overall_valid = false;

			$scope.$watch(function(){return self.value}, function(pass){
				var overall_valid = true;
				angular.forEach(self.validators, function(validator, key) {
					if (self.config[key]) {
						validator.in_use = true;
						if (typeof pass != "string") {
							validator['is_valid'] = false;
							overall_valid = false;
						} else if (pass == "") {
							validator['is_valid'] = false;
							overall_valid = false;
						} else {
							validator['is_valid'] = validator.validate(pass, self.config);
							overall_valid &= validator['is_valid'];
						}
					} else {
						validator.in_use = false;
					}
				})
				this.overall_valid = overall_valid;
			});


        },
		controllerAs: '$passwordStrengthValidator'
	}
}

angular.module('forms.fields.password')
.directive('passwordStrengthValidator', PasswordStrengthValidator)



angular.module('forms.fields.password_single', [])
.directive('passwordSingleField', function($translate){
return {
	require: ['ngModel'],
	restrict: 'A',
	scope: true,
	link: function($scope, element, attrs, controllers) {
		var ngModel = controllers[0];

		$scope.pass = {pass:''};
		$scope.$watchCollection('pass', function(pass) {
			if (!pass) return;
			var value = pass.pass;
			
			ngModel.$setViewValue(value);
		}, true);
		
		ngModel.$render = function() {
			$scope.pass.pass = ngModel.$modelValue;
			$scope.pass.repeat = ngModel.$modelValue;
    	};
	},
}

});

angular.module('forms.fields.binary', [])
.directive('persistentBinaryField', function($q, pinesNotifications, $translate){
    var slice = Array.prototype.slice;
    
    var readFile = function (file, setProgress) {
        var deferred = $q.defer();
        var isResolved = false;

        var reader = new FileReader()
        reader.onerror = function(e) {
            if (!isResolved) deferred.reject({file: file, event: e});
            isResolved = true;
        }
        reader.onload = reader.onloadend = function(e){
            if (!isResolved) {
                if (e.target.result.length) {
                    deferred.resolve(e.target.result);
                } else {
                    deferred.reject({file: file, event: e});
                }
            }
            isResolved = true;
        }
        reader.onprogress = function(e){
            if (setProgress && e.total) {
                setProgress({file: file, event: e});
            }
        }

        if (file.size <= 100 * 1025 * 1024) {
            reader.readAsDataURL(file);
        } else {
            deferred.reject({file: file, event: null, message: $translate.instant('File too large')});
        }

        return deferred.promise;
    }
    
    var updateFilesMetadata = function(files) {
		console.debug('Update files meta:', files);
		if (files.length > 0) {
			var file = files[0];
			object.mime = file.type;
			object.filename = file.name;
		} else {
			object.mime = null;
			object.filename = null;
		}
	}

    return {
        restrict: 'A',
        scope: { 'onRead': '&', 'onProgress': '&', 'onError': '&' },
        require: '?ngModel',
        link: function(scope, element, attrs, ngModel){
            if(!ngModel) return;

            var setProgress = function(info) {
                scope.$apply(function(){
                    scope.onProgress({$event: info.event, file: info.file});
                });
            }

            ngModel.$render = function(){}

            element.bind('change', function(e){
                var element = e.target;
				
				
                $q.all(slice.call(element.files, 0).map(function(reader){return readFile(reader, setProgress);}))
                .then(function(values){
                    if (element.multiple) ngModel.$setViewValue(values);
                    else ngModel.$setViewValue(values.length ? values[0] : null);
                    scope.onRead({file: element.files.length>0? element.files[0] : {}});
                }).catch(function(info){
                    console.error('Binary field error', info.file, info.event);
                    pinesNotifications.notify({
                        title: $translate.instant('An error occured while loading the file'),
                        text: info.message || info.file.name,
                        type: 'error'
                    });
                    scope.onError({$event: info.event, file: info.file});
                });
                
            });//change

        },//link

    };//return

})



















.directive('binaryHashField', function($q, pinesNotifications, $translate, $cookies, FileUploader){
    return {
		bindToController: {
			field: '<',
			object: '=fieldObject',
		},
		controller: function($parse, $scope, Classes) {
            this.uploader = new FileUploader({
                url: this.field.client.upload_url,
                autoUpload: true,
                removeAfterUpload: true,
                headers: {'X-XSRF-TOKEN': $cookies.get('XSRF-TOKEN')},
                formData: []
            });

            var self = this;
            this.current_item = null;
            this.current_item_error = '';

            // CALLBACKS

            this.uploader.onBeforeUploadItem = function(item) {
                console.info('onBeforeUploadItem', item);
                self.current_item = item;
                self.current_item_error = '';
                //item.formData.push({parent_vid: $scope.object.__vid});

                // update meta
                self.object.mime = item.file.type;
                self.object.filename = item.file.name;
            };
            this.uploader.onSuccessItem = function(fileItem, response, status, headers) {
                console.info('onSuccessItem', fileItem, response, status, headers);
                response = JSON.parse(response);
                self.object[self.field.name] = {hash: response}
                self.current_item = null;
            };
            this.uploader.onErrorItem = function(fileItem, response, status, headers) {
                console.error('Binary hash field error', fileItem, response, status, headers);
                var message = response.message || 'unknown reason';
                try {
                    var message = JSON.decode(response).message;
                } catch (e) {}
                self.current_item_error = 'Error (' + status + '): ' + message;
                pinesNotifications.notify({
                    title: $translate.instant('An error occured while loading the file'),
                    text: message || fileItem.file.name,
                    type: 'error'
                });
                self.current_item = null;
            };
            this.uploader.onCancelItem = function(fileItem, response, status, headers) {
                console.info('onCancelItem', fileItem, response, status, headers);
                self.current_item = null;
            };
            this.uploader.onCompleteItem = function(fileItem, response, status, headers) {
                console.info('onCompleteItem', fileItem, response, status, headers);
            };
        },
        controllerAs: '$hash'
    }


})


function TagField() {
	return {
		bindToController: {
			field: '<',
			object: '=fieldObject',
		},
		controller: function($scope, $parse, $q, Classes) {
			var self = this;
			this.queries_cache = [];
			
			this.loadTags = function($query) {
				for (var i=0; i<self.queries_cache.length; i++) {
					if (self.queries_cache[i].query == $query) {
						return $q.resolve(self.queries_cache[i].tags);
					}
				}
				return self.field.dict({
					filter:{"title ~* ?": $query},
					data: {}
				}).then(function(dict){
					var tags = dict.map(function(item){return {text:item[1]};})
					self.queries_cache.splice(0, 0, [{query: $query, tags: tags}]);
					if (self.queries_cache.length > 10) self.queries_cache.length = 10;
					return tags;
				});
			}
			
			
			
			this.addTag = function($tag) {
				self.object[self.field.name] = self.object[self.field.name] || [];
				self.object[self.field.name].push($tag.text)
			}
			this.removeTag = function($tag) {
				self.object[self.field.name] = self.object[self.field.name] || [];
				self.object[self.field.name].splice(self.object[self.field.name].indexOf($tag.text), 1)
			}

			this.dictionary = [];
			if (this.field.client && this.field.client.display == "checkboxes") {
				this.loadTags().then(function(tags){
					[].push.apply(self.dictionary, tags);

					$scope.$watch(function() {return self.object[self.field.name]}, function(value) {
						if (value && value.length) {
							for (var i=0; i<self.dictionary.length; i++) {
								self.dictionary[i].selected = false;
								for (var t=0; t<value.length; t++) {
									if (self.dictionary[i].text == value[t]) self.dictionary[i].selected = true;
								}
							}
						} else {
							for (var i=0; i<self.dictionary.length; i++) self.dictionary[i].selected = false;
						}
					});
				});
			} else {
				this.tags = [];
				$scope.$watch(function() {return self.object[self.field.name]}, function(value) {
					if (value && value.length) {
						self.tags = value.map(function(item) {return {text:item}});
					} else {
						self.tags = [];
					}
				});
			}

			

			window.tCtrl = this;

		},
		controllerAs: '$tagField'
	}
}



function TagFieldController($scope, $parse) {

	var self = this;
	var cls = $scope.object.getClass();
	
	if(!$scope.object[$scope.field.name])
		$scope.object[$scope.field.name] = [];	

	if(!$scope.object[$scope.field.name])
		$scope.object[$scope.field.name] = [];

	this.loadTags = function($query) {
		return cls[$scope.field.name + '__dict']({
			filter:{"title ~* ?": $query},
			data: {}
		}).then(function(dict){
			return dict.map(function(item){return {text:item[1]};})
		});
	}

	this.tags = [];
	$scope.$watch('object.' + $scope.field.name, function(value) {
		if (value && value.length) {
			self.tags = value.map(function(item) {return {text:item}});
		} else {
			self.tags = [];
		}
	});
	
	this.addTag = function($tag) {
		$scope.object[$scope.field.name].push($tag.text)
	}
	this.removeTag = function($tag) {
		$scope.object[$scope.field.name].splice($scope.object[$scope.field.name].indexOf($tag.text), 1)
	}

	window.tCtrl = this;
}




angular.module('forms.fields.tags', ['ngTagsInput'])
.controller('TagFieldController', TagFieldController)
.directive('tagField', TagField)

function CompositeField() {
	return {
		bindToController: {
			field: '<',
			object: '=fieldObject',
		},
		controller: function($parse, $scope, FormService, $q, Classes) {
			var self = this;

			
			
			
			if (!this.object[this.field.name]) {
                this.object[this.field.name] = {};
                
			}
			/*
			if (!this.object[this.field.name].__parent) {
				Object.defineProperty(this.object[this.field.name], '__parent', {
                    enumerable: false,
                    configurable: true,
                    writable: false,
                    value: self.object
                });
			}
			*/

			this.object[this.field.name].__parent = {}

			if (this.object.__class) {
				self.Class = Classes[this.object.__class];
				$scope.$watchCollection(function(){return self.object}, function(value) {
					if (!value) return;
					self.object[self.field.name].__parent = self.Class.getObjectPayload(value, 'essential');
				});
			}
			
			
			//this.subfields = this.object.get_form_params(this.field.client.fields)
			

		},
		controllerAs: '$ref'
	}
}


angular.module('forms.fields.composite', [])
.directive('compositeField', CompositeField)
function MarkdownTextField($parse, $translate, $timeout) {
	return {
		bindToController: {
			field: '<',
            object: '=fieldObject',
            atwho: '<',
		},
		restrict: 'A',
        require:  'ngModel',
        link: function(scope, element, attrs, ngModel) {
          var options = scope.$eval(attrs.markdownTextField) || {};

          scope.undo = [];
          scope.lastContent = "";
          scope.editor = null;
          
          // make button reflect undow state
          var updateUndoButton = function(){
            element.closest('.md-editor').
                find('button[data-handler="bootstrap-markdown-cmdUndo"]').
                toggleClass('disabled', scope.undo.length == 0 || scope.undo.length == 1 && scope.undo[0] == scope.editor.getContent() );
            }
          
            // update undo after blur or othe content change
            // also updates the button
          var updateUndo = function() {
              if (!scope.editor) return;
              var content = scope.editor.getContent();
              if (scope.undo.length == 0) {
                  scope.undo.push(content);
              } else {
                  var lastUndo = scope.undo[scope.undo.length - 1];
                  var push = false;
                  //if (Math.abs(content.length - lastContent.lenght) > 5) push = true;
                  //if (Math.abs(content.length - lastUndo.lenght) > 50) push = true;
                  if (content.trim() != lastUndo.trim()) push = true;
                  if (push) scope.undo.push(content);
              }
              lastContent = content;
              updateUndoButton();
          }
          
          var updatePreview = function(e){
              var html = e.parseContent();
              if (html == '') {
                  element.closest('.md-editor').find('.twitter-footer').show().html(html)
              } else {
                  element.closest('.md-editor').find('.twitter-footer').show().html(html)
              }
          };

            var makeCallback = function(source, additionalCallback) {
                var callback = $parse(source);
                return function(editorObject) {
                    if (additionalCallback) additionalCallback(editorObject);
                    return callback({editorObject: editorObject});
                }
            }

            // Only initialize the $.markdown plugin once.
            if (! element.hasClass('processed')) {
                element.addClass('processed');

                // Setup the markdown WYSIWYG.
                element.markdown({
                  autofocus: options.autofocus || false,
                  saveable: options.saveable || false,
                  iconlibrary: options.iconlibrary || 'glyph',
                  hideable: options.hideable || false,
                  width: options.width || 'inherit',
                  height: options.height || 'inherit',
                  resize: options.resize || 'vertical',
                  language: options.language || $translate.use().substring(0,2),
                  footer: options.footer || '<div class="twitter-footer" style="display:none;"></div>',
                  fullscreen: options.fullscreen || { enable: true, icons: {}},
                  hiddenButtons: options.hiddenButtons || 'cmdPreview',
                  disabledButtons: options.disabledButtons || [],
                  initialstate: options.initialstate || 'editor',
                  parser: options.parser || null,
                  dropZoneOptions: options.dropZoneOptions || null,
                  enableDropDataUri: options.enableDropDataUri || false,
                  showButtons: options.showButtons || null,
                  additionalButtons: [
				    [{
				          name: "groupUndo",
				          data: [{
				            name: "cmdUndo",
				            toggle: false, // this param only take effect if you load bootstrap.js
				            title: "Cofnij",
				            icon: "fa fa-undo",
				            callback: function(e){
				            	var restoredContent = "";
				            	while (scope.undo.length > 0) {
				            		restoredContent = scope.undo.pop();
				            		console.debug(restoredContent);
				            		if (e.getContent().trim() != restoredContent.trim()) {
				            			e.setContent(restoredContent);
				            			break;
				            		}
				            	}
				            	if (scope.undo.length == 0) scope.undo.push(restoredContent);
                                updateUndoButton(e);
                                updatePreview(e);
				            }
				          }]
				    }]
  				  ],

                  //-- Events/Hooks --
                  // each of them are defined as callback available in the directive
                  // example: <textarea markdown-editor="{'iconlibrary': 'fa'}" on-fullscreen-exit="vm.exitFullScreenCallback()"></textarea>
                  //  NOTE: If you want this one to work, you will have to manually download the JS file, not sure why but they haven't released any versions in a while
                  //       https://github.com/toopay/bootstrap-markdown/tree/master/js
                  onPreview: makeCallback(attrs.onPreview),
                  onPreviewEnd: makeCallback(attrs.onPreviewEnd),
                  onSave: makeCallback(attrs.onSave),
                  onBlur: makeCallback(attrs.onBlur, updateUndo),
                  onFocus: makeCallback(attrs.onFocus, updateUndo),
                  onFullscreen: makeCallback(attrs.onFullscreen),
                  onSelect: makeCallback(attrs.onSelect),
                  onFullscreenExit: makeCallback(attrs.onFullscreenExit),
                  onChange: makeCallback(attrs.onChange, function(e) {
                    // When a change occurs, we need to update scope in case the user clicked one of the plugin buttons
                    // (which isn't the same as a keydown event that angular would listen for).
                    ngModel.$setViewValue(e.getContent());

                    updatePreview(e);
                  }),
                  onShow: makeCallback(attrs.onShow, function (e) {
                    // keep the Markdown Object in $rootScope so that it's available also from anywhere (like in the parent controller)
                    // we will keep this in an object under the ngModel name so that it also works having multiple editor in same controller
                    //$rootScope.markdownEditorObjects = $rootScope.markdownEditorObjects || {};
                    //$rootScope.markdownEditorObjects[ngModel.$name] = e;

                    scope.editor = e;
                    scope.$widget.editor = e;
                    updateUndoButton(e);
                    $timeout(function(){
                        updatePreview(e);
                    }, 100);

                    /*element.atwho({
                        at: "@",
                        data: ["one", "two", "three"],
                    }).atwho({
                        at: "{",
                        data: ["one", "two", "three"],
                        insertTpl: "{{${name}}}",
                    });*/
                    

                  })
                });
            }
            
            element.on('keypress', function(e) {
				var code = e.keyCode || e.which;
			    if (code == 13 || code == 0) {
			        // unprintable code
			        updateUndo();
			    }
            });
            

            
        },
        controller: function($element, $scope) {
            var self = this;
            $scope.$watch(function(){return self.atwho},function(atwho_config){
                if (atwho_config) {
                    $element.atwho(self.atwho)
                }
            })

        },
		controllerAs: '$markdown'
	}
}


function TemplateUserHelp($parse, $translate, $timeout, $filter) {
	return {
		bindToController: {
			field: '<',
			object: '=fieldObject',
		},
        controller: function($scope, Classes) {
            var self = this
            this.vars = null;
            this.atwho = null;
            $scope.$watch(function(){return self.object[self.field.client.dataBaseClass]}, function(baseClass){
                if (!baseClass) {
                    return;
                }
                self.field.class_placeholders({classname:baseClass}).then(function(vars){
                    //self.vars = vars
                    var tpltranslate = $filter('tpltranslate')
                    var list = [];
                    for (key in vars) {
                        list.push({
                            varname: key,
                            title: tpltranslate('{{' + vars[key].split(' > ').join('}} > {{') + '}}')
                        })
                    }
                    self.vars = list;

                    self.atwho = {
                        data: list,
                        at: "{",
                        insertTpl: "{{${varname}}}",
                        displayTpl: "<li>${title} <small>${varname}</small></li>",
                        searchKey: "title",
                    }
                })
            })
            
        },
        controllerAs: '$help'
    }
}

function TextFieldLength($parse, $translate, $timeout) {
	return {
		bindToController: {
			field: '<',
            object: '=fieldObject'
		},
		restrict: 'A',
        require:  'ngModel',
        controller: function($element, $scope) {
			
            var self = this;
			
			this.strlength = 0;
			this.minlength = null;
			this.maxlength = null;
			this.remainedlength = 0;
			this.neededlength = 0;
			this.show_sign_counter = false;
			
			if(self.field.client && (self.field.client.minlength || self.field.client.maxlength)){
				self.minlength = self.field.client.minlength;
				self.maxlength = self.field.client.maxlength;
				self.show_sign_counter = true;				
				
				$scope.$watch(function(){return self.object[self.field.name]}, function(text){
                    if (typeof text != 'string') text = '';
                    text = text.replace(/<\/?("[^"]*"|'[^']*'|[^>])*(>|$)/g, "");  // strip tags
					self.strlength = text.length;
					
					if(self.minlength && (self.minlength - text.length) > 0){
						self.neededlength = self.minlength - text.length;
					}else{
						self.neededlength = 0;
					}
					
					if(self.maxlength && (self.maxlength - text.length) > 0){
						self.remainedlength = self.maxlength - text.length;
					}else if(self.maxlength){
						text.length = self.maxlength;
						self.remainedlength = 0;
					}else{
						self.remainedlength = 0;
					}
				})
				
			}


        },
		controllerAs: '$textFieldLength'
	}
}

angular.module('forms.fields.text', ['hc.marked', 'hljs'])
.directive('markdownTextField', MarkdownTextField)
.directive('templateUserHelp', TemplateUserHelp)
.directive('textFieldLength', TextFieldLength)
.config(['markedProvider', function (markedProvider) {
    markedProvider.setOptions({gfm: true, breaks: true});
}]);
function FormBuilderField() {
	return {
		bindToController: {
			field: '<',
			object: '=fieldObject',
			errors: '<fieldErrors',
		},
		controller: function($parse, $scope, FormService, $q, Classes, $timeout, $translate, $element, $window) {
			var self = this;
			self.formBuilder = null;
			self.working = false;
			self.formitems = [];

			


			self.makeFormInput = function(form_type, name, options) {
				var field = {
					//client:undefined,
					//default:undefined,
					description: '',
					editable:"true",
					groups:['survey-form'],
					name: name || 'default_value',  // every field has the same name, different object
					required: options.required || false,
					title: options.label,
					type: form_type,
					visible: options.visible || "true",
					client: {
						description: options.description || null,
						placeholder: options.placeholder || ' ',
						options_inline: options.options_inline || null
					}
				};
				if (options.values) {
					field.dictionary = options.values
				}
				if (form_type == "FormFilesField") {
					field.client.multiple = options.multiple;
					field.client.max_file_size = options.max_file_size;
					field.client.max_files = options.max_files;
				}
				return field;
			}

			self.makeFormItem = function(type, spec) {
				var item = angular.copy(spec);
				item.options.name = item.options.name || _.camelCase(type) + '_' + Date.now();
				item.options.type = type;
				item.example_input = self.makeFormInput(item.form_type, 'default_value', item.options || {})
				item.config_form_fields = [
					self.makeFormInput("Field", 'label', {label: 'Input title', required: true}),
					self.makeFormInput("BooleanField", 'required', {label: 'Required'}),
					self.makeFormInput("Field", 'placeholder', {label: 'Input placeholder'}),
					self.makeFormInput("Field", 'description', {label: 'Input description'}),
				]
				if (item.options.values) {
					item.config_form_fields.push(self.makeFormInput("BooleanField", 'options_inline', {label: 'Display options inline'}));
				}
				if (item.options.values) {
					var value_field = self.makeFormInput("BackReferenceField", 'values', {label: 'Options'});
					value_field.fields = [
						self.makeFormInput("Field", 'label', {label: 'Option label'}),
						self.makeFormInput("Field", 'value', {label: 'Option value'}),
					];
					value_field.fields[1].default = function(){
						var i=0;
						while(true) {
							i++;
							var id = 'opcja-' + i;
							var exists = false;
							for(var j=0; j<item.options.values.length; j++) {
								if (id == item.options.values[j].value) exists = true;
							}
							if (!exists) break;
						}
						return 'opcja-' + i
					}
					value_field.join = {backref: null}
					value_field.client.display = 'table',
					item.config_form_fields.push(value_field)
				}

				if (type == 'file') {
					item.config_form_fields.push(self.makeFormInput("BooleanField", 'multiple', {label: 'Allow multiple files'}));
					item.config_form_fields.push(self.makeFormInput("IntField", 'max_file_size', {label: 'Maximum single file size in MB'}));
					var max_files = self.makeFormInput("IntField", 'max_files', {label: 'Maximum number of files'})
					max_files.visible = "multiple == true"
					item.config_form_fields.push(max_files);
				}

				// conditional
				item.config_form_fields.push(self.makeFormInput("BooleanField", 'conditional', {label: 'Is conditional?'}));
				var conditional_field_list = self.makeFormInput("DictionaryField", 'visible_reference', {label: 'Observed field'});
				conditional_field_list.dict = function(){
					return $q.resolve(self.formitems.map(function(item){return [item.options.name, item.options.label]}));
				};
				conditional_field_list.visible = "conditional == true"
				item.config_form_fields.push(conditional_field_list)

				var conditional_field_value = self.makeFormInput("Field", 'visible_value', {label: 'Required value'});
				conditional_field_value.visible = "conditional == true && visible_reference"
				item.config_form_fields.push(conditional_field_value)
				// END conditional

				// typeUserAttrs
				if (self.field.client && self.field.client.typeUserAttrs && self.field.client.typeUserAttrs[type]) {
					for (var fname in self.field.client.typeUserAttrs[type]) {
						var fspec = self.field.client.typeUserAttrs[type][fname];
						if (fspec.options) {
							item.config_form_fields.push(self.makeFormInput("DictionaryField", fname, {label: fspec.label, values:fspec.options, required: fspec.required}))
						} else {
							item.config_form_fields.push(self.makeFormInput("Field", fname, {label: fspec.label, required: fspec.required}))
						}
					}
				}


				item.config_form_errors = {}
				item.has_errors = false;
				item.stop_watching_options = $scope.$watch(function(){return item.options;}, function(currval, oldval){
					if (oldval && currval) {
						item.example_input.title = item.options.label;
						item.example_input.required = item.options.required;

						// errors
						item.has_errors = false;
						for (var i=0; i<item.config_form_fields.length; i++) {
							var fcfield = item.config_form_fields[i];
							if (fcfield.required && !item.options[fcfield.name]) {
								item.config_form_errors[fcfield.name] = 'This field is required';
								item.has_errors = true;
							} else {
								item.config_form_errors[fcfield.name] = null;
							}
						}
					}
				}, true);

				item.stop_watching_values = $scope.$watch(function(){return item.default_value;}, function(currval, oldval){
					self.updateObjectValue();
				}, true);
				return item;
			}

			self.fields = {
				text: {
					title: $translate.instant('Text field'),
					form_type: 'Field',
					options: {
						label: $translate.instant('Text field'),
						name: null,  // fill dynamically
						//description: "",
						//placeholder: "",
					},
					default_value: "",
					erase: function(item) {
						item.default_value = "";
					}
				},
				textarea: {
					title: $translate.instant('Large text field'),
					form_type: 'TextField',
					options: {
						label: $translate.instant('Large text field'),
					},
					default_value: "",
					erase: function(item) {
						item.default_value = "";
					}
				},
				number: {
					title: $translate.instant('Number field'),
					form_type: 'IntField',
					options: {
						label: $translate.instant('Number field'),
					},
					default_value: null,
					erase: function(item) {
						item.default_value = null;
					}
				},
				date: {
					title: $translate.instant('Date field'),
					form_type: 'DateField',
					options: {
						label: $translate.instant('Date field'),
					},
					default_value: null,
					erase: function(item) {
						item.default_value = null;
					}
				},
				select: {
					title: $translate.instant('Select field'),
					form_type: 'FormSelectField',
					options: {
						label: $translate.instant('Select field'),
						values: [
							{label:'Opcja 1', value:'opcja-1'},
							{label:'Opcja 2', value:'opcja-2'},
							{label:'Opcja 3', value:'opcja-3'},
						],
					},
					default_value: null,
					erase: function(item) {
						item.default_value = null;
						for (var i=0; i<item.options.values; i++) delete item.options.values[i].selected;
					}
				},
				'radio-group': {
					title: $translate.instant('Radio select field'),
					form_type: 'FormRadioGroupField',
					options: {
						label: $translate.instant('Radio select field'),
						values: [
							{label:'Opcja 1', value:'opcja-1'},
							{label:'Opcja 2', value:'opcja-2'},
							{label:'Opcja 3', value:'opcja-3'},
						],
					},
					default_value: null,
					erase: function(item) {
						item.default_value = null;
						for (var i=0; i<item.options.values; i++) delete item.options.values[i].selected;
					}
				},
				'checkbox-group': {
					title: $translate.instant('Checkbox field'),
					form_type: 'FormChecboxGroupField',
					options: {
						label: 'Checkbox field',
						values: [
							{label:'Opcja 1', value:'opcja-1', /* selected: true */},
							{label:'Opcja 2', value:'opcja-2'},
							{label:'Opcja 3', value:'opcja-3'},
						],
					},
					default_value: null,
					erase: function(item) {
						item.default_value = [];
						for (var i=0; i<item.options.values; i++) delete item.options.values[i].selected;
					}
				},
				file: {
					title: $translate.instant('File upload'),
					form_type: 'FormFilesField',
					options: {
						label: $translate.instant('File upload'),
						multiple: false,
						max_file_size: 5,
						max_files: 10,
					},
					default_value: [],
					erase: function(item) {
						item.default_value = [];
					}
				},
			}
			
			self.controlOrder = [
				'text',
				'textarea',
				'number',
				'date',
				'select',
				'checkbox-group',
				'radio-group',
				'file'
			];

			self.typesDragOptions = {
				clone: true,
				accept: function(){return false;},
				itemMoved: function (eventObj) {
					eventObj.dest.sortableScope.removeItem(eventObj.dest.index);
					var type = eventObj.source.itemScope.modelValue;
					if (typeof type == "string") {
						var item = self.makeFormItem(type, self.fields[type]);
						item.editing = true;
						eventObj.dest.sortableScope.insertItem(eventObj.dest.index, item);
					}
				}
			}

			self.fieldsDragOptions = {
				containerPositioning: 'relative',
				containment:'.formbuilder-items',
				orderChanged: function (eventObj) {
					self.updateObjectValue();
				}
			}

			self.appendFormItem = function(type) {
				var item = self.makeFormItem(type, self.fields[type]);
				self.formitems.push(item);
				self.updateObjectValue();
			}

			self.cloneFormItem = function(index) {
				var olditem = angular.copy(self.formitems[index]);
				olditem.options.name = null;
				var item = self.makeFormItem(self.formitems[index].options.type, olditem);
				self.formitems.splice(index + 1, 0, item);
				self.updateObjectValue();
			}

			self.deleteFormItem = function(index) {
				self.formitems[index].stop_watching_options()
				self.formitems[index].stop_watching_values()
				self.formitems.splice(index, 1);
				self.updateObjectValue();
			}

			self.toggleEditing = function(item) {
				item.editing=!item.editing;
				if (!item.editing) {
					item.example_input = self.makeFormInput(item.form_type, 'default_value', item.options || {})
				}
			}

			// read write

			self.updateObjectValue = function() {
				var value = self.object[self.field.name] || []
				if (typeof value.length != "number") value = [];
				value.length = 0;
				for (var i=0; i<self.formitems.length; i++) {
					var item = self.formitems[i];
					var valueitem = item.options;

					if (valueitem.type == 'checkbox-group') {
						var formval = item.default_value;
						for (var v=0; v<valueitem.values.length; v++) {
							valueitem.values[v].selected = formval.indexOf(valueitem.values[v].value) != -1;
						}
					} else if (valueitem.type == 'radio-group' || valueitem.type == 'select') {
						var formval = item.default_value;
						for (var v=0; v<valueitem.values.length; v++) {
							valueitem.values[v].selected = valueitem.values[v].value == formval;
						}
					} else {
						valueitem.value = item.default_value;
					}

					value.push(valueitem); 
				} 
				self.object[self.field.name] = value;
			}

			self.readObjectValue = function() {
				var value = self.object[self.field.name] || [];
				if (typeof value.length != "number") value = [];
				self.formitems.length = 0;
				for (var i=0; i<value.length; i++) {
					var valueitem = value[i];
					var spec = angular.copy(self.fields[valueitem.type]);
					spec.options = valueitem;
					var item = self.makeFormItem(valueitem.type, spec);
					if (valueitem.type == 'checkbox-group') {
						var formval = [];
						for (var v=0; v<valueitem.values.length; v++) {
							if (valueitem.values[v].selected) formval.push(valueitem.values[v].value);
						}
						item.default_value = formval
					} else if (valueitem.type == 'radio-group' || valueitem.type == 'select') {
						var formval = null;
						for (var v=0; v<valueitem.values.length; v++) {
							if (valueitem.values[v].selected) formval = valueitem.values[v].value;
						}
						item.default_value = formval
					} else {
						item.default_value = valueitem.value
					}
					
					self.formitems.push(item)
				}
			}

			// controls lock bug fix (consider the fixed top bar)
			var fixedControls = 0;
			var itemsDiv = $element.find('.formbuilder-items');
			var toolboxDiv = $element.find('.formbuilder-toolbox');
			var topnavDiv = angular.element($window.document).find('#topnav');

			self.updateToolboxPosition = function () { 
				var offsetTop = angular.element($window).scrollTop();
				var scrollSpace = itemsDiv.height() - toolboxDiv.height();
				var fixedOffset = topnavDiv.height() + 20;
				var minOffsetTop = itemsDiv.offset().top - (topnavDiv.height() + 20);
				var maxOffsetTop = minOffsetTop + scrollSpace;

				if (scrollSpace <= 100) {
					return;   // do not fix toolbas for small distances
				}

				if (offsetTop < minOffsetTop || 
					toolboxDiv.parent().css('float') != 'left'   // kolumna jedna nad drugą - wąski ekran
				) {
					if (fixedControls != 1){
						toolboxDiv.css({
							'position': 'static',
							'left': 'auto',
							'top': 'auto',
							'width': 'auto',
							'margin-top': 0,
						});
						fixedControls = 1;
					} 
				} else if (offsetTop < maxOffsetTop) {
					if (fixedControls != 2){
						toolboxDiv.css({
							'position': 'fixed',
							'left': toolboxDiv.offset().left,
							'top': fixedOffset + 'px',
							'width': toolboxDiv.width() + 'px',
							'margin-top': 0,
						});
						fixedControls = 2;
					}
				} else {
					if (fixedControls != 3){
						toolboxDiv.css({
							'position': 'static',
							'left': 'auto',
							'top': 'auto',
							'width': 'auto',
							'margin-top': scrollSpace + 'px',
						});
						fixedControls = 3;
					}
				}
			}
			angular.element($window).bind("scroll resize", self.updateToolboxPosition)

			$scope.$on("$destroy", function handler() {
				// destruction code here
				angular.element($window).unbind("scroll resize", self.updateToolboxPosition)
			});

			$scope.$watch(function(){return self.object[self.field.name];}, self.readObjectValue);
			

		},
		controllerAs: '$fb'
	}
}



function FormViewField() {
	return {
		bindToController: {
			field: '<',
			object: '=fieldObject',
			errors: '<fieldErrors',
			readonly: '<',
		},
		controller: function($parse, $scope, FormService, $q, Classes, $timeout) {
			var self = this;
			
			self.Classes = Classes
			self.items = self.object[self.field.name];

			self.formFields = [];
			self.formValues = {};
			self.formLayout = ['survey-form'];
			self.formErrors = [];
			self.formLabelClass = (self.field.client? self.field.client.formLabelClass : null) || "text-left";
			self.formEditorClass = (self.field.client? self.field.client.formEditorClass : null) || "";

			self.convertFieldTypes = {
				'text': 'Field',
				'textarea': 'TextField',
				'number': 'IntField',
				'date': 'DateField',
				'select': 'FormSelectField',
				'checkbox-group': 'FormChecboxGroupField',
				'radio-group': 'FormRadioGroupField',
				'file': 'FormFilesField',
			}

			self.updateFormFieldsAndValues = function(formSettingsData) {
				if (!self.formValues.__parent) {  // na przyszłość do ew. ukrywania pól np. __parent.event.title
					Object.defineProperty(self.formValues, '__parent', {
						enumerable: false,
						configurable: true,
						writable: false,
						value: self.object
					});
				}
				var newFormFields = {};
				angular.forEach(formSettingsData, function(value, key) {
					if(self.convertFieldTypes[value.type]){
						var field = {
							//client:undefined,
							//default:undefined,
							description: 'test',
							editable:"true",
							groups:['survey-form'],
							name: value.name,
							required: value.required || false,
							title: value.label,
							type: self.convertFieldTypes[value.type],
							visible:"true",
							client: {
								description: value.description,
								placeholder: value.placeholder || ' ',
								options_inline: value.options_inline
							}
						}
						if(value.conditional && value.visible_reference && value.visible_value){
								field.visible = value.visible_reference + ".length ? " + value.visible_reference + ".indexOf('" + value.visible_value + "') != -1 : " + value.visible_reference + " == '" + value.visible_value + "'";
						}
						if (value.type == 'file') {
							field.client.multiple = value.multiple;
							field.client.max_file_size = value.max_file_size;
							field.client.max_files = value.max_files;
						}
						if (self.field.client && self.field.client.child_box_template_url) {
							field.client.box_template_url = self.field.client.child_box_template_url;
						}
						if(value.type == 'checkbox-group' || value.type == 'radio-group' || value.type == 'select'){
							var fieldDict = [];
							self.formValues[value.name] = value.type == 'checkbox-group' ? [] : null;
							for (var i = 0; i < value.values.length; i++) {
								fieldDict.push({
									value: value.values[i].value, 
									label: value.values[i].label
								});
								if (value.values[i].selected) {
									if (value.type == 'checkbox-group') self.formValues[value.name].push(value.values[i].value);
									if (value.type == 'radio-group' || value.type == 'select') self.formValues[value.name] = value.values[i].value;
								}
							}
							field.dictionary = fieldDict;
						}
						if (value.value) {
							self.formValues[value.name] = value.value;
						}

						newFormFields[key] = self.formFields[key] || {}
						_.merge(newFormFields[key], field)  // recursive overwrite
					}
					self.formFields = newFormFields;
				});
			}
			
			self.updateFormFieldsAndValues(self.object[self.field.name]);

			$scope.$watch(function(){return self.object[self.field.name]}, function(formSettingsData, old){
				self.items = formSettingsData;
				if (formSettingsData && formSettingsData !== old) {
					self.updateFormFieldsAndValues(formSettingsData);
				}
			}, true);

			if (!self.readonly) {
				$scope.$watch(function(){return self.formValues;}, function(formValues){
					// form was edited
					angular.forEach(self.object[self.field.name], function(value, key) {
						if(self.convertFieldTypes[value.type]){
							if(value.type == 'checkbox-group'){
								for (var i = 0; i < value.values.length; i++) {
									value.values[i].selected = formValues[value.name].indexOf(value.values[i].value) >= 0;
								}
							} else if (value.type == 'radio-group' || value.type == 'select') {
								for (var i = 0; i < value.values.length; i++) {
									value.values[i].selected = formValues[value.name] == value.values[i].value;
								}
							} else {
								value.value = formValues[value.name];
							}
						}
					});
				}, true);

				$scope.$watch(function(){return self.errors ? self.errors[self.field.name] : null}, function(errors) {
					self.formErrors = {}
					for (var key in errors) {
						var fname = self.object[self.field.name][key].name;
						self.formErrors[fname] = errors[key];
					}
				})
			}
			


			// TODO: fieldErrors
	
		},
		controllerAs: '$form'
	}
}

function FormBuilderCheckboxGroup() {
	return {
		bindToController: {
			field: '<',
			object: '=fieldobject',
		},
		controller: function($parse, $scope) {
			var self = this;
			this.items = [];
			
			self.object[self.field.name] = self.object[self.field.name] || [];
			
			self.updateItems = function(){
				self.items.length = 0;
				for (var i=0; i<self.field.dictionary.length; i++) {
					var item = self.field.dictionary[i];
					if (self.object[self.field.name].indexOf(item.value) != -1) {
						item.selected = true;
					}
					self.items.push(item);
				}
			}
			$scope.$watchCollection(function(){return self.field.dictionary}, self.updateItems);

			$scope.$watch(function() { 
				return _.map(self.items, function(o){
						return {
							label:o.label,
							selected:o.selected,
							value:o.value
						}
					}
				)
			}, function(newValue, oldValue) {
				if (newValue == oldValue) return;
				self.object[self.field.name].length = 0;
				for (var i in self.items) {
					var item = self.items[i];
					if (item && item.selected) {
						self.object[self.field.name].push(item.value);
					}
				}
			}, true);
		},
		controllerAs: '$formBuilderCheckboxGroup'
	}
}

function FormFilesField($q) {
	return {
		require: ['ngModel', '^^?fieldBox'],
		link: function($scope, element, attrs, controllers) {
			var ngModel = controllers[0];
			var fieldBox = controllers[1];
			var self = {};
			ngModel.$setViewValue(ngModel.$viewValue || [])
			
			var slice = Array.prototype.slice;
	
			self.message = null;
			self.busy = false;
			self.items = [];
			self.invalidFiles = [];
			self.invalidItems = [];

			self.readFile = function (file) {
				var deferred = $q.defer();

				var reader = new FileReader()
				reader.onload = function(e){
					deferred.resolve({
						mime: file.type,
						filename: file.name,
						data: e.target.result,
						title: file.name
					});
				}
				reader.onerror = function(e) {
					deferred.reject(e);
				}
				reader.readAsDataURL(file);

				return deferred.promise;
			}
			
			self.uploadFiles = function(files) {
				self.is_busy = true;
				fieldBox.setFieldState('busy', 'Reading files');  // invisible error - wait for files to be read, but stop form from sending
				return $q.all(slice.call(files, 0).map(self.readFile)).then(function(values){
					ngModel.$setViewValue(values);
					[].push.apply(self.items, values);
					self.is_busy = false;
					fieldBox.setFieldState('valid', null);
					delete fieldBox.errors[fieldBox.field.name];
				}).catch(function(e){
					self.message={type:'danger', body:e}
					self.is_busy = false;
					if (fieldBox) {
						fieldBox.errors[fieldBox.field.name] = 'Error while reading file: ' + e;
						fieldBox.setFieldState('invalid', 'Error while reading file: ' + e);
					}
				});
			}

			$scope.$watch(function(){return self.invalidFiles}, function(currval) {
				self.invalidItems.length = 0;
				if (currval.$error) {
					self.invalidItems.push(currval);
				} else if (currval.length) {
					[].push.apply(self.invalidItems, currval);
				}
				if (self.invalidItems.length) {
					fieldBox.errors[fieldBox.field.name] = 'Some files are invalid';
					fieldBox.setFieldState('invalid', 'Some files are invalid');
				} else {
					fieldBox.setFieldState('valid', null);
					delete fieldBox.errors[fieldBox.field.name];
				}
			})

			self.remove = function(obj) {
				for (var i in self.items) {
					if (self.items[i] === obj) {
						self.items.splice(i, 1);
						break;
					}
				}
				for (var i in self.invalidItems) {
					if (self.invalidItems[i] === obj) {
						self.invalidItems.splice(i, 1);
						break;
					}
				}
			}

			ngModel.$render = function() {
				self.items = ngModel.$modelValue;
			};

			$scope.$formFiles = self;
		},
	}
}

angular.module('forms.fields.formbuilder', [])
.directive('formBuilderField', FormBuilderField)
.directive('formViewField', FormViewField)
.directive('formBuilderCheckboxGroup', FormBuilderCheckboxGroup)
.directive('formFilesField', FormFilesField);



function TinymceHelper($parse, $translate, $timeout, $filter) {
	return {
		bindToController: {
			field: '<',
			object: '=fieldObject',
		},
        controller: function($scope, LocaleService, Classes, $cookies) {
            var self = this
            
            this.tinymceOptions = {
                plugins: 'autolink autoresize code contextmenu fullscreen image link lists media paste table textcolor colorpicker visualblocks visualchars',
                toolbar: 'undo redo | bold italic forecolor backcolor | alignleft aligncenter alignright numlist bullist table | image link media | code fullscreen',
                autoresize_max_height: 500,
                autoresize_bottom_margin: 25,
                //language: LocaleService.getLocale().replace(/([a-z]*)_[A-Z]*/, '$1'),
                language_url: 'bower_components/tinymce/langs/' + LocaleService.getLocale().replace(/([a-z]*)_[A-Z]*/, '$1') + '.js',  // suport useref, minify
                inline: true,
                browser_spellcheck: true, /* contextmenu: false */
                skin_url: 'bower_components/tinymce/skins/lightgray',  // suport useref, minify
                table_class_list: [
                    {title: 'None', value: ''},
                    {title: 'Default', value: 'table'},
                    {title: 'Condensed', value: 'table table-condensed'},
                    {title: 'Bordered', value: 'table table-bordered'},
                    {title: 'Striped', value: 'table table-striped'},
                    {title: 'Bordered Striped', value: 'table table-striped table-bordered'},
                ],
                table_responsive_width: true,   // force % size

                paste_data_images: true,  // allow image dnd, paste in Word
                paste_enable_default_filters: true,  // to enable valid_elements
                /*paste_word_valid_elements: "@[style],-strong/b,-em/i,-span,-p,-ol,-ul,-li,-h1,-h2,-h3,-h4,-h5,-h6," +
                    "-table[border|cellspacing|cellpadding|frame|rules|align|summary|style|class],"+
                    "-tr[rowspan|align|valign|style],tbody,thead,tfoot,#td[colspan|rowspan|align|valign|scope|style],"+
                    "#th[colspan|rowspan|align|valign|scope|style],-a[href|title],img[src|title|alt|class],sub,sup,strike,caption,br",
                */
                paste_word_valid_elements: "-strong/b,-em/i,-p,-ol,-ul,-li,-h1,-h2,-h3,-h4,-h5,-h6," +
                    "-table[align|summary|class:table],"+
                    "-tr[rowspan|align|valign],tbody,thead,tfoot,#td[colspan|rowspan|align|valign|scope],"+
                    "#th[colspan|rowspan|align|valign|scope],-a[!href|title],img[src|title|alt|class|width|height],sub,sup,strike,caption,br",
                
                paste_preprocess: function(plugin, args) {
                    args.content = args.content.replace(/<!--[\s\S]*?-->/g, '');
                    args.content = args.content.replace(/<!\[[^>]*\]>/g, '');
                },
                file_picker_types: 'image',  // file image media

                relative_urls: false,
                images_reuse_filename: true,
                // basic upload handler - automatick for local media
                images_upload_handler: self.field.client.image_class ? function (blobInfo, success, failure) {
                    var xhr, formData;
                
                    xhr = new XMLHttpRequest();
                    xhr.withCredentials = false;
                    xhr.open('POST', Classes[self.field.client.image_class].ApiRootPath + '/upload');
                    xhr.setRequestHeader('X-XSRF-TOKEN', $cookies.get('XSRF-TOKEN'))
                
                    xhr.onload = function() {
                      var json;

                      json = JSON.parse(xhr.responseText);
                
                      if (!json || typeof json.location != 'string') {
                        if (xhr.status != 200) {
                            failure('HTTP Error: ' + xhr.status);
                        } else {
                            failure('Invalid JSON: ' + xhr.responseText);
                        }
                        return;
                      }
                
                      if (xhr.status != 200) {
                        failure('Upload error: ' + (json.message || 'Unknown error'));
                        return;
                      }
                
                      success(json.location);
                    };
                
                    formData = new FormData();
                    formData.append('file', blobInfo.blob(), blobInfo.blob().name || blobInfo.filename());
                
                    xhr.send(formData);
                } : null,

                // local file picker
                file_picker_callback: function(cb, value, meta) {
                    var input = document.createElement('input');
                    input.setAttribute('type', 'file');
                    input.setAttribute('accept', 'image/*');
                    
                    // Note: In modern browsers input[type="file"] is functional without 
                    // even adding it to the DOM, but that might not be the case in some older
                    // or quirky browsers like IE, so you might want to add it to the DOM
                    // just in case, and visually hide it. And do not forget do remove it
                    // once you do not need it anymore.
                
                    input.onchange = function() {
                      var file = this.files[0];
                      
                      var reader = new FileReader();
                      reader.onload = function () {
                        // Note: Now we need to register the blob in TinyMCEs image blob
                        // registry. In the next release this part hopefully won't be
                        // necessary, as we are looking to handle it internally.
                        // var id = 'blobid' + (new Date()).getTime();
                        var id = file.name || ('blobid' + (new Date()).getTime());
                        var blobCache =  tinymce.activeEditor.editorUpload.blobCache;
                        var base64 = reader.result.split(',')[1];
                        var blobInfo = blobCache.create(id, file, base64);
                        blobCache.add(blobInfo);
                
                        // call the callback and populate the Title field with the file name
                        cb(blobInfo.blobUri(), { title: file.name });
                      };
                      reader.readAsDataURL(file);
                    };
                    
                    input.click();
                  }
            }
            
        },
        controllerAs: '$tinymcehelper'
    }
}

angular.module('forms.fields.html.medium', ['angular-medium-editor'])
;
angular.module('forms.fields.html.tinymce', ['ui.tinymce'])
.directive('tinymceHelper', TinymceHelper)
;


var admin = angular.module('admin', [
	'forms',
	//'forms.fields.position',   // requires 'uiGmapgoogle-maps'
    'forms.fields.daterange',
    'forms.fields.datelist',
	'forms.fields.tags',
	'admin.dialogs',
	"persistent",
	'ui.router',
	'ui.bootstrap',
	'ui.select',
	'monospaced.elastic',  // textarea autoresize
	'angularFileUpload',
	'ngFileUpload',  // (backreference) TODO choose one :)
	'angular-loading-bar'
])


angular.module('admin')
	.value('LoginFile', 'start.php')
	.service('LoginService', function(CurrentUser, LoginFile, $location, $browser) {
		this.requireUser = function() {
			// unauthenticated - redirect to login
			if (!CurrentUser.isLoggedIn()) {
				this.redirectToLogin();
			}
		}

		this.redirectToLogin = function(){
			if ($location.$$html5) {
				var base_href = $browser.baseHref()
				var current_location = window.location.href.substr(base_href.length);
				window.location = LoginFile + '/login/back/' + encodeURIComponent(current_location.replace(/\//g, '~'));
			} else {
				if (location.hash) {
					var current_location = location.href.replace(/^[^#]*\//, '')
					window.location = LoginFile + '#/login/back/' + encodeURIComponent(current_location.replace(/\//g, '~'));;
				} else {
					window.location = LoginFile
				}
			}
		}
	})
		
    // admin musi mieć usera
	.run(function(LoginService){
		// unauthenticated - redirect to login
		LoginService.requireUser()
		
	})
	.run(function($rootScope, FieldTplDir) {
		$rootScope.fieldTplDir = FieldTplDir;
	})
	.run(function($rootScope) {
		$rootScope.defaultCurrency = 'PLN';
	})
	// reemit events scripts/core/controller/mainController.js
	.run(function($rootScope, pinesNotifications, LoginService){
		$rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams){
	  		console.log('$stateChangeStart');
	  		// could start angular-loading-bar or skylo
	  		$rootScope.$broadcast('$routeChangeStart');
		})
		$rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams){
			console.log('$stateChangeSuccess');
			// could stop angular-loading-bar or skylo
	  		$rootScope.$broadcast('$routeChangeSuccess');
		})
		$rootScope.$on('$stateChangeError', function(event, toState, toParams, fromState, fromParams, error){
			console.log('$stateChangeError', toState, toParams, fromState, fromParams, error);
			// could stop angular-loading-bar or skylo
	  		$rootScope.$broadcast('$routeChangeError');
			pinesNotifications.notify({
			    title: 'An error occured while loading the object',
			    text: error.data? error.data.message: error,
			    type: 'error'
			});
			// on unauthorized error => redirect to login
			if (error.data && error.data.code == 401) {
				LoginService.redirectToLogin();
			}
		})
		$rootScope.$on('$stateNotFound', function(event, unfoundState, fromState, fromParams){ 
		    console.log('$stateNotFound', unfoundState); // "lazy.state"
		})
		
		$rootScope.$on('unauthorized', function() {
			LoginService.redirectToLogin();
		});
	})
	.config(function(cfpLoadingBarProvider) {
		cfpLoadingBarProvider.includeSpinner = false;
		cfpLoadingBarProvider.latencyThreshold = 600;
	})
	
	
	.config(function ($stateProvider) {
		// Use $stateProvider to configure your states.
		// see http://angular-ui.github.io/ui-router/sample/app/contacts/contacts.js
		$stateProvider

        ////////////
        // Module //
        ////////////
        
        .state("module", {
			// With abstract set to true, that means this state can not be explicitly activated.
			// It can only be implicitly activated by activating one of its children.
			abstract: true,
			
			// This abstract state will prepend '/objects/<page>' onto the urls of all its children.
			url: '/objects/{page:[a-zA-Z_\-]+}',
			
			//templateUrl: 'framework/partials/admin/module.html', 
			template: '<ui-view>', 
			
			resolve: {
				ListContext: function(ContextService, $stateParams){return ContextService.getContext($stateParams.page)},
			}
		})
		
		// Using a '.' within a state name declares a child within a parent.
        // So you have a new state 'list' within the parent 'module' state.
		.state("module.list", {
			url: '',  // this will become /objects/<page>, becouse it is parent's "objects/<page>" + ''
			resolve:  {
				BaseFilter: function(ListContext){return ListContext.fetchBaseFilter();}
			},
			// IMPORTANT: Now we have a state that is not a top level state. Its
			// template will be inserted into the ui-view within this state's
			// parent's template; so the ui-view within module.html. This is the
			// most important thing to remember about templates.
			templateProvider: function(ListContext, $templateFactory){ 
				return $templateFactory.fromUrl(ListContext.config.listTemplateUrl || 'framework/partials/admin/list.html'); 
			},
			//controller: 'ModuleListController as mCtrl',
			// instantiale configured controller
			/*
			controller: function($controller, $scope, ListContext, BaseFilter) {
				var ctrl = $controller(ListContext.config.controller, {$scope:$scope, ListContext:ListContext, BaseFilter:BaseFilter});
				$scope[ListContext.config.controllerAs] = ctrl;
			},
			*/
			controllerProvider: function(ListContext) {
				// injectable provider that return the controller or a string
				var controller = ListContext.config.listController || 'ModuleListController';
				var controllerAs = ListContext.config.listControllerAs || 'mCtrl';
				return controller + ' as ' + controllerAs;
			}
		})
		
		.state("module.create", {
			//url: '/new/:parentClass/:parentVid',  
			url: '/:parentVid/:refClass/new',  
			//templateUrl: 'framework/partials/admin/object-create.html',
			templateProvider: function(ListContext, $templateFactory){ 
				return $templateFactory.fromUrl(ListContext.config.createTemplateUrl || 'framework/partials/admin/object-createform.html'); 
			},
			params: {
				refClass: {
					value: null,
					squash: true
				},
				parentVid: {
					value: null,
					squash: true
				},
				defaults: {
					value: null  // optional object with default values
				}
			},
			resolve:  {
				ListContext: function(ListContext, $stateParams) {
					if ($stateParams.refClass == '$clone') {
						return ListContext;
					} else if ($stateParams.refClass) {
						return ListContext.getInstance($stateParams.parentVid).fetch().then(function(parent) {;
							return ListContext.getReferencedContext(parent, $stateParams.refClass);
						});
					} else {
						return ListContext;
					}
				},
				Object: function(ListContext /* this is the new peer-defined ListContext */, $stateParams){
					if ($stateParams.refClass == '$clone') {
						var original = ListContext.getInstance($stateParams.parentVid);
						return ListContext.cloneInstance(original);
					} else {
						return ListContext.fetchNewInstance($stateParams.defaults)
					}
				},
				createMode: function($stateParams) {return $stateParams.refClass == '$clone'? '$clone': true},
				ModesAllowed: function(Object, ListContext){
					return {
						info: false,
						edit: true,
						hist: false,
					}
				},
				Mode: function(){return 'edit';}
			},
			/*
			// prowizoryczny kontroler
			controller: 'ObjectPanelController',
			controllerAs: 'oCtrl'
			*/
			controllerProvider: function(ListContext) {
				// injectable provider that return the controller or a string
				var controller = ListContext.config.createController || 'ModuleObjectController';
				var controllerAs = ListContext.config.createControllerAs || 'mCtrl';
				return controller + ' as ' + controllerAs;
			}
		})

		.state("module.import", {
			url: '/import/:preset',  
			templateProvider: function(ListContext, $templateFactory){ 
				return $templateFactory.fromUrl(ListContext.config.importTemplateUrl || 'framework/partials/admin/object-import.html'); 
			},
			params: {
				preset: {
					value: 'default',
					squash: true
				}
			},
			resolve:  {
				ListContext: function(ListContext, $stateParams) {
					if ($stateParams.refClass) {
						return ListContext.getInstance($stateParams.parentVid).fetch().then(function(parent) {
							return ListContext.getReferencedContext(parent, $stateParams.refClass);
						});
					} else {
						return ListContext;
					}
				},
				TemplateObject: function(ListContext /* this is the new peer-defined ListContext */, $stateParams){
					return ListContext.fetchNewInstance($stateParams.defaults)
				},
			},
			controllerProvider: function(ListContext) {
				// injectable provider that return the controller or a string
				var controller = ListContext.config.createController || 'ModuleImportController';
				var controllerAs = ListContext.config.createControllerAs || 'mCtrl';
				return controller + ' as ' + controllerAs;
			}
		})
		
		.state("module.detail", {
			url: '/{vid:[^/]+}/{mode:[^/]+}',
			params:{
				mode: 'info',
			},
			//templateUrl: 'framework/partials/admin/object.html',
			resolve:  {
				ListContext: function(ListContext, $stateParams) {
					// apply effective time
					if ($stateParams.vid.match(/:/)) {
						var effective_time = $stateParams.vid.replace(/^[^:]*:/, '');
						return ListContext.withEffectiveTime(effective_time);
					} else {
						return ListContext;
					}
				},
				Object: function(ListContext, $stateParams){
					return ListContext.getInstance($stateParams.vid).fetch(false, ListContext.config.fetchLevel || 1);
				},
				createMode: function() {return false},
				ModesAllowed: function(Object, ListContext, $injector){
					var tabs = ListContext.getTabs();
					var modes = {}
					for (var t in tabs) {
						modes[tabs[t].name] = $injector.invoke(tabs[t].enabled, null, {Object:Object,Config:ListContext.config});;
					}
					var inline = ListContext.getRefs('inline');
					for (var k in inline) {
						modes[inline[k].name] = typeof inline[k].enabled == "function"? $injector.invoke(inline[k].enabled, null, {Object:Object,Config:ListContext.config}) : true;
					}
					return modes;
				},
				Mode: function(ModesAllowed, $stateParams){
					if (ModesAllowed[$stateParams.mode]) {
						return $stateParams.mode;
					} else {
						if (ModesAllowed.info) return 'info';
						if (ModesAllowed.edit) return 'edit';
						if (ModesAllowed.hist) return 'hist';
					}
				},
			},
			/*
			// prowizoryczny kontroler
			controller: 'ObjectPanelController',
			controllerAs: 'oCtrl'
			*/
			templateProvider: function(ListContext, $templateFactory){ 
				return $templateFactory.fromUrl(ListContext.config.objectTemplateUrl || 'framework/partials/admin/object.html'); 
			},
			controllerProvider: function(ListContext) {
				// injectable provider that return the controller or a string
				var controller = ListContext.config.objectController || 'ModuleObjectController';
				var controllerAs = ListContext.config.objectControllerAs || 'mCtrl';
				return controller + ' as ' + controllerAs;
			}
		})
		
		.state("module.detail.tab", {
			url: '/{tab:[^/]+}',
			resolve: {
				ListContext: function(ListContext, Object, $stateParams){return ListContext.getReferencedContext(Object, $stateParams.tab)},
				BaseFilter: function(ListContext) {return ListContext.fetchBaseFilter()}  // tODO
			},
			templateProvider: function(ListContext, $templateFactory){ 
				return $templateFactory.fromUrl(ListContext.config.tabTemplateUrl || 'framework/partials/admin/tab-list.html'); 
			},
			controllerProvider: function(ListContext) {
				var controller = ListContext.config.listController || 'ModuleListController';
				var controllerAs = ListContext.config.listControllerAs || 'tCtrl';
				return controller + ' as ' + controllerAs;
			}
		})
		

	})



angular.module('admin')
.directive('fieldValue', function(FieldTplDir) {
	return {
		template: '<span ng-if="object.__perms[field.viewperm]" ng-include="\''+FieldTplDir+'field-view-\'+(field.client.widget.toLowerCase()||field.type.toLowerCase())+\'.html\'"></span>' + 
		          '<span ng-if="!object.__perms[field.viewperm]"><i class="fa fa-eye-slash"></i></span>',
		restrict: 'EA',
		/*scope: {
			aliases: '=*fieldValue',  // https://docs.angularjs.org/api/ng/service/$compile - =* shallow watch	
		},*/
		scope: {
    		compact: '=*compact',
    		object: '=*object',
    		field: '=*fieldValue'
    	},
		priority: 1,
		link: function(scope, element, attrs){
			scope.fieldTplDir = FieldTplDir;
		}
	}
	/**/ 
})
.directive('fieldEditor', function(FieldTplDir) {
	return {
		template: '<span ng-include="\''+FieldTplDir+'field-edit-\'+field.type.toLowerCase()+\'.html\'"></span>',
		restrict: 'A',
		scope: {
			aliases: '=*fieldEditor',  // https://docs.angularjs.org/api/ng/service/$compile - =* shallow watch	
		},
		priority: 1,
		link: function(scope, element, attrs){
			//console.log(scope.aliases);
			angular.extend(scope, scope.aliases);
		},
		controller: function($scope) {
			$scope.$watchCollection($scope.aliases, function(locals) {
				angular.extend($scope, $scope.aliases);
			});
		}
	}
})




angular.module('admin')
.directive('eatClick', function() {
    return function(scope, element, attrs) {
        $(element).click(function(event) {
            event.preventDefault();
            event.stopPropagation();
        });
    }
});



angular.module('admin')
.directive('onEnter',function(){
	return function(scope,element,attrs) {
		element.bind("keypress", function(event) {
			if(event.which === 13) {
				scope.$apply(attrs.onEnter);
				event.preventDefault();
			}
		});
	}
});




angular.module('admin')

/* 
 * Tworzenie fragmentu witryny tak jakby użyć stanu module.detail.tab
 * params
 * load-module="name or id" - specyfikacja modułu do załadowania
 * parent-context="mCtrl.ListContext" - obiekt jako kontekst
 * parent-object="mCtrl.Object" - obiekt jako kontekst
 */ 
.directive('loadModule', function(ContextService, $controller) {
	return {
		template: '<div class="v-grow" ng-include="loadModuleTemplateUrl"></div>',
		restrict: 'EA',
		scope: true,
		link: function(scope, element, attrs){
			//console.log(scope.aliases);
			var tab_name = scope.$eval(attrs.loadModule);
			var ParentObject = scope.$eval(attrs.parentObject);
			var ParentContext = scope.$eval(attrs.parentContext);
			if (ParentContext && ParentObject) {
				var ListContext = ParentContext.getReferencedContext(ParentObject, tab_name)
			} else {
				var ListContext = ContextService.getContext(tab_name)
			}
			if (!ListContext) throw "No module for load-module";
			
			var controller = ListContext.config.listController || 'ModuleListController';
			var controllerAs = ListContext.config.listControllerAs || 'tCtrl';
			var templateUrl = ListContext.config.tabTemplateUrl || 'framework/partials/admin/tab-list.html'
			
			ListContext.fetchBaseFilter().then(function(BaseFilter){
				var ctrl = $controller(controller, {$scope:scope, ListContext:ListContext, BaseFilter:BaseFilter});
				scope[controllerAs] = ctrl;
				scope.loadModuleTemplateUrl = templateUrl;
				console.log('loaded', ListContext);
			}); 

			
		}
		
	}
	/**/ 
})



// <div local-controller='MainController as mc' locals='{x: "test", y: 42}'></div>


angular.module('admin')
.directive('localController', function($controller) {
  return {
    scope: true,
    priority: 10,
    link: {
    	pre: function(scope, elem, attrs) {
	      var locals = scope.$eval(attrs.locals);
	      angular.extend(locals, {$scope: scope});
	      var ctrlas = attrs.localController.split(/ +as +/)
	      var ctrl = $controller(ctrlas[0], locals);
	      scope[ctrlas[1]] = ctrl;
				if (attrs.localControllerInit) {scope.$eval(attrs.localControllerInit);}
	      console.log('localController', ctrlas[1], ctrl);
	    }
	}
  };
});

angular.module('admin')

.directive('saveElementHeight', function($rootScope, $timeout) {
    return function(scope, element, attrs) {
    	$rootScope.elementHeight = $rootScope.elementHeight || {};
    	var updateTimeout = null;
		var update = function(){
			//$rootScope.elementHeight[attrs.saveElementHeight] = element.is(':visible')? element.outerHeight(true) : 0;
			if (element.hasClass('ng-hide') || element.closest('.ng-hide').length) {
				// elementy ukryte przez angular
				$rootScope.elementHeight[attrs.saveElementHeight] = 0;
			} else if (element.is(':visible')) {  // sprawdzanie, czy element jest w DOM (casem nie jest nie wiedzieć czemu i height => 0)
				$rootScope.elementHeight[attrs.saveElementHeight] = element.outerHeight();
			}
			$rootScope.elementHeight['window'] = $(window).height();
			$rootScope.elementHeight['$max'] = Math.max;
			$rootScope.elementHeight['$min'] = Math.min;
		}
		var applyUpdate = function (){$timeout.cancel(updateTimeout); updateTimeout = $timeout(update);}
		angular.element(window).bind('resize', applyUpdate);  // update on window resize
		angular.element(window).bind('click', function(){/*update();*/applyUpdate()});  // update on click
		//scope.$watch(update);                                 // update every digest
		update();                                             // update now
		//$interval(update, 500);
	}
})

.directive('setElementHeight', function($rootScope) {
    return function(scope, element, attrs) {
    	var evalHeight = function() {
    		return scope.$eval(attrs.setElementHeight, $rootScope.elementHeight);
    	}
    	$rootScope.$watch(evalHeight, function(h) {
    		if (h !== null) {
    			element.height(h);
    			//element.css({minHeight: h});
    		}
    	});
	}
})

.directive('setElementMinHeight', function($rootScope) {
    return function(scope, element, attrs) {
    	var evalHeight = function() {
    		return scope.$eval(attrs.setElementMinHeight, $rootScope.elementHeight);
    	}
    	$rootScope.$watch(evalHeight, function(h) {
    		if (h !== null) {
    			element.css({minHeight: h});
    		}
    	});
	}
})

.directive('checkNavButtonCollapse', function($timeout) {
	return {
		restrict: 'A',
        link: function(scope, element, attrs){
			var last_nav_options_collapse_width = 0;
			var do_collapse = false;
			var checkCollapse = function(){

				// container width
				var nav_container_width = element.width();
				
				// all btns width
				if (!do_collapse) {
					var nav_options_width = 0;
					angular.forEach(element.find('li'), function(value, key) {
						nav_options_width += $(value).outerWidth(true);
					});
				} else {
					nav_options_width = last_nav_options_collapse_width;
				}
				
				if(nav_container_width <= nav_options_width){
					last_nav_options_collapse_width = nav_options_width;
					do_collapse = true;
				}else{
					do_collapse = nav_container_width < last_nav_options_collapse_width
				}
				return do_collapse;
			}
			var update = function() {
				scope[attrs.collapse] = checkCollapse();
			}
			var updateTimeout = null;
			var applyUpdate = function (){$timeout.cancel(updateTimeout); updateTimeout = $timeout(update);}
        	angular.element(window).bind('resize', applyUpdate);  // update on window resize
			angular.element(window).bind('click', function(){applyUpdate()});  // update on click
			updateTimeout = $timeout(update); 

        }//link

    };//return
})



angular.module('admin')
.controller('WorkflowBoxController', function() {
	var self = this;
	
})
.directive('workflowbox', function(FormService, CurrentUser) {
    return {
    	templateUrl: 'framework/partials/admin/field-workflowbox.html',
    	scope: {
    		object: '=*',
    		reload: '&',
    		field: '=',  // workflow field
    	},
    	bindToController: true,
    	controller: function($scope, $translate, FormService) {
    		var self = this;
    		this.states = null;
    		this.transitions = null;
    		this.Object = this.object;
    		
    		/*self.Object[self.field.name + '__states']().then(function(states){
				self.states = states;
			});*/
			self.states = self.field.dictionary;
    		
    		$scope.$watch(function(){return self.Object.rec_id}, function() {
    			if (!self.Object || !self.Object.id) return;
				
				self.Object[self.field.name + '__transitions']().then(function(transitions){
					self.transitions = transitions;
				});
				
			});		
    		this.make = function(transition) {
    			console.log('make', transition);
    			var t = transition;
    			var formdata = this.Object.getClass().getObjectPayload(this.Object);
				formdata.target = t.target;
    			//var formdata = {target: t.target};
    			var form = {
    				title:t.name, 
					btn:t.name, 
    				prompt: $translate.instant('Are you sure you want to transition to:') + ' ' + $translate.instant(t.target_name) + '?', 
    				params: t.params? self.Object.get_form_params(t.params) : [],
					layout: [['edit']],
					submit: function(data) {
						return self.Object[self.field.name + '__state'](data).then(function(result){
							return self.reload({}).then(function(){return result;});
						});
					}
    			};
    			
    			var form = FormService.activateFormModal(form, formdata);
    		}
    		

			// do we need this?
    		this.hasPerm = function(permissions) {
    			var user = CurrentUser.instance;
    			if (typeof permissions === "string") permissions = [permissions];
    			for (var i=0; i<=permissions.length; i++) {
    				if (self.Object.__perms && self.Object.__perms[permissions[i]]) {
    					return true;
    				}
    			}
    			return false;
    		}
    		
    		window.$workflowscope = $scope;
    	},
    	controllerAs: 'workflow',
    }
})



angular.module('admin')
.directive('dictNav',function(){
	return function(scope,element,attrs) {
		var self = {};
		var KEYUP = 38; 
		var KEYDOWN = 40; 
		var KEYTAB = 9;
		self.selectedItem = null;
		element.bind("keydown", function(event) {
			options = element.find('ul li');
			if(event.which === 13 || event.which === KEYTAB) {
				if (options.length > 0) {
					if (!self.selectedItem) self.selectedItem = 0;
				}
				if (self.selectedItem !== null) {
					options.eq(self.selectedItem).find('[ng-click]').click();
				}
				event.preventDefault();
			} else if (event.which === KEYUP) {
				if (self.selectedItem === null) {
					self.selectedItem = self.options.length - 1;
				} else {
					self.selectedItem -= 1;
					if (self.selectedItem == -1) self.selectedItem = options.length - 1;
				}
				//console.log(options, self.selectedItem);
				options.eq(self.selectedItem).addClass('active').siblings().removeClass('active');
				options.eq(self.selectedItem)[0].scrollIntoView();
			} else if (event.which === KEYDOWN) {
				if (self.selectedItem === null) {
					self.selectedItem = 0;
				} else {
					self.selectedItem += 1;
					if (self.selectedItem >= options.length) self.selectedItem = 0;
				}
				options.eq(self.selectedItem).addClass('active').siblings().removeClass('active');
				options.eq(self.selectedItem)[0].scrollIntoView();
			} else {
				self.selectedItem = null;
				options.removeClass('active');
			}
			console.log(self.selectedItem);
		});
	}
});


angular.module('admin')
.directive('widgetMultiDictionary', function() {
    return {
    	templateUrl: 'partials/fields/widget-multi-dictionary.html',
    	scope: {
    		dictionary: '=',
    	},
    	require: 'ngModel',
    	bindToController: true,
    	link: function (scope, elem, attrs, ngModel) {
			var ctrl = scope.widget; //add this 
			ctrl.modelCtrl = ngModel; 
			ctrl.init()
		},
    	controller: function($scope, $translate) {
    		var self = this;
    		
    		this.pairs = [];
    		this.values = [];
    		this.init = function() {
    			self.modelCtrl.$isEmpty = function(val) {
					return val == null || (val.length == 0);
				};
				self.modelCtrl.$render = function() {
					if (!self.modelCtrl.$modelValue) {
						self.values = [];
					}
					self.values = self.modelCtrl.$modelValue
				};
    		}
    		
    		$scope.$watchCollection(function(){return self.dictionary},function(){
    			self.pairs.length = 0;
    			if (!self.dictionary) return;
    			if (self.dictionary.length) {
    				for (var i in self.dictionary) {
    					var item = self.dictionary[i];
    					if (item.length == 2) {
    						self.pairs.push(item);
    					}
    					if (item.__id) {
    						self.pairs.push([item.__id, item.__title]);
    					}
    				}
    			} else {
    				for (var key in self.dictionary) {
    					self.pairs.push([key, self.dictionary[key]]);
    				}
    			}
    		})
			
			// field.dictionary może mieć postać {a: "b"} lub [["a","b"]]. 
			// Potrzebujemy tą pierwszą do przerabiania value => title w widokach.
			this.dictionaryAsMap = function(dict) {
				if (dict.length) {
					var ret = {};
					for (var i=0; i<dict.length; i++) {
						ret[dict[i][0]] = dict[i][1];
					}
					return ret;
				} else {
					return dict;
				}
			}
			
			this.titleForKey = function(key) {
				var dict = self.dictionaryAsMap(self.pairs);
				if (typeof key == "string" || typeof key == "number") {
					return dict[key];
				} else {
					var titles = [];
					for (var i=0; i<key.length; i++) {
						titles.push(dict[key[i]]);
					}
					return titles.join(', ');
				}
			}
			
			this.toggleOption = function(option) {
				var pos = self.values.indexOf(option);
				if (pos >= 0) {
					self.values.splice(pos,1);
				} else {
					self.values.push(option);
				}
				self.modelCtrl.$setViewValue(self.values);
				self.modelCtrl.$setDirty();
				return self.values;
			}
			
			this.clear = function() {
				self.values = self.values || [];
				self.values.length = 0;
				self.modelCtrl.$setViewValue(self.values);
				self.modelCtrl.$setDirty();
			}
			
			this.hasOption = function(option) {
				return (self.values||[]).indexOf(option) >= 0;
			}

    		
    		
    	},
    	controllerAs: 'widget',
    }
})


// Enables links to files to be dragged out from browser to explorer

angular.module('admin')
.directive('dragout', function() {
	return {
        restrict: 'A'
        , scope: { 'dragout': '@' }  // interpolated
        , link: function(scope, element, attrs){
            
        	var rawelem = element.get(0);
			if (!rawelem.addEventListener) {
				console.debug('Dragout: no addEventListener');
				return;
			}
			rawelem.addEventListener('dragstart', function(evt){
				//console.debug('dragstart', scope.dragout, evt);
				if (scope.dragout && evt.dataTransfer) {
					//console.debug('DownloadURL', scope.dragout);
					evt.dataTransfer.setData("DownloadURL", scope.dragout);
				} else if (scope.dragout) {
					console.debug('Dragout: evt.dataTransfer not supported');
				}
			}, false);

        }//link

    };//return
})


angular.module('admin')
.filter('shorttime', function () {
    return function(text) {
    	if (typeof text != 'string') return text;
        return text.replace(/(\d\d:\d\d):\d\d(?:\.\d*)/g, '$1');
    }
})


angular.module('admin')
.factory('scrollTo', function() {
	return function(x,y) {
		window.scrollTo(x,y);
	}
});



angular.module('admin')
.factory('pinesNotifications', ['$window', function ($window) {
    'use strict';
    return {
      notify: function (args) {
        args.mouse_reset = false;
        var notification = new $window.PNotify(args);
        notification.notify = notification.update;
        return notification;
      },
    };
  }]);
  


(function(){
/*
 * Obiekt konfigurujacy listy obiektów i ekrany szczegółów obiektów
 * Wpływa na takie elementy jak:
 * - BaseFilter - domyślny filtr listy
 * - konfigurację pól - czy możliwa edycja
 * - Domyślne parametry do tworzenie nowego obiektu
 */
function ListContext($injector, $q, $parse, Classes, CurrentUser, config, ContextService, Parent /*=null*/, EffectiveTime /*=null*/) {

	var self = this;
	this.config = config  // here config is guaranteed to be complete
	this.Parent = Parent || null;
	this.Class = Classes[config.classname];
	this.EffectiveTime = EffectiveTime || null;
	
	// top lists and parent-related nested lists
	this.fetchBaseFilter = function() {
		var filter = {};
		var name;
		for (name in this.config.basefilter) {
			var func = this.config.basefilter[name];
			filter[name] = $injector.invoke(func, null, {Parent:Parent,CurrentUser:CurrentUser});
		}
		return $q.all(filter);
	}

	
	// creates a new sub-module based on config.references configuration
	// sets the new Parent to the provided class instance
	this.getReferencedContext = function(newparent, i_or_path_or_class) {
		for (var i in config.references) {
			var tabconfig = ContextService.prepareConfig(config.references[i]);
			if (i === i_or_path_or_class
				|| tabconfig.name == i_or_path_or_class 
				|| tabconfig.classname == i_or_path_or_class
			) {
				return $injector.instantiate(ListContext, {config:tabconfig, ContextService:ContextService, Parent:newparent, EffectiveTime:this.EffectiveTime});
			}
		}
	}
	
	// creates a new object with default field values based on:
	// - Class fields defaults
	// - config.defaults with optional Parent dependency (if available - context create)
	this.fetchNewInstance = function(defaults) {
		defaults = defaults || {};
		return this.fetchClassDefaults().then(function(defaults1){
			return self.fetchConfigDefaults(defaults1).then(function(defaults2){
				var data = angular.extend({}, defaults1, defaults2, defaults);
				console.log('New object context resolved', data);
				var object = self.getClass().create(data);
				return object;
			});
		});
	}
	
	// detail 
	
	this.getClass = function() {
		return this.Class;
	}
	
	this.getEffectiveTime = function() {
		return this.EffectiveTime;
	}
	
	this.withEffectiveTime = function(effective_time) {
		return $injector.instantiate(ListContext, {config:this.config, ContextService:ContextService, Parent:this.Parent, EffectiveTime:effective_time});
	}
	
	this.getInstance = function(vid) {
		//var vid = id;
		//if (this.EffectiveTime) vid += ':' + this.EffectiveTime;
		return this.Class.get(vid);
	}
	
	this.cloneInstance = function(original) {
		return this.fetchClassDefaults().then(function(defaults){
			console.log('New object context resolved for clone', defaults);
			return self.getClass().clone_instance(original, defaults, ['edit', 'clone']).then(function(object){
				return self.fetchConfigDefaults(object).then(function(defaults2){
					angular.extend(object, defaults2);
					console.debug('Cloned object', object);
					return object;
				});
			});
		});
	}
	
	// support
	
	// returns an object filled with default values for class fields
	// based on the class configuration retrieved from the server
	this.fetchClassDefaults = function() {
		var defaults = {};
		var cls = this.getClass();
		var fields = cls.get_form_params();    // was: cls.fields
		for (var k in fields) {
    		var field = fields[k];
			if (field && typeof field['default'] != "undefined") {
				var func = $parse(field['default']);  // function(context, locals)
				defaults[field['name']] = func({$moment: moment, $user: CurrentUser.instance}, Classes); 
			}
    	}
    	return $q.all(defaults);
	}
	
	// returns an object filled with default values for class fields
	// based on the target context configuration
	this.fetchConfigDefaults = function(context) {
		var defaults = {};
		for (var name in this.config.defaults) {
    		var func = this.config.defaults[name];
			defaults[name] = $injector.invoke(func, null, {Object:context,Parent:Parent,CurrentUser:CurrentUser});
    	}
    	return $q.all(defaults);
	}
	
	
	// display
	
	this.getTitle = function() {
		return self.config.display.title;
	}
	this.getListTitle = function() {
		return self.config.display.ntitle;
	}
	this.getIcon = function() {
		return self.config.display.icon;
	}
	this.getName = function() {
		return self.config.name;
	}
	this.getCreateLabel = function() {
		if(self.config.display.createLabel)
			return self.config.display.createLabel;
		else
			return 'Create';
	}
	
	this.getTabs = function(location) {
		var tabs = [];
		for (var i in config.tabs) {
			var display = config.tabs[i].display;
			if (!location || display.location == location) {
				tabs.push(config.tabs[i]);
			}
		}
		return tabs;
	}

	this.getRefs = function(location) {
		var refs = [];
		for (var i in config.references) {
			var display = config.references[i].display;
			if (!location || display.location == location) {
				var tabconfig = ContextService.prepareConfig(config.references[i]);
				refs.push(tabconfig);
			}
		}
		return refs;
	}
	
	this.getClientActions = function(location) {
		var actions = [];
		for (var i in config.clientActions) {
			var action = config.clientActions[i];
			if (action.location == location) {
				actions.push(action);
			}
		}
		return actions;
	}

	// returns predefined mandatory filters for lists
	this.getPredefinedFilters = function() {
		if (typeof this.config.predefinedFilters == "function") {
			var func = this.config.predefinedFilters;
			return $injector.invoke(func, null, {Parent:Parent,CurrentUser:CurrentUser});
		} else {
			return this.config.predefinedFilters;
		}
	}

	// return preconfigured cols from main.js
	this.getMergeGridColumnDefs = function() {
		if (typeof this.config.mergeGridColumnDefs == "function") {
			var func = this.config.mergeGridColumnDefs;
			return $injector.invoke(func, null, {Parent:Parent,CurrentUser:CurrentUser});
		} else {
			return this.config.mergeGridColumnDefs;
		}
	}
}


function ContextService(Modules, Classes, $injector) {
	
	this.modules = Modules;
	
	/*
		// Example Configuration
		
		var config = {
			name:"users", 
			classname: "Person",
			display: {
				ntitle:"Users", 
				title:"User", 
				icon:"fa fa-users",
				// simpleui: true,
			},
			listController: 'ModuleListController',
			listControllerAs: 'mCtrl',
			objectController: 'ModuleObjectController',
			objectControllerAs: 'mCtrl',
			createController: 'ModuleObjectController',
			createControllerAs: 'mCtrl',
			listTemplateUrl: 'framework/partials/admin/list.html',
			objectTemplateUrl: 'framework/partials/admin/object.html',
			createTemplateUrl: 'framework/partials/admin/object-create.html',
			tabTemplateUrl: 'framework/partials/admin/tab-list.html',
			
			import: "some_default_config_name",
			
			basefilter: {
				'manager.id': function(CurrentUser) {  // injectable locals: Parent,CurrentUser
					return CurrentUser.instance.__id;  // can be a promise
				}
			},
			
			defaults: {
				manager: function(CurrentUser) {  // injectable Object,Parent,CurrentUser
					return CurrentUser.instance;  // can be a promise
				}
			},
			
			clientActions: [{
				'location': 'actions',
				'perm': 'create',
				'btn': 'New email',
				'icon': 'far fa-download fa-fw',
				'condition': function(Object) {return Object.has_email_address},
				'action': function(Object, $state) {  // injectable Object
					return Object.fetch().then(function(){
						var mailto = "mailto:" + Object.email;
						window.location = mailto;
					});
				}
			}]
			
			mergetabs: [
				{
					name: 'edit2',
					display: {location: 'right', title: 'Edit', icon: 'glyphicon glyphicon-edit'},
					enabled: function(Object, Config) {return Object.__perms.edit && Object.__id==Object.__vid},
					templateUrl: 'framework/partials/admin/object-editform.html',
					// savegroups: ['edit'],
					// formlayout: [ ['edit-l', 'edit-r'], ['edit-w'] ]
				},
			],
			
			
			references: [
				{
					import: "customers",
					
					foreignKey:'subagent',  // only in referenced context
					// OR
					basefilter: {
						'subagent.id': function(Parent) {  // injectable locals: Parent,CurrentUser
							return Parent.__id;  // can be a promise
						}
					}
					defaults: {
						subagent: function(Parent) {  // injectable locals: Object,Parent,CurrentUser
							return Parent;  // can be a promise
						}
					},
					
					controller:'ModuleListController', 
					templateUrl: 'framework/partials/admin/tab-list.html'
					
					display: {
						location: 'side'
					}
				},
			],

			fetchLevel: 1,

			predefinedFilters: [
				{
					title: 'All',
					icon: 'fa fa-list',
					filter: {},
					mandatory: true,  // cannot delete
					dynamic: false,   // saved, do not offer save dialog
				}
			],

			mergeGridColumnDefs: [],
		}
	*/
	
	this.makeDefaultConfig = function(Class) {
		return {
			"name": Class.classname,
			"classname": null,  // REQUIRED - the only required field
			"display": {
				"title": Class.classname.replace(/(\w)([A-Z])/g, '$1 $2'),
				"ntitle": "List of " + Class.classname.replace(/(\w)([A-Z])/g, '$1 $2'),
				"icon": "fa fa-cubes"
			},
			//"listController": "ModuleListController",
			//"listControllerAs": "mCtrl",
			//"templateUrl": 'framework/partials/admin/list.html',
			"references": null,
			tabs: [
				{
					name: 'info',
					display: {location: 'left', title: 'Details', icon: 'glyphicon glyphicon-th'},
					enabled: function(Object, Config) {return !(Config.display.simpleui) || (Object.__perms && !Object.__perms.edit)},
					templateUrl: 'framework/partials/admin/object-details.html',
				},
				{
					name: 'edit',
					display: {location: 'right', title: 'Edit', icon: 'glyphicon glyphicon-edit'},
					enabled: function(Object, Config) {return Object.__perms.edit && Object.__id==Object.__vid},
					templateUrl: 'framework/partials/admin/object-editform.html',
				},
				{
					name: 'hist',
					display: {location: 'right', title: 'History', icon: 'fa fa-history'},
					enabled: function(Object, Config) {return Object.__perms.history},
					templateUrl: 'framework/partials/admin/object-history.html',
				}
			],
			predefinedFilters: [
				{
					title: 'All items',
					icon: 'fa fa-list',
					filter: {},
					mandatory: true,  // cannot delete
					dynamic: false,   // saved, do not offer save dialog
				}
			],
		};
	}
	
	this.findConfig = function(name_or_class) {
		for (var i in this.modules) {
			var module = this.modules[i]
			if (module.name == name_or_class) return module;
			if (module.classname == name_or_class) return module;
		}
		throw "No module defined for: " + name_or_class
		return null;
	}
	
	this.getConfig = function(name_or_class) {
		var config = this.findConfig(name_or_class);
		return config? this.prepareConfig(config): null;
	}
	
	this.prepareConfig = function(config) {
		// import other config if needed
		config = angular.copy(config);
		if (config.import) {
			var imported = this.getConfig(config.import);
			if (!imported) throw "Import failed: " + config.import;
			//config = angular.extend(config, imported);
			for (var key in imported) {
				if (imported[key] !== null && typeof imported[key] === 'object') {
					config[key] = angular.copy(config[key]) || {}
					for (var k in imported[key]) {
						if (!config[key][k]) config[key][k] = imported[key][k];
					}
				} else {
					if (!config[key]) config[key] = imported[key];
				}
			}
		}

		// add any missing default options
		var default_config = this.makeDefaultConfig(Classes[config.classname])
		config = angular.extend(default_config, config);
		
		// merge custom tabs
		if (config.mergetabs) {
			for (var mi=0; mi<config.mergetabs.length; mi++) {
				var tabmerged = false;
				for (var di=0; di<config.tabs.length; di++) {
					if (config.tabs[di].name == config.mergetabs[mi].name) {
						tabmerged = true;
						angular.extend(config.tabs[di], config.mergetabs[mi]);
					}
				}
				if (!tabmerged) {
					config.tabs.push(config.mergetabs[mi]);
				}
			}
		}
		
		// expand foreignKey shortcut
		if (config.foreignKey) {
			config.basefilter = angular.copy(config.basefilter) || {}
			config.basefilter[config.foreignKey + '.id'] = function(Parent) {
				return Parent.__id;
			}
			if (!config.foreignKey.match(/\./)) {
				config.defaults = angular.copy(config.defaults) || {}
				config.defaults[config.foreignKey] = function(Parent) {
					return Parent;
				}
			}
		}
		
		return config;
	}
	
	// tworzy pusty kontekst dla list obiektów pierwszego poziomu
	this.getContext = function(name_or_class, effective_time) {
		var config = this.getConfig(name_or_class);
		if (!config) return null;
		var ret = $injector.instantiate(ListContext, {config:config, ContextService:this, Parent:null, EffectiveTime:effective_time});
		return ret;
	}
	
}


angular.module('admin').service('ContextService', ContextService);

})();


function ListController(GridVolatileStateManager, GridPersistentStateManager, GridTabsManager, $scope, $q, $uibModal, $timeout, GridId, BaseFilter, EffectiveTime, Class, SimpleObservable, $injector) {
	var self = this;
	

	this.Class = Class;  // Person
	this.gridId = GridId;
	this.baseFilter = BaseFilter;
	this.effectiveTime = EffectiveTime;
	this.promises = {};  // a place to store all deferred dependencies of the grid
	this.promisesDefer = {};  // a place to store matching defered for promises
	self.loading = false;
	
	this.session = GridVolatileStateManager.get(this.gridId);
	this.promises.prefs = GridPersistentStateManager.load(this.gridId.replace(/0-9/, '')).then(function(prefs){
		self.prefs = prefs;
		return prefs;
	});
	
	this.params = {
		filter: this.session.getItem('filter', {}),
		base_filter: this.baseFilter,
		sort: this.session.getItem('sort', [this.Class.default_sort]),
		limit: this.session.getItem('limit', 50),
		offset: this.session.getItem('offset', 0),
		effective_time: this.effectiveTime || null,
		group: {0:'list',1:'essential'},
		levels: 1
	};
	this.state = this.session.getItem('state', {});
	this.filterQuerySelector = this.Class.get_text_search_query();
	this.filterQuery = this.params.filter[this.filterQuerySelector];
	this.loadCounter = 0;
	this.objects_count = {};
	this.objects = [];  // lista oiektów
	this.message = null;
	this.options = [  // lista ekranów do panelu z opcjami
		/*{'title': 'Zakładki wyszukiwania', 'templateUrl': 'grid/options-tabs.html'}*/
	]
	
	
	this.failure = function(error) {
		self.message = {type:'danger', body:error.data.message}
		self.loading = false;
		if (error.data.code == 401) {
			$scope.$emit('unauthorized');
		}
	}
	
	this.saveSession = function() {
		self.session.setItem({
			filter: self.params.filter,
			sort: self.params.sort,
			limit: self.params.limit,
			offset: self.params.offset,
			state: self.state,
		});
	}
	
	this.reload = function() {
		return self.getPage();
	}
	
	this.getPage = SimpleObservable(function() {
		self.loadCounter++;
		self.loading = true;
		var currentLoad = self.loadCounter;
		var params = angular.copy(self.params);
		//if (self.tabs) self.tabs.searchChanged(params.filter);  // tabs
		self.objects_count = {}
		// count objects
		return self.Class.count({
			filter:angular.copy(params.filter), 
			base_filter:angular.copy(params.base_filter), 
			effective_time: params.effective_time
		}).then(function(objects_count){
			if (self.loadCounter != currentLoad) {
				// jest już wczytywana nowsza wersja, pomińmy te wyniki
				//self.objects = [];
				return self.objects;
			}
			self.objects_count = objects_count;
			self.saveSession();
			// fetch objects if count > 0
			self.objects = [];
			self.message = null;
			
			angular.extend(params.filter, params.base_filter); 
			if (objects_count.filtered > 0) {
				return self.Class.find(params).then(function(list){
					if (self.loadCounter != currentLoad) {
						// jest już wczytywana nowsza wersja, pomińmy te wyniki
						return self.objects;
					}
					self.loading = false;
					return self.objects = list;
				});
			} else {
				self.loading = false;
				return self.objects;
			}
		}).catch(self.failure);
	})
	
	//$timeout(function(){console.debug("Waiting for promises", self.promises); $q.all(self.promises).then(function(){console.debug("List promises loaded!")});});
	$timeout(function(){$q.all(self.promises).then(self.getPage);});
	
	// apply text search
	this.setFilterQuery = function() {
		if (self.filterQuery) {
			self.params.filter[self.filterQuerySelector] = self.filterQuery.replace(/[^0-9A-Za-z\u00C0-\u017F @_\-.]/g, '');  //  + Latin 1 + Latin A + Latin B, http://kourge.net/projects/regexp-unicode-block
		} else {
			delete self.params.filter[self.filterQuerySelector];
		}
		self.setFilter(self.params.filter);  // fire event
		self.getPage()
	}
	
	
	this.setRowsPerPage = function(n) {
		this.params.limit = n;
	}
	this.setFilter = SimpleObservable(function(filter) {
		this.params.filter = filter;
		self.filterQuery = filter[self.filterQuerySelector] || '';
		return filter
	});
	
	// przeładowanie wywołane przez nadrzędny obiekt
	$scope.$on('object-reload', function(){
		// zamknięcie formularza
		console.log('Reloading list..');
    	self.getPage();
    });
    
    $scope.$on('search', function(event, search_string) {
		self.filterQuery = search_string;
	});

	this.waitFor = function(componentName) {
		console.log('Setting wait for: ' + componentName);
		self.promisesDefer[componentName] = $q.defer();
		self.promises[componentName] = self.promisesDefer[componentName].promise;
	}

	this.stopWaitingFor = function(componentName) {
		console.log('Stopping wait for: ' + componentName);
		self.promisesDefer[componentName].resolve(true);
	}
	
	this.isExportAvailable = function() {
		var export_config = self.Class.export_config || {};
		var has_default_export_config = export_config.default;
		return has_default_export_config;
	}
    
    this.export = function(format) {
		var filter = {};
    	angular.extend(filter, self.params.filter);
    	angular.extend(filter, self.params.base_filter);
		var url = self.Class.get_url('export_all', {format:format, filter:filter, sort:self.params.sort, preset: 'default'});
		window.location = url;
    }
    
    this.showPrefs = function() {
		
		var save = function(data) {
			function doSave(i) {
				var option = self.options[i];
				return option.save().then(function(){
					if (i < self.options.length - 1) {
						return doSave(i+1);
					} else {
						return true;
					}
				});
			}
			if (self.options.length > 0) {
				return doSave(0);
			} else {
				return $q.when(true);
			}
		}
		//var dlg = dialogs.create('partials/grid/dialog-save-tab.html','SaveCancelDialogCtrl',{data:tab,save:save},{size:'lg'});
		var dlg = $uibModal.open({
		      animation: true,
		      templateUrl: 'framework/partials/grid/dialog-grid-options.html',
		      controller: 'SubmitCancelDialogCtrl as dCtrl',
		      size: 'lg',
		      resolve: {
		        params: function () {
		          return {options:self.options, lCtrl: self, submit:save}
		        }
		      }
		});
	}


	this.activate_module_action = function(action) {
		return $injector.invoke(action.action, null, {Class:self.Class});
	}
    
	
	window.lCtrl = this;  // debug

}


// a state controller for the new Grid components
function ModuleListController(ListContext, BaseFilter, $state) {
	var self = this;

	this.ListContext = ListContext;
	this.BaseFilter = BaseFilter;
	this.Class = ListContext.getClass();  // Person
	this.predefinedFilters = ListContext.getPredefinedFilters();
	this.mergeGridColumnDefs = ListContext.getMergeGridColumnDefs();
	this.EffectiveTime = ListContext.getEffectiveTime();  // null
	this.title = ListContext.getListTitle();
	this.name = ListContext.getName();
	this.icon = ListContext.getIcon();
	this.createLabel = ListContext.getCreateLabel();
	this.gridId = ListContext.Parent? (this.name + '-' + ListContext.Parent.getClass().name) : this.name;
	
	
	this.gotoObject = function(vid, event/*=null*/) {
		if(event && (event.ctrlKey || event.metaKey)){
			var url = $state.href('module.detail', {page: ListContext.config.name, vid: vid});
			window.open(url,'_blank');
		}else{
			$state.go('module.detail', {page: ListContext.config.name, vid: vid});
		}
	}
    
    this.can_create_from_context = function(parentContext) {
		//return self.ListContext.config.foreignKey;
		return self.ListContext.config.defaults;
    }
    
    this.gotoCreate = function(parentContext, parentObject) {
    	var params = {}
    	if (parentObject && parentContext && this.can_create_from_context(parentContext)) {
    		params.page = parentContext.getName();
    		params.parentVid = parentObject.__vid;
    		params.refClass = self.Class.name;
    	} else {
    		params.page = this.ListContext.getName();
    	}
    	console.log('Create screen', "module.create", params);
    	$state.go("module.create", params);
    }
	
	window.mCtrl = this;  // debug
}




angular.module('admin')
.controller('ListController', ListController)
.controller('ModuleListController', ModuleListController)





// a state controller for import
function ModuleImportController(ListContext, TemplateObject, FormService, $state, $stateParams, $scope, $q, $timeout, GridHelpers, $translate) {
	var self = this;

	this.ListContext = ListContext;
	this.TemplateObject = TemplateObject;
	this.Class = ListContext.getClass();  // Person
	this.EffectiveTime = ListContext.getEffectiveTime();  // null
	this.title = ListContext.getListTitle();
	this.name = ListContext.getName();
	this.icon = ListContext.getIcon();
	this.gridId = ListContext.Parent? (this.name + '-import-' + ListContext.Parent.getClass().name) : this.name;
	this.activeTab = 0;
	this.preset = $stateParams.preset
	this.import_config = this.Class.import_config[this.preset]
	this.import_title = this.import_config.title != 'Import' ? this.import_config.title : null;

	this.items = [];
	this.results = [];
	this.deleted_items = [];
	this.values = {
		csv_text: "",
		delete_unlisted: false,
		merge_objects: false,
	}
	this.fieldGroup = this.import_config.group
	this.importFields = this.Class.get_form_params(null, self.Class.get_fields(this.fieldGroup), {edit: true, view:true})
	this.importColumns = []
	this.columnFieldnames = [];
	this.gridOptions = GridHelpers.makeGridOptions({
		enableServerSideSorting: false,
		enableSorting: true,
		enableFilter: true,
		suppressCellSelection: true,  // do not click individual cells
		rowSelection: 'single',
		angularCompileRows: false,  // sloow
		colWidth: 170,
		rowData: null,
		columnDefs: [
			{
				headerName: $translate.instant('Import status'), 
				field: '__index',
				valueGetter: function(params) {
					var __index = params.data.__index;
					var label = 'Ready to import';
					if (!self.results[__index]) {
						return $translate.instant('Ready to import');
					} else {
						if (self.results[__index].created) {
							return $translate.instant('Created');
						}
						if (self.results[__index].updated) {
							return $translate.instant('Updated');
						}
						if (self.results[__index].data) {
							var output = [];
							for (var fieldname in self.results[__index].data) {
								if (self.import_config.columns[fieldname]) {
									// it is possible not to find columns if presets get conflicted
									var error = self.results[__index].data[fieldname];
									var cols = self.import_config.columns[fieldname].join(', ')
									output.push(cols + ": " + $translate.instant(error));
								}
							}
							return $translate.instant(mCtrl.results[__index].message) + " - " + output.join('; ')
						}
					}
					return $translate.instant( mCtrl.results[__index].message);
				},
				cellRenderer: function(params) {
					var __index = params.data.__index;
					var label = 'Ready to import';
					if (!self.results[__index]) {
						return '<span class="label label-default">' + $translate.instant('Ready to import') + '</span>';
					} else {
						if (self.results[__index].created) {
							return '<span class="label label-success">' + $translate.instant('Created') + '</span>';
						}
						if (self.results[__index].updated) {
							return '<span class="label label-info">' + $translate.instant('Updated') + '</span>';
						}
						if (self.results[__index].unchanged) {
							return '<span class="label label-info">' + $translate.instant('Unchanged') + '</span>';
						}
					}
					return '<span class="text-danger" title="'+params.value+'">' + $translate.instant(mCtrl.results[__index].message) + '</span>';
				},
				filter:'text',
			}
		]
	});

	visible_csv_columns = {};
	for (var fieldname in this.import_config.columns) {
		for (var i in this.import_config.columns[fieldname]) {
			var column = this.import_config.columns[fieldname][i];
			if (self.importColumns.indexOf(column) == -1) {
				self.importColumns.push(column);
				self.columnFieldnames[column] = [fieldname];
			} else {
				self.columnFieldnames[column].push(fieldname)
			}
			if (visible_csv_columns[column]) continue;
			visible_csv_columns[column]=true;
			self.gridOptions.columnDefs.push((function(fieldname){return {
				headerName: column, 
				field: column,
				cellClass: function(params) { 
					var __index = params.data.__index;
					if (self.results[__index] && self.results[__index].data) {
						if (self.results[__index].data[fieldname]) return 'bg-danger';
					}
				},
				cellRenderer: function(params) {
					var tooltip = null;
					var __index = params.data.__index;
					if (self.results[__index] && self.results[__index].data) {
						if (self.results[__index].data[fieldname]) {
							tooltip = $translate.instant(self.results[__index].data[fieldname]);
						}
					} 
					if (tooltip) {
						return '<div title="' + tooltip + '" style="position:absolute;top:0;left:0;right:0;bottom:0"></div>'+params.value
					} else {
						return typeof params.value != "undefined"? params.value : "";
					}
				}
			}})(fieldname))
		}
	}
	this.message = null;


	this.form = FormService.createForm({
		layout: ['edit', ['options-0', 'options-1', /*'options-2',*/ 'options-3']],
		submit: function(data) {
			self.message = null;
			self.results.length = 0;
			if (self.items.length == 0) {
				return $q.reject({data:{code: 400, message: 'No data found in the provided file.'}});
			}
			return self.Class.import_all({preset: self.preset, objects:self.items, group:self.fieldGroup, merge_objects:self.values.merge_objects, delete_unlisted: self.values.delete_unlisted, dry_run: self.values.dry_run, ignore_errors: self.values.ignore_errors}).then(function(result){
				// success
				//$state.go('module.list');
				self.results = result
				if (self.results.length > self.items.length) {
					self.deleted_items.length = 0;
					[].push.apply(self.deleted_items, self.results.slice(self.items.length).map(function(item){return item.data}))
				}
				self.gridOptions.api.refreshView();
				return {__callstatus:{message:'The data has been successfully imported.'}};
			}).catch(function(error){
				if (error.data.code >= 100) {
					self.results = error.data.data
					if (self.results.length > self.items.length) {
						self.deleted_items.length = 0;
						[].push.apply(self.deleted_items, self.results.slice(self.items.length).map(function(item){return item.data}))
					}
					self.gridOptions.api.refreshView();
				}
				return $q.reject(error);
			});
		},
		params: [
			/*{
				"title": "Paste the CSV file content here",
				"type": "TextField",
				"name": "csv_text",
				"groups": ["edit"],
				"required": false,
				"visible": 'true',
				"editable": 'true',
				"client": {"placeholder":"CSV file contents"},
			},*/
			{
				"title": "Update existing objects",
				"type": "BooleanField",
				"name": "merge_objects",
				"groups": ["options-0"],
				"required": false,
				"visible": 'true',
				"editable": 'true',
			},
			{
				"title": "Skip incorrect entries",
				"type": "BooleanField",
				"name": "ignore_errors",
				"groups": ["options-1"],
				"required": false,
				"visible": 'true',
				"editable": 'true',
			},
			/*{
				"title": "Delete unlisted objects",
				"type": "BooleanField",
				"name": "delete_unlisted",
				"groups": ["options-2"],
				"required": false,
				"visible": 'true',
				"editable": 'true',
			},*/
			{
				"title": "Dry run",
				"type": "BooleanField",
				"name": "dry_run",
				"groups": ["options-3"],
				"required": false,
				"visible": 'true',
				"editable": 'true',
			},
		]
	}, this.values)


	this.parse = function(text) {
		var self = this;
		var i;
		self.items.length = 0;
		self.deleted_items.length = 0;
		self.results.length = 0;

		//text = text.replace(/("[^"]+")([^\t])/mg, "$1");
		var result = self.result = Papa.parse(text, {header: true, skipEmptyLines: true})
		var data = result.data;  // TODO manage errors and meta info

		

		// parse data
		for (i in data) {
			line = data[i]
			var object = self.Class.getObjectPayload(self.TemplateObject, self.fieldGroup)
			object.__index = i;  // to get mctrl.results[__index]
			for (var fi in result.meta.fields) {
				var fname = result.meta.fields[fi];
				if (typeof line[fname] != "undefined") {
					object[fname] = line[fname].replace(/[\r\n]/mg, '');
				}
			}
			self.items.push(object)
		}
	}

	$scope.$watch(function(){return self.values.csv_text}, function(){
		self.parse(self.values.csv_text);
		if (self.gridOptions.api) self.gridOptions.api.setRowData(self.items);
	}, true)

	
	this.cancelImport = function() {
		$state.go('module.list');
	}

	this.saveReportCSV = function() {
		if (self.gridOptions.api) {
			var params = {
				fileName: self.name + '-import.csv',
				columnSeparator: ';',
			}
			self.gridOptions.api.exportDataAsCsv(params);
		}
	}

	this.detectPaste = function($event) {
		if (($event.ctrlKey || $event.metaKey) && $event.keyCode==86){
			$timeout(function(){self.activeTab = 1;});
		}
	}

	this.readFile = function (file) {
        var deferred = $q.defer();

		var reader = new FileReader()
        reader.onload = function(e){
            deferred.resolve({
    			mime: file.type,
				filename: file.name,
				data: e.target.result,
				title: file.name.replace(/\.[a-z0-9]+$/, '').replace(/[_\\-]/g, ' ')
	    	});
        }
        reader.onerror = function(e) {
            deferred.reject(e);
        }
        reader.readAsDataURL(file);

        return deferred.promise;
    }
	
	self.upload_is_busy = false;
    this.uploadFiles = function(files) {
		var slice = Array.prototype.slice;
		self.upload_is_busy = true;

        return $q.all(slice.call(files, 0).map(self.readFile)).then(function(values){
			
			// sent in to self.Class to decode
			if(values.length){
				self.Class.parseCsvSelectedString({
					import_data: values[0].data
				}).then(function(data){
					
					//console.table(data);
					//result = JSON.parse(result);
					//self.values.csv_text = result;
					//self.parse(self.values.csv_text);
					self.items.length = 0;
					for (i in data) {
						line = data[i]
						var object = self.Class.getObjectPayload(self.TemplateObject, self.fieldGroup)
						object.__index = i;  // to get mctrl.results[__index]
						for (var ci in self.importColumns) {
							var column = self.importColumns[ci];
							object[column] = line[column];
						}
						self.items.push(object)
					}
					if (self.gridOptions.api) 
						self.gridOptions.api.setRowData(self.items);

					self.activeTab = 1;

				}).catch(function(error){
					if (error.data.code >= 100) {
						self.results = error.data.data
						if (self.results.length > self.items.length) {
							self.deleted_items.length = 0;
							[].push.apply(self.deleted_items, self.results.slice(self.items.length).map(function(item){return item.data}))
						}
						self.gridOptions.api.refreshView();
					}
					return $q.reject(error);
				});
			}
			
			self.upload_is_busy = false;
    	}).catch(function(e){
    		self.message={type:'danger', body:e}
			self.upload_is_busy = false;
    	});
    }


	
	window.mCtrl = this;  // debug
}


angular.module('admin')
.controller('ModuleImportController', ModuleImportController)



function ObjectController(Object, createMode, $scope, $state, $q, $injector, FormService, $translate, ApiRootUrl) {

	var self = this;
	this.Object = $scope.object = Object;
	this.Class = Object.getClass();
	this.createMode = createMode;
	this.message = null;
	this.apiRootUrl = ApiRootUrl;	
	
	//this.Module = ModuleService.getModule(Object.__classname);
	
	/************** viewing ****************/
	
	this.actions = Object.get_forms('Action');
	
	this.activate_form = function(form, formdata) {
		if (typeof form == 'string') {
			form = Object.get_form(form);
		}
		return FormService.activateFormModal(form, formdata).then(function(){
			self.Object.fetch(true);
		});
	}
	this.activate_module_action = function(action) {
		return $injector.invoke(action.action, null, {Object:self.Object});
	}

	this.test_action_condition = function(condition_test) {
		if (!condition_test) return true;
		return $injector.invoke(condition_test, null, {Object:self.Object});
	}
	
	this.is_field_visible = function(field) {
		var enabled = (field.enable)? $scope.$eval(field.enable, this.Object): true;
		var visible = this.Object.has_perm(field.viewperm);
		return enabled && visible;
	}
	
	this.is_field_editable = function(field) {
		var is_fixed = false;  //this.Module.isFixedField(field.name);
		//var is_object_editable = object && object.__perms && object.__perms.edit;
		var is_field_editable = this.Object.has_perm(field.editperm);
		//return !is_fixed && is_object_editable && is_field_editable;
		return !is_fixed && is_field_editable;
	}
    
    
    
    /************** editing ****************/
	
	this.saving = false;
	this.last_saved = null;
	this.field_errors = {};
	
	this.failure = function(error) {
		if (!error) return;
		self.message = {type:'danger', body: $translate.instant(error.data.message)}
		if (error.data.code == 401) {
			$scope.$emit('unauthorized');
		}
		if (error.data.code == 1) {
			self.message.type='warning';
		}
	}
	
	this.validate = function() {
		var data = self.Class.getObjectPayload(self.Object);
		return self.Class.validate(data).then(function(result) {
			self.field_errors = {};
			return result;
		},function(error){
			self.field_errors = error.data.data;
			return $q.reject(error);
		});
	}
	
	this.save = function(group, payload /* optional */) {
		return self.Object.save(group, payload).then(function(result){
			self.field_errors = {};
			return result;
		},function(error){
			self.field_errors = error.data.data;
			return $q.reject(error);
		});
	}
	
	this.saveEdit = function(group, go_to, payload /* optional */){
		this.saving = true;
		this.last_saved = null;
		
		//return self.validate().then(function(result){
		//	console.debug('Validation successful, saving ...');
			
		return self.save(group, payload).then(function(result){
				console.debug('Save successful.');
			
				self.last_saved = new Date;
				self.saving = false;
				self.message = {type:'success', body:'Saved at {{last_saved|date:"HH:mm:ss"}}', parameters: {last_saved: self.last_saved}}
			
				$scope.$emit('afterSave', go_to, result);
				return result;
			//});
		}).catch(function(error){	
			console.debug('Validation or save failed.');
			self.saving = false;
			self.failure(error);
			return $q.reject(error);
		});
		
	}
    
    this.cancelEdit = function(){
		this.last_saved = false;
		this.Object.rollback();
		this.error = false;
		this.field_errors = {};
		this.message = null;
		$scope.$emit('afterCancelEdit');
	}
	
	this.resetForm = function(oForm) {
	    if (oForm) {
			oForm.$setPristine();
			oForm.$setUntouched();
	    }		
	}


	/************** editing (forms) ****************/

	this.last_saved = null;
	this.message = null;
	this.prepared_forms = [];
	this.prepareForm = function(savegroups, layout) {
		var savegroups = savegroups || ['edit'];
		if (typeof savegroups == "string") savegroups = [savegroups];
		var payloadgroups = angular.copy(savegroups);
		payloadgroups.push('essential');
		var layout = layout || [
			['edit-l', 'edit-r'],
			['edit-w']
		]
		var fields = this.Class.get_fields(savegroups)
		var formconfig = {
			options: {savegroups: savegroups, payloadgroups: payloadgroups},  // (form.config.options.savegroups)
			params: this.Class.get_form_params(this.Object, fields),
			submit: function(data) {
				return self.Object.save(savegroups, data);
			},
			layout: layout,
		}
		var values = this.Class.getObjectPayload(this.Object, payloadgroups);
		var form = FormService.createForm(formconfig, values);
		this.prepared_forms.push(form);
		return form;
	}
	$scope.$on('object-reload', function(){
		for (var i in self.prepared_forms) {
			var form = self.prepared_forms[i];
			self.cancelForm(form);
		}
	})

	this.saveForm = function(form, go_to){
		this.last_saved = null;
		this.message = null;
		return form.submit().then(function(result){
			console.debug('Save successful.');
			self.last_saved = new Date();
			self.message = {type:'success', body:'Saved at {{last_saved|date:"HH:mm:ss"}}', parameters: {last_saved: self.last_saved}}
			form.reset(self.Class.getObjectPayload(self.Object, form.config.options.payloadgroups));
			$scope.$emit('afterSave', go_to, result);
 			return result;
		}).catch(function(error){	
			console.debug('Save failed.');
			self.message = {type:'danger', body: error.data.message, parameters: error.data.data}
			if (error.data.code == 1) {
				self.message.type='warning';
			}
			return $q.reject(error);
		});
		
	}

	this.cancelForm = function(form) {
		this.last_saved = null;
		this.message = null;
		if (form) {
			form.reset(self.Class.getObjectPayload(self.Object, form.config.options.payloadgroups));
		}
		$scope.$emit('afterCancelEdit');
	}

	/************** end editing ****************/
	
	window.oCtrls = window.oCtrls || [];
	window.oCtrls.push(this);


    
}



























function ModuleObjectController(ListContext, $state, Object, createMode, ModesAllowed, Mode, ContextService, $scope, scrollTo, $translate, $uibModal, $timeout) {

	var self = this;
	this.Object = Object;
	this.ListContext = ListContext;
	this.Class = ListContext.getClass();  // Person
	this.EffectiveTime = ListContext.getEffectiveTime();  // null
	this.createMode = createMode;
	this.title = ListContext.getTitle();
	this.ntitle = ListContext.getListTitle();
	this.name = ListContext.getName();
	this.icon = ListContext.getIcon();
	window.$state = $state;
	
	this.tabsLeft = ListContext.getTabs('left');
	this.tabsRight = ListContext.getTabs('right');
	this.refsInline = ListContext.getRefs('inline');
	this.refsSide = ListContext.getRefs('side');
	this.refsBottom = ListContext.getRefs('bottom');
	
	this.getBreadcrumbs = function() {
		var path = [];
		var object = this.Object;
		if (object) {
			object = object.get_parent();
			while (object) {
				var ctx = ContextService.getContext(object.__classname, self.EffectiveTime);
				path.splice(0, 0, {
					page: ctx.getName(),
					module_title: ctx.getListTitle(),
					vid: object.__vid,
					title: object.__title
				});
				object = object.get_parent? object.get_parent(): null;
			}
		}
		return path;
	}
	this.breadcrumbs = this.getBreadcrumbs()
	
	this.reload = function() {
		return self.Object.fetch(true, ListContext.config.fetchLevel).then(function(){
			self.ObjectPerms = self.Object.__perms
			self.breadcrumbs = self.getBreadcrumbs()
    		$scope.$broadcast('object-reload');
    	});
	}
	
	/************** view, edit tabs ****************/
	
	
	this.viewTab = Mode;
	self.initialViewTab = Mode
	this.ModesAllowed = ModesAllowed;
	this.enableTab = {};  // do opóżnionego ładowania tab-ów
	this.enableTab[this.viewTab] = true;
	
	this.setViewTab = function(name) {
		this.viewTab = null;
		$timeout(function(){
			self.viewTab = name;
			self.enableTab[name] = true;
			setTimeout(function(){
				// event w ramach timeout, aby załadowały się kontent (FIXME - co jeśli to trwa dłużej niż 10 ms?)
				$scope.$broadcast(name+'TabOn');
			});
			$state.go('.', {mode:name}, {location:'replace', notify: false})
		})
	}
	
	if (this.tabsSide && this.tabsSide.length && !createMode) {
		// przekieruj na pierwszy tab
		if ($state.is("module.detail")) {
			$state.go(".tab", {tab: this.tabsSide[0].name}, {inherit: true, notify: true});
		}
	}
	
	
	$scope.$on('action-complete', function(){
		// zamknięcie formularza = relaod
    	self.reload();
    });
    

	
	// utility
    
    // for the historical warning object-detail
    this.vid2date = function(vid) {
 		if (!vid) return '';
 		var date = vid.replace(/[0-9]+:/, '');
 		if (date[0] == '@') return moment(date.replace('@',''), 'X').format('YYYY-MM-DD HH:mm:ss') 
 		return  moment(date).format('YYYY-MM-DD HH:mm:ss');
 	}
 	
 	// oCtrl api
 	
 	this.onAfterCancelEdit = function() {
 		if (self.createMode || self.initialViewTab == 'edit') {
			window.history.back();
		} else {
			self.setViewTab(self.initialViewTab);
			scrollTo(0,0);
		}
	}
    $scope.$on('afterCancelEdit', this.onAfterCancelEdit);
    
    
    this.onAfterSave = function($event, go_to, results) {
    	if (self.createMode) {
			if (go_to == 'go_object') {
				console.debug('go-object');
				self.Object.fetch(true, ListContext.config.fetchLevel).then(function(){
					$state.go('module.detail', {page:self.name, vid: self.Object.__vid});
				});
			}
			if (go_to == 'go_list') {
				console.debug('go-list');
				//$state.go('^.list');
				window.history.back();
			}
		} else {
			self.setViewTab(self.initialViewTab);  // przejdź do głównej zakładki info lub edit
			scrollTo(0,0);
			if (ListContext.config.fetchLevel > 1) {
				self.reload();
			} else {
				$scope.$broadcast('object-reload');
			}
		}
    }
    $scope.$on('afterSave', this.onAfterSave);
    
    /************** deleting ****************/
	
	this.deleteModal = function() {
		var del = function() {
			return self.Object.delete();
		}
		
		var dlg = $uibModal.open({
		      animation: true,
		      templateUrl: 'framework/partials/admin/object-delete.html',
		      controller: 'SubmitCancelDialogCtrl as dCtrl',
		      size: 'md',
		      resolve: {
		        params: function (ContextService, $q) {
		          return $q.all({
		          	data: self.Object,
		          	submit:del,
		          	remove_dependencies: self.Object.list_remove_dependencies(),
		          	getContext: function(classname) {return ContextService.getContext(classname)}
		          });
		        }
		      }
		});
		
		return dlg.result.then(function(){
			window.history.back();
			$timeout(function(){
				//if ($state.is("module.detail") || $state.is("module.detail.tab")) {
				if ($state.params.vid == self.Object.__vid) {
					$state.go("module.list");
				}
			},1000);
			/*if ($state.is("module.detail") || $state.is("module.detail.tab")) {
				$state.go("module.list");
			} else {
				window.history.back();
			}*/
		},self.failure);
	}
	
	
	
	window.$mScope=$scope;
	window.mCtrl=this;
	window.oCtrls = [];  // prevent stacking of oCtrls
}


angular.module('admin')
.controller('ObjectController', ObjectController)
.controller('ModuleObjectController', ModuleObjectController)





function ObjectHistoryController ($scope, Object, FormService) {

	var self = this;
	this.versions = [];     // object versions
	this.changesets = [];   // object diffs
	this.is_busy = true;
	this.message = null;
	
	
	this.loadHistory = function() {
		self.versions.length = 0;
		self.changesets.length = 0;
		self.is_busy = true;
		return Object.history().catch(function(error){	
			console.debug('Loading history failed.');
			self.is_busy = false;
			self.message = {type:'danger', body: error.data.message}
			if (error.data.code == 1) {
				self.message.type='warning';
			}
			return $q.reject(error);
		}).then(function(versions){
			self.is_busy = false;
			versions = versions.sort(function(a, b) {  // reverse
			    return - (a.effective_time.from > b.effective_time.from? 1 : (a.effective_time.from < b.effective_time.from? -1 : 0) );
			})
			self.versions = versions;
			self.changesets = self.makeChangesets(versions);
		});
	}
	
	this.loadHistory();
	$scope.$on('object-reload', function(){
		self.loadHistory();
	});
	
	this.makeChangesets = function(versions) {
		var changesets = [];
		for (var i=0; i<versions.length; i++) {
			
			var changeset = {
				base: i+1<versions.length && versions[i+1].__id == versions[i].__id? versions[i+1] : null,
				changed: versions[i],
				type: null,
				changes: [],
				date: versions[i].effective_time.from,
				days: null,
				author: versions[i].editor_login,
			};

			var workflow = this.compareObjects(changeset.base, changeset.changed, ['workflow', 'workflow-top']);
			[].push.apply(changeset.changes, workflow);

			if (changeset.base == null) {
				changeset.type = 'create';
			} else if (workflow.length > 0) {
				changeset.type = 'workflow';
			} else if (changeset.changed.deleted && !changeset.base.deleted) {
				changeset.type = 'delete';
			} else {
				changeset.type = 'edit';
			}
			if (versions[i].couch_uuid && versions[i].winning_rev == false) {
				changeset.type = 'conflict'
				changeset.base = null;
			}
			
			var edits = this.compareObjects(changeset.base, changeset.changed, ['edit', 'clone', 'edit-ext']);
			[].push.apply(changeset.changes, edits);
			

			if (changeset.changed.effective_time) {
				var days = moment().diff(moment(changeset.changed.effective_time.from), 'days');
				changeset.days = days;
			}
			if (changeset.changes.length || changeset.type != 'edit') {
				changesets.push(changeset);
			}
		}
		// is this needed?
		changesets.sort(function(a, b) { 
		    return - (a.changed.effective_time.from.localeCompare(b.changed.effective_time.from));
		});
		return changesets;
	}
	
	this.compareObjects = function(base, changed, group) {
		var changes = [];
		base = base || {};
		var cls = changed.getClass();
		var fields = cls.get_fields(group);
		
				
		for (var i in fields) {
			var field = fields[i];
			var property = field.name;
			var from = base[property];
			var to = changed[property];
			if (field.type == 'ReferenceField' ) {
				//from = from? from.__title : null;
				//to = to? to.__title : null;
				from = from? from.__id : null;
				to = to? to.__id : null;
			} else if (field.type == 'GridReferenceField' || field.type == 'BackReferenceField') {
				var obj2str = function(obj) {
					if (!obj) return "";
					var out = {};
					var cls = obj.getClass();
					var fields = cls.get_fields('edit');
					for (var i in fields) {
						if (typeof obj[fields[i].name] != "object") {
							out[fields[i].name] = obj[fields[i].name];
						} else if (obj[fields[i].name] && obj[fields[i].name].__id) {
							out[fields[i].name] = obj[fields[i].name].__id;
						}
						
					}
					return angular.toJson(out);
				}
				from = ""+ angular.toJson(_.map(from, obj2str));
				to = ""+ angular.toJson(_.map(to, obj2str));
			} else if (_.isObject(changed[property])) {
				from = angular.toJson(from);
				to = angular.toJson(to);
			} else if (_.isArray(changed[property])) {
				from = angular.toJson(from);
				to = angular.toJson(to);
			} else if (field.type == 'Field' || field.type == 'TextField') {
				if (from && from != to) {
					to = diffString(from || "", to || "");
				}
			}
			//console.debug(property, base[property] , changed[property]);
	        if (from != to) {
	        	var change = {};
	        	change.name = property;
	        	change.title = field.title;
	        	change.from = from;
	        	change.to = to;
	        	change.field = field;
	        	change.base = base[property];
	        	change.changed = changed[property];
	        	changes.push(change);
	        }			
		}
		return changes;
	}


	this.object_activate_form = function(object, form, formdata) {
		if (typeof form == 'string') {
			form = object.get_form(form);
		}
		return FormService.activateFormModal(form, formdata);
	}

	
	window.historyCtrl = this;
}


angular.module('admin')
.controller('ObjectHistoryController', ObjectHistoryController)

/*
 * Javascript Diff Algorithm
 *  By John Resig (http://ejohn.org/)
 *  Modified by Chu Alan "sprite"
 *
 * Released under the MIT license.
 *
 * More Info:
 *  http://ejohn.org/projects/javascript-diff-algorithm/
 */

function escape(s) {
    var n = s;
    n = n.replace(/&/g, "&amp;");
    n = n.replace(/</g, "&lt;");
    n = n.replace(/>/g, "&gt;");
    n = n.replace(/"/g, "&quot;");

    return n;
}

function diffString( o, n ) {
  o = o.replace(/\s+$/, '');
  n = n.replace(/\s+$/, '');

  var out = diff(o == "" ? [] : o.split(/\s+/), n == "" ? [] : n.split(/\s+/) );
  var str = "";

  var oSpace = o.match(/\s+/g);
  if (oSpace == null) {
    oSpace = ["\n"];
  } else {
    oSpace.push("\n");
  }
  var nSpace = n.match(/\s+/g);
  if (nSpace == null) {
    nSpace = ["\n"];
  } else {
    nSpace.push("\n");
  }

  if (out.n.length == 0) {
      for (var i = 0; i < out.o.length; i++) {
        str += '<del>' + escape(out.o[i]) + oSpace[i] + "</del>";
      }
  } else {
    if (out.n[0].text == null) {
      for (n = 0; n < out.o.length && out.o[n].text == null; n++) {
        str += '<del>' + escape(out.o[n]) + oSpace[n] + "</del>";
      }
    }

    for ( var i = 0; i < out.n.length; i++ ) {
      if (out.n[i].text == null) {
        str += '<ins>' + escape(out.n[i]) + nSpace[i] + "</ins>";
      } else {
        var pre = "";

        for (n = out.n[i].row + 1; n < out.o.length && out.o[n].text == null; n++ ) {
          pre += '<del>' + escape(out.o[n]) + oSpace[n] + "</del>";
        }
        str += " " + out.n[i].text + nSpace[i] + pre;
      }
    }
  }
  
  return str;
}


function diff( o, n ) {
  var ns = new Object();
  var os = new Object();
  
  for ( var i = 0; i < n.length; i++ ) {
    if ( ns[ n[i] ] == null )
      ns[ n[i] ] = { rows: new Array(), o: null };
    ns[ n[i] ].rows.push( i );
  }
  
  for ( var i = 0; i < o.length; i++ ) {
    if ( os[ o[i] ] == null )
      os[ o[i] ] = { rows: new Array(), n: null };
    os[ o[i] ].rows.push( i );
  }
  
  for ( var i in ns ) {
    if ( ns[i].rows.length == 1 && typeof(os[i]) != "undefined" && os[i].rows.length == 1 ) {
      n[ ns[i].rows[0] ] = { text: n[ ns[i].rows[0] ], row: os[i].rows[0] };
      o[ os[i].rows[0] ] = { text: o[ os[i].rows[0] ], row: ns[i].rows[0] };
    }
  }
  
  for ( var i = 0; i < n.length - 1; i++ ) {
    if ( n[i].text != null && n[i+1].text == null && n[i].row + 1 < o.length && o[ n[i].row + 1 ].text == null && 
         n[i+1] == o[ n[i].row + 1 ] ) {
      n[i+1] = { text: n[i+1], row: n[i].row + 1 };
      o[n[i].row+1] = { text: o[n[i].row+1], row: i + 1 };
    }
  }
  
  for ( var i = n.length - 1; i > 0; i-- ) {
    if ( n[i].text != null && n[i-1].text == null && n[i].row > 0 && o[ n[i].row - 1 ].text == null && 
         n[i-1] == o[ n[i].row - 1 ] ) {
      n[i-1] = { text: n[i-1], row: n[i].row - 1 };
      o[n[i].row-1] = { text: o[n[i].row-1], row: i - 1 };
    }
  }
  
  return { o: o, n: n };
}





angular.module('admin.dialogs', [])
.controller('SubmitCancelDialogCtrl',function($rootScope, $uibModalInstance, params, $q, dialogs, $timeout, $translate){
		//-- Variables --//

		var self = this;
		self.data = params.data;
		self.params = {
			submit: function(){return $q.resolve(true);},
			cancel: function(){return $q.resolve(true);},
			failure: function(error){return $q.reject(error);},
		}
		angular.extend(self.params, params);
		self.message = null;
		self.is_busy = false;

		//-- Methods --//
		
		self.failure = function(error){
			self.message={type:'danger', body:error.data.message || 'An error has occured'}
			if (error.data.code == 401) {
				$rootScope.$emit('unauthorized');
			}
			if (error.data.code == 1) {
				self.message.type='warning';
			}
		}
		
		self.cancel = function(){
			return self.params.cancel(self.data).then(function(){
				$uibModalInstance.dismiss('Canceled');
			}).catch(self.failure);
		}; // end cancel
		
		self.submit = function(){
			if (self.is_busy) {
				return;
			}
			self.is_busy = true;
			return self.params.submit(self.data).then(function(result){
				$uibModalInstance.close(result);
				if (result && result.__callstatus && result.__callstatus.message) {
					$timeout(function(){
						var title = self.params.title? $translate.instant(self.params.title) : $translate.instant('Information');
						dialogs.notify(title, $translate.instant(result.__callstatus.message));
					}, 500);  // wait for the prevoius dialog to hide
				}
				//self.is_busy = false;
			}).catch(function(error){
				self.is_busy = false;
				self.params.failure(error).then(self.failure).catch(self.failure);
			});
		};  // end save
		
		self.hitEnter = function(evt, is_true){
			if(angular.equals(evt.keyCode,13) && is_true)
				self.submit();
		};
}) // end controller(customDialogCtrl)






angular.module('admin')
.controller('FileUploadCtrl', function (FileUploader, $cookies, $timeout, ListController, AdditionalFormData) {
	var uploader = this.uploader = new FileUploader({
        url: ListController.Class.get_url('upload'),
        autoUpload: true,
        removeAfterUpload: true,
        headers: {'X-XSRF-TOKEN': $cookies.get('XSRF-TOKEN')},
        formData: [{x:1}]
    });

	var self = this;
	this.current_item = null;
	this.current_item_error = '';

    // CALLBACKS

    uploader.onWhenAddingFileFailed = function(item /*{File|FileLikeObject}*/, filter, options) {
        console.info('onWhenAddingFileFailed', item, filter, options);
    };
    uploader.onAfterAddingFile = function(fileItem) {
    	console.info('onAfterAddingFile', fileItem);
    };
    uploader.onAfterAddingAll = function(addedFileItems) {
        console.info('onAfterAddingAll', addedFileItems);
    };
    uploader.onBeforeUploadItem = function(item) {
        console.info('onBeforeUploadItem', item);
        self.current_item = item;
        self.current_item_error = '';
        //item.formData.push({parent_vid: $scope.object.__vid});
        item.formData.push(AdditionalFormData);
    };
    uploader.onProgressItem = function(fileItem, progress) {
        console.info('onProgressItem', fileItem, progress);
    };
    uploader.onProgressAll = function(progress) {
        console.info('onProgressAll', progress);
    };
    uploader.onSuccessItem = function(fileItem, response, status, headers) {
        console.info('onSuccessItem', fileItem, response, status, headers);
        ListController.reload();
    };
    uploader.onErrorItem = function(fileItem, response, status, headers) {
        console.info('onErrorItem', fileItem, response, status, headers);
        var message = response.message || 'unknown reason';
        try {
        	var message = JSON.decode(response).message;
        } catch (e) {}
        self.current_item_error = 'Error (' + status + '): ' + message;
    };
    uploader.onCancelItem = function(fileItem, response, status, headers) {
        console.info('onCancelItem', fileItem, response, status, headers);
    };
    uploader.onCompleteItem = function(fileItem, response, status, headers) {
        console.info('onCompleteItem', fileItem, response, status, headers);
    };
    uploader.onCompleteAll = function() {
        console.info('onCompleteAll');
        $timeout(function(){
        	if (self.current_item.isSuccess) self.current_item = null;
        }, 2000);
    };

    console.info('uploader', uploader);
    
    window.$fileupload = self;
});






Grid = window.Grid || {};

Grid.AgCellRenderer = function(field, $ctrl, $translate, $filter) {

	var basicViewFields = ['Field','TextField','DateField','IntervalField','UrlField',
									'CalculatedField','TextCalculatedField', 'ExpressionField'];
									
	var def = {
		width: 150
	};
	if (field.client && field.client.grid && field.client.grid.width) def.width = field.client.grid.width;

	var visibilityFilter = function(cellRenderer) {
		return function(params) {
			if (params.data.has_perm && params.data.has_perm(field.viewperm)) {
				return cellRenderer(params) || '';
			}
			return '<i class="fa fa-eye-slash"></i>';
		}
	}
	
	var field_type = field.type;
	if (field.client && field.client.widget && field_type != "SequenceField") field_type = field.client.widget;

	if (field_type == 'ReferenceField') {
		//def.valueGetter = 'data.'+field.name+'.__title';
		//def.valueGetter = visibilityFilter(function(params) {return (params.data[field.name]||{}).__title;})
		def.cellRenderer = visibilityFilter(function(params) {return (params.data[field.name]||{}).__title;})
	} else if (basicViewFields.indexOf(field_type) > -1) {
		// nothing
		def.cellRenderer = visibilityFilter(function(params) {return params.data[field.name];})
	} else if (field_type == 'DateTimeField' || field_type == 'TimeField') {
		if (field.client && field.client.display=='shorttime') {
			def.cellRenderer = visibilityFilter(function(params) {
				return (params.data[field.name]||'').replace(/:\d\d(\.\d*)?$/, '');
			})
		} else {
			def.cellRenderer = visibilityFilter(function(params) {return params.data[field.name];})
		}
	} else if (field_type == 'CurrencyField' || field_type == 'CurrencyCalculatedField') {
		def.cellRenderer = visibilityFilter(function(params) {
			var values = [];
			for (var currency in params.data[field.name]) values.push(currency + ' ' + (params.data[field.name][currency]||0).toFixed(2));
			return values.join(' + ');
		})
		def.cellClass="text-right"
	} else if (field_type == 'TagField') {
		def.cellRenderer = visibilityFilter(function(params) {
			var values = [];
			for (var i in params.data[field.name]) values.push(params.data[field.name][i]);
			return values.join(', ');
		})
	} else if (field_type == 'BooleanField' || field_type == 'BooleanCalculatedField') {
		def.cellRenderer = visibilityFilter(function(params) {
			return params.data[field.name]? '<i class="fa fa-check"></i>' : '<i class="fa fa-minus"></i>'
		})
	} else if (field_type == 'WorkflowField') {
		def.cellRenderer = visibilityFilter(function(params) {
			//var original = field.workflow.states[params.data[field.name]].name || params.data[field.name];
			var original = field.dictionary[params.data[field.name]] || params.data[field.name];
			return $translate.instant(original);
		})
	} else if (field_type == 'DictionaryField') {
		def.cellRenderer = visibilityFilter(function(params) {
			var original = params.data[field.name];
			for (var i=0; i<field.dictionary.length; i++) {
				if (field.dictionary[i][0] == params.data[field.name]) {
					original = field.dictionary[i][1];
					break;
				}
			}
			return $translate.instant(original);
		})
	} else if (field_type == 'DecimalField' || field_type == 'DecimalCalculatedField' || field_type == 'IntField') {
		var client = field.client || {};
		var numberpl = $filter('numberpl');
		def.cellRenderer = visibilityFilter(function(params) {
			return (client.prefix||'') + ' ' + numberpl(params.data[field.name]) + ' ' + (client.suffix||'');
		})
		def.cellClass="text-right"
	} else if (field_type == 'SequenceField') {

		def.cellRenderer = visibilityFilter(function(params) {return params.data[field.name];})
		def.rowDrag = true;
		$ctrl.gridOptions.rowDragManaged = false;  // default
		//$ctrl.gridOptions.animateRows = false;
		$ctrl.dragFieldName = field.name;

	} else {
		def.cellRenderer = visibilityFilter(function(params) {
			params.$scope.fields = params.$scope.fields || {};
			params.$scope.fields[field.name] = field;
			return '<div field-value="fields.'+field.name+'" object="data"></div>';
		})
		// compile rows
		$ctrl.gridOptions.angularCompileRows = true;
	}
	
	return def;
}

Grid.makeGridOptions = function(gridOptions, $translate) {

	return angular.extend({
			headerHeight: 30,
			rowHeight: 30,
			colWidth: 150,
			enableColResize: true,
			icons: {
	            // use font awesome for menu icons
	            menu: '<i class="fa fa-bars"/>',
	            filter: '<i class="fa fa-filter"/>',
	            sortAscending: '<i class="fa fa-caret-up"/>',
	            sortDescending: '<i class="fa fa-caret-down"/>',
	            // use some strings from group
	            groupExpanded: '<img src="minus.png" style="width: 15px;"/>',
	            groupContracted: '<img src="plus.png" style="width: 15px;"/>',
				columnMovePin: '<i class="fa fa-thumb-tack"/>', // when column is to the left, before it gets pinned
				columnMoveAdd: '<i class="fa fa-plus"/>', // when adding a column
				columnMoveHide: '<i class="fa fa-minus"/>', // when removing a column
				columnMoveMove: '<i class="fa fa-arrows-h"/>', // when moving a column
				columnMoveLeft: '<i class="fa fa-caret-left"/>', // when moving and scrolling left
				columnMoveRight: '<i class="fa fa-caret-right"/>', // when moving and scrolling right
	        },
	        suppressNoRowsOverlay: true,
	        suppressLoadingOverlay: true,
			//suppressDragLeaveHidesColumns: true,
			localeText: {
				// for number filter
				equals: $translate.instant('Equals'),
				lessThan: $translate.instant('Less than'),
				greaterThan: $translate.instant('Greater than'),

				// for text filter
				contains: $translate.instant('Contains'),
				startsWith: $translate.instant('Starts with'),
				endsWith: $translate.instant('Ends with'),

				filterOoo: $translate.instant('filter...'),
			}
		}, gridOptions);

}

Grid.AgGridComponent = {
	template: '<div ag-grid="gridCtrl.gridOptions" set-to-parent-height class="{{gridCtrl.agClass}}" style="display:none; flex-grow: 1;"></div>',
	transclude: false,
	bindings: {
		listController: '=',
		selectAction: '&',
		agClass: '@',
		cellClassRules: '=',
		mergeGridColumnDefs: '=',
	},
	controllerAs: 'gridCtrl',
	controller: function($injector, $scope, $filter, $rootScope, $timeout, $translate, $q, pinesNotifications, GridHelpers) {
	
		var self = this;
		this.Class = this.listController.Class;
		
		this.agClass = this.agClass || 'ag-bootstrap'
		
		this.prefs = null;  // the grid prefs object in the future
		this.objects = null;

		this.pinesNotifications = pinesNotifications;
		
		this.gridOptions = GridHelpers.makeGridOptions({
			enableServerSideSorting: true,
			suppressCellSelection: true,  // do not click individual cells
			rowSelection: 'single',
			angularCompileRows: false,  // sloow
			rowData: null,
			columnDefs: null,
			animateRows: true,
		});

		this.dragFieldName = null;
		
		this.getColumnDefs = function() {
			var fields = this.Class.get_fields('list');
			
			var defs = [];
			for (var i in fields) {
				var field = fields[i];
				// check static perm
				if (!this.Class.perms[field.listperm]) continue;
				var def = {
					colId: field.name,
					field: field.name,
					fieldInfo: field,  // custom information for cellTemplate
					headerName: $filter('translate')(field.title),
					headerTooltip: $filter('translate')(field.title),
					hide: false,
					//enableHiding: false,
					//enableSorting: true,
					//minWidth: 70,
					//cellTemplate: '<div class="ui-grid-cell-contents" title="TOOLTIP" field-value="{object:row.entity, field:col.colDef.fieldInfo}"></div>'
				};

				angular.extend(def, GridHelpers.makeAgCellRenderer(field, self));
				
				// merge colDefs from main.js
				if (this.mergeGridColumnDefs) {
					for (var j=0; j<this.mergeGridColumnDefs.length; j++) {
						if (this.mergeGridColumnDefs[j].colId == def.colId) {
							angular.extend(def, this.mergeGridColumnDefs[j]);
						}
					}
				}

				defs.push(def);
			}
			return defs;
		}
		
		this.gridOptions.columnDefs = this.getColumnDefs();
		// compile angular for unusual fields
		for (var ci=0; ci<this.gridOptions.columnDefs.length; ci++) {
			if (this.cellClassRules) this.gridOptions.columnDefs[ci].cellClassRules = this.cellClassRules
		}

		this.gridOptions.getRowNodeId = function(data) { return data.__rec_id || data.__id }
		
		this.gridOptions.onGridReady = function() {
			// open target object
			self.gridOptions.api.addEventListener('rowClicked', function(event){
				self.selectAction({object: event.data, event: event.event});
			});
			// set sort model - update col icons
			var sort = self.listController.params.sort;
			var sortModel = [];
			for (var i=0; i<sort.length; i++) {
				var info = self.getSortModel(sort[i]);
				if (info) sortModel.push(info);
			}
			self.gridOptions.api.setSortModel(sortModel);
			// sorting
			self.gridOptions.api.addEventListener('sortChanged', function(event){
				console.log('sortChanged', event);
				var sortmodel = self.gridOptions.api.getSortModel()
				var sort = [];
				for (var i=0; i<sortmodel.length; i++) {
					var info = sortmodel[i];
					var sort_expr = self.getSortExpr(info);
					if (sort_expr) sort.push(sort_expr);
				}
				if (sort.length == 0) sort.push(self.Class.default_sort);
				self.updateSort(sort);

				// enable/disable row dragging
				self.gridOptions.api.setSuppressRowDrag(self.listController.params.sort[0] != self.dragFieldName)
			});
			
			//self.gridOptions.api.addEventListener('columnVisible columnPinned afterColumnResized columnMoved', function(event){
			self.gridOptions.api.addEventListener('columnResized', function(event){
				self.colState = self.gridOptions.columnApi.getColumnState();
			});
			self.gridOptions.api.addEventListener('columnMoved', function(event){
				//console.log('columnChanged', event);
				self.colState = self.gridOptions.columnApi.getColumnState();
				//self.saveColState();
			});
			self.gridOptions.api.addEventListener('columnPinned', function(event){
				self.colState = self.gridOptions.columnApi.getColumnState();
			});
			self.gridOptions.api.addEventListener('columnVisible', function(event){
				self.colState = self.gridOptions.columnApi.getColumnState();
			});
			self.gridOptions.api.addEventListener('dragStarted', function(event){
				console.log('dragStarted', event);
			});
			self.gridOptions.api.addEventListener('rowDragMove', function(event){
				//console.log('rowDragMove', event);
				self.onRowDragMove(event)
			});
			self.gridOptions.api.addEventListener('rowDragEnd', function(event){
				console.log('rowDragEnd', event);
				self.onRowDragEnd(event)
			});




			self.colState = self.gridOptions.columnApi.getColumnState();

		};
		
		this.updateSort = function(sort) {
			self.listController.params.sort = sort;
			self.listController.reload();
		}
		
		this.getSortExpr = function(info) {
			var fields = this.Class.get_fields('list');
			for (var i in fields) {
				if (fields[i].name == info.colId) {
					return (info.sort=='desc'?'-':'') + fields[i].sort_expr;
				}
			}
			return null;
		}
		
		this.getSortModel = function(sort_expr) {
			var direction = 'asc';
			if (sort_expr[0] == '-') {
				sort_expr=sort_expr.substr(1);
				direction = 'desc';
			}
			var fields = this.Class.get_fields('list');
			for (var i in fields) {
				if (fields[i].sort_expr == sort_expr) {
					return {colId: fields[i].name, sort: direction};
				}
			}
			return null;
		}
		
		//$scope.$watch(function(){return self.listController.objects}, function(objects){
		self.listController.getPage.subscribe(function(objects){
			self.gridOptions.api.setRowData(objects);
			self.objects = objects;
		});
		
		// load column state
		this.listController.promises.prefs.then(function(prefs){
			self.prefs = prefs;
			var state = prefs.getItem('colState');
			if (state && state.length == self.gridOptions.columnDefs.length) {
				// reapply saved state
				self.colState = state;
				gridCtrl.gridOptions.columnApi.setColumnState(state);
			}
		});
		this.getColumnDef = function(colId) {
			for (var i in self.gridOptions.columnDefs) {
				var def = self.gridOptions.columnDefs[i];
				if (def.colId == colId) return def;
			}
		}
		this.saveColState = function(){
			if (self.colState && self.prefs) {
				self.gridOptions.columnApi.setColumnState(self.colState);
				return self.prefs.setItem('colState', self.colState);
			}
			$q.when(true);
		}

		this.origDataIndices = null
		this.onRowDragMove = function (event) {
			var movingNode = event.node;
			var overNode = event.overNode;
		
			var rowNeedsToMove = movingNode !== overNode;
		
			if (rowNeedsToMove) {
				self.gridOptions.animateRows = true;
				self.gridOptions.deltaRowDataMode = true;
				// the list of rows we have is data, not row nodes, so extract the data
				var movingData = movingNode.data;
				var overData = overNode.data;
		
				var fromIndex = self.objects.indexOf(movingData);
				var toIndex = self.objects.indexOf(overData);

				if (!self.origDataIndices) {
					self.origDataIndices = {}
					for (var i=0; i<self.objects.length; i++) {
						self.origDataIndices[self.objects[i].__id] = i;
					}
				}
		
				//var newStore = self.objects.slice();
				moveInArray(self.objects, fromIndex, toIndex);
		
				//self.objects = newStore;
				self.gridOptions.api.setRowData(self.objects);
		
				self.gridOptions.api.clearFocusedCell();
			}
		
			function moveInArray(arr, fromIndex, toIndex) {
				var element = arr[fromIndex];
				arr.splice(fromIndex, 1);
				arr.splice(toIndex, 0, element);
			}
		}

		this.onRowDragEnd = function (event) {
			self.gridOptions.animateRows = false;
			self.gridOptions.deltaRowDataMode = false;
			var movingNode = event.node;
			var overNode = event.overNode;
			var rowNeedsToMove = self.origDataIndices[movingNode.data.__id] !== event.overIndex;
			if (!rowNeedsToMove) return;
			
			var mode = self.origDataIndices[movingNode.data.__id] > event.overIndex ? 'before' /* up */: 'after' /* down */;
			var targetObj = self.objects[event.overIndex + (mode == "before" ? 1 : -1)];
			movingNode.data[self.dragFieldName + '__place']({target_id: targetObj.__id, mode:mode}).then(function(){
				self.listController.reload();
			}, function(error){
				self.pinesNotifications.notify({
					title: 'An error occured while reordering',
					text: error.data? error.data.message: error,
					type: 'error'
				});
				self.listController.reload();
			})
			self.origDataIndices = null;
		}
		
		/*$rootScope.$watch('elementHeight', function(h){
			$timeout(function(){
				if (self.gridOptions.api) {  // grid might not exist by then
					self.gridOptions.api.doLayout()
				}
			});
		}, true);*/
		
		
		// register options screen
		self.listController.options.push({'title': $translate.instant('Columns'), 'templateUrl': 'framework/partials/grid/options-columns.html', grid: self, save: function(){return self.saveColState()}});
		
		window.gridCtrl = self;
		
	}
}





Grid = window.Grid || {};


Grid.PagerComponent = {
    	templateUrl: 'framework/partials/grid/pager.html',
    	bindings: {
    		listController: '=',
    	},
 		controllerAs: 'pageCtrl',
 		transclude: true,
    	controller: function() {
    		var self = this;
    		this.rows_per_page_selection = [2,25,50,100,500];
    		this.cache = {}
    		this.isSearchAvailable = function() {
    			return typeof self.listController.state.showSearch != "undefined";
    		}
    		this.toggleSearch = function() {
    			self.listController.state.showSearch = !self.listController.state.showSearch;
    		}
    		
    		this.arePrefsAvailable = function() {
    			return self.listController.options.length > 0;
    		}

    		this.isExportAvailable = function() {
    			if (!this.cache.isExportAvailable) {
    				this.cache.isExportAvailable = self.listController.isExportAvailable();
    			}
    			return this.cache.isExportAvailable;
    		}

    		this.showPrefs = function() {
    			self.listController.showPrefs();
    		}

    		this.export = function(format) {
    			self.listController.export(format);
    		}
    		
    		//$scope.$watch(function(){return self.listController.objects_count}, function(){ 
			this.listController.getPage.subscribe(function(objects){
				self.page = self.listController.params.offset / self.listController.params.limit + 1;
				self.pages = Math.max(1, Math.ceil((self.listController.objects_count.filtered || 0) / self.listController.params.limit));
				self.prevPage = self.page;
    		});
    		
    		this.addPage = function(delta) {
    			self.page += delta;
    			self.changePage();
    		}
    		
    		this.firstPage = function() {
    			self.page = 1;
    			self.changePage();
    		}
    		
    		this.lastPage = function() {
    			self.page = self.pages;
    			self.changePage();
    		}
    		
    		this.changePage = function() {
    			if (self.page < 1) self.page = 1;
    			if (self.page > self.pages) self.page = self.pages; 
				if (self.prevPage != self.page) {
					self.listController.params.offset = (self.page - 1) * self.listController.params.limit;
					self.listController.getPage();
					self.prevPage = self.page;
				}
    		}
    		
    		this.setPageSize = function(n) {
    			self.listController.setRowsPerPage(n);
    			self.prevPage = null;
    			self.firstPage();
    		}
    		
    		this.reload = function() {
    			self.listController.getPage();
    		}
    		
    		window.pageCtrl = this;
    		
    	}
}

Grid = window.Grid || {};


Grid.FilterComponent = {
    	templateUrl: 'framework/partials/grid/filter.html',
    	bindings: {
    		listController: '=',
    	},
 		controllerAs: 'filterCtrl',
    	controller: function($scope, FieldTplDir, $timeout) {
    		var self = this;
    		
    		this.fieldTplDir = FieldTplDir;
    		this.fields = this.listController.Class.get_fields('filter').filter(function(field){return self.listController.Class.perms[field.listperm]});
    		if (this.fields.length > 0) {
    			// activate pager's filter icon
    			this.listController.state.showSearch = this.listController.state.showSearch || null;  // ng-if, let the pager know
    		}
    		var search_timeout = null;
			
			$scope.$watch('filter', function(filter, oldfilter) {
				if (filter === oldfilter) return;
				$timeout.cancel(search_timeout);
				search_timeout = $timeout(function(){
						var query = {};
						// sanitize filter
						for (var k in filter) {
							var v = filter[k];
							if (typeof v == "undefined" || v === null || v === "" || v.length === 0) {
								//delete $scope.filter[k];
								continue;
							}
							if (typeof v == "string" && k.indexOf('~')>0) v = v.replace(/[^0-9A-Za-z\u00C0-\u017F @_\-.]/g, '');
							if (typeof v.from != "undefined" && typeof v.to != "undefined") {
								if (v.from != null && v.to != null) {
									v = '[' + v.from + ',' + v.to + ']';
								} else continue;
							}
							query[k] = angular.copy(v); 
						}
						if (!angular.equals(query, self.listController.params.filter)) {
							self.listController.params.offset = 0;
							//self.listController.params.filter = query;
							self.listController.setFilter(query);
							self.listController.getPage();
						}
				}, 200);
			}, true);
			
			//$scope.$watch(function(){return self.listController.params.filter}, function(filter) {
			this.controllerFilterChanged = function(filter){
				$scope.filter = angular.copy(filter);
				for (var k in filter) {
					var v = filter[k];
					var matches;
					if (typeof v == "string" && (matches = v.match(/[\[\(](.*),(.*)[\]\)]/))) {
						v = {from: matches[1], to: matches[2]}
					}
					$scope.filter[k] = angular.copy(v); 
				}
			}
			this.listController.setFilter.subscribe(this.controllerFilterChanged);
			$scope.filter = {};
	        this.controllerFilterChanged(self.listController.params.filter)
			
			
			this.has_filter = function(fieldname) {  // dla search-box
	        	for (var i in $scope.fieldname2filter[fieldname]) {
	        		var recipe = $scope.fieldname2filter[fieldname][i];
	        		if (!recipe) continue;
	        		var expr = $scope.$eval(recipe, {field:self.listController.Class.fields[fieldname]}) || fieldname;
	        		if ($scope.filter[expr]) return true;
	        	}
	        	return false;
	        }
	        
	        // leagcy stuff
	        $scope.create_mode = true; // do we need this?
	        $scope.fieldname2filter = {}
	        $scope.cls = this.listController.Class
    		
    		window.filterCtrl = this;
    		
    	}
}



// TODO - isolate scope, 
Grid.FilterComponentField = function() {
    return {
    	scope: true,
    	link: function(scope, element, attrs) {
			scope.create_mode = true;
			scope.object = {};
			scope.fieldname2filter[scope.field.name] = [];
			scope.fieldname2filter[scope.field.name].push(attrs.expr || scope.field.name)
			scope.fieldname2filter[scope.field.name].push(attrs.expr2);
		}
	}
};




function GridState(scope, manager) {
	
	var self = this;
	
	this.scope = scope
	this.manager = manager;
	this.data = manager.state[this.scope];
	this.getItem = function (name) {
		return self.data[name];
	}
	
	this.getItem = function(name, defaultvalue) {
		return self.data[name] || defaultvalue;
	}
	
	this.setItem = function(name, value) {
		// allow for multiple settings at once
		if (typeof name == "object") {
			for (var key in name) {
				self.data[key] = name[key];
			}
		} else {
			self.data[name] = value;
		}
		return self.save();
	}
	
	this.setDefault = function(name, value) {
		// allow for multiple settings at once
		if (typeof name == "object") {
			var data = {};
			for (var key in name) {
				// only set if no previous value
				if (typeof self.getItem(name) == "undefined") {
					data[key] = name[key];
				}
			}
			return self.setItem(data);
		} else {
			// only set if no previous value
			if (typeof self.getItem(name) == "undefined") {
				return self.setItem(name, value);
			}
		}
	}
	
	this.save = function() {
		return manager.save(self.scope, self.data);
		
	}
}

function GridVolatileStateManager() {

	var manager = this;
	this.state = {};
	this.fifo = [];
	
	this.save = function(scope, data) {
		this.state[scope] = data;
		this.moveFifo(self.scope);
	}
	
	this.moveFifo = function(scope) {
		if (this.fifo.length == 0 || this.fifo[this.fifo.length - 1] != scope) {
			for (var i=0; i<this.fifo.length; i++) {
				if (this.fifo[i] == scope) this.fifo.splice(i, 1);
			}
			this.fifo.push(scope);
			this.removeOld();
		}
	}
	
	this.removeOld = function() {
		if (this.fifo.length > 100) {
			var remove = this.fifo.splice(0,this.fifo.length - 100);
			for (var i=0; i<remove.length; i++) {
				delete this.state[remove[i]];
			}
		}
	}
	
	this.get = function (scope) {
		// returns a scoped storage
		this.state[scope] = this.state[scope] || {}
		return new GridState(scope, this);
	}

}

function GridPersistentStateManager(CurrentUserPrefs) {

	var manager = this;
	this.state = {};
	
	this.save = function(scope, data) {
		this.state[scope] = data;
		return CurrentUserPrefs.put(scope, data);
	}
	
	this.load = function (scope) {
		// returns a scoped storage
		scope = 'grid-prefs-' + scope;
		return CurrentUserPrefs.get(scope).then(function(prefs) {
			manager.state[scope] = prefs || {};
			return new GridState(scope, manager);
		});
		
	}

}


Grid = window.Grid || {};
Grid.GridVolatileStateManager = GridVolatileStateManager;
Grid.GridPersistentStateManager = GridPersistentStateManager;



function GridTabs ($uibModal, dialogs, $translate, tabs, prefs, listController) {
	
	var self = this;
	
	this.tabs = tabs;
	this.listController = listController;
	this.dynamic = null;
	//this.current = tabs[0];
	
	
	// activate tab by updating global params
	this.activateTab = function(tab) {
		//for (var member in self.filter) delete self.filter[member];
		self.current = tab;
		if (tab !== self.dynamic) self.dynamic = null;
		if (this.isTabActive(tab)) return;
		self.filter = {};
		angular.extend(self.filter, tab.filter);
		//self.listController.params.filter = self.filter;
		self.listController.setFilter(self.filter);
		self.listController.getPage();
	}
	
	this.isTabActive = function(tab) {
		if (!tab) return false;
		if (tab && tab === self.dynamic) return true;
		return angular.equals(tab.filter, self.filter);
	}
	
	this.searchChanged = function(filter) {
		self.filter = filter;
		var is_predefined = false;
		for (var i in self.tabs) {
			if (self.isTabActive(self.tabs[i])) {
				is_predefined = true;
				self.current = self.tabs[i];
			}
		}
		if (is_predefined) {
			// remove dynamic tab
			self.dynamic = null;
		} else {
			self.dynamic = {
				title: $translate.instant('New search'),
				icon: 'fa fa-pencil',
				dynamic: true,
			}
			self.current = self.dynamic;
		}
	}
	
	this.deleteTab = function(tab) {
		var index = self.tabs.indexOf(tab);
		if (index < 0) {
			alert("Błąd usuwania zakłądki!");
			return;
		}
		if (tab.mandatory) {
			alert("Nie możesz usunąć tej zakładki");
			return;
		}
		dialogs.confirm($translate.instant('Delete tab'), 
				$translate.instant('Do you really want to delete')+' "'+tab.title+'"?', {size:'md'}).result.then(function() {
			self.tabs.splice(index, 1);
			self.activateTab(self.tabs[0]);
		});
	}
	
	this.addTab = function() {
		var tab = {
			title: self.dynamic.title,
			filter: self.filter,
			icon: 'fa fa-filter'
		}
		
		var save = function(data) {
			self.tabs.push(data);
			self.dynamic = null;
			return self.saveTabs();
		}
		//var dlg = dialogs.create('framework/partials/grid/dialog-save-tab.html','SaveCancelDialogCtrl',{data:tab,save:save},{size:'lg'});
		var dlg = $uibModal.open({
		      animation: true,
		      templateUrl: 'framework/partials/grid/dialog-save-tab.html',
		      controller: 'SubmitCancelDialogCtrl as dCtrl',
		      size: 'md',
		      resolve: {
		        params: function () {
		          return {data:tab,submit:save}
		        }
		      }
		});
	}
	
	this.saveTabs = function() {
		var tabs = []
		for (var i in self.tabs) {
			var tab = self.tabs[i];
			tabs.push({
				title: tab.title,
				filter: tab.filter,
			});
		}
		return prefs.setItem('tabs', tabs);
	}
	
	this.activateDefalt = function() {
		//this.activateTab(this.tabs[0])
		var tab = this.tabs[0];
		self.listController.setFilter(tab.filter);
		self.searchChanged(tab.filter);
	}
	
}


function GridTabsManager($q, dialogs, $rootScope, $injector, $translate) {
	
	var self = this;
	this.dialogs = dialogs;
	this.getTabsFor = function(prefs, listController, predefinedFilters) {
		
		var tabs = prefs.getItem('tabs', []);
		if (typeof tabs.length != "number") tabs = [];
		for (var i in tabs) {
			tabs[i].icon = 'fa fa-filter';
			if (tabs[i].filter.length == 0) tabs[i].filter = {};
		}

		for (var t=predefinedFilters.length-1; t>=0; t--) {
			this.pushTab(tabs, predefinedFilters[t]);
		}
		/*
		this.pushTab(tabs, {
			title: $translate.instant('All'),
			icon: 'fa fa-list',
			filter: {},
			mandatory: true,  // cannot delete
			dynamic: false,   // saved, do not offer save dialog
		});
		*/

		var manager = $injector.instantiate(Grid.GridTabs, {prefs: prefs, tabs:tabs, listController:listController});
		
		// register options screen
		listController.options.push({
			'title': $translate.instant('Filter tabs'), 
			'templateUrl': 'framework/partials/grid/options-tabs.html',
			manager: manager, 
			save: function(){return manager.saveTabs()}
		});
		
		return manager
	}
	
	this.pushTab = function(tabs, tab) {
		var orig = this.getTabForFilter(tabs, tab.filter);
		if (!orig) {
			tabs.splice(0,0,tab);
		} else {
			orig.mandatory = tab.mandatory;
			orig.dynamic = tab.dynamic;
			orig.icon = tab.icon;
		}
	}
	
	this.getTabForFilter = function(tabs, filter) {
		for (var i in tabs) {
			var tab = tabs[i];
			if (angular.equals(tab.filter, filter)) {
				return tab;
			}
		}
		return null;
	}
	
	
}



Grid = window.Grid || {};
Grid.GridTabs = GridTabs;
Grid.GridTabsManager = GridTabsManager;


Grid.TabsComponent = {
    	templateUrl: 'framework/partials/grid/tabs.html',
    	bindings: {
    		listController: '=',
    		tabsType: '@',  // 'tabs' | 'pills'
			predefinedFilters: '<',
			onLoad: '&'
    	},
    	replace: true,
 		controllerAs: 'tabsCtrl',
    	controller: function(GridTabsManager, $q) {
    		
    		self = this;
    		this.tabsClass = this.tabsType || 'tabs'

			var predefinedFilters = $q.resolve(self.predefinedFilters);
    		console.debug("Tabs activate wait...")
    		$q.all([this.listController.promises.prefs, predefinedFilters]).then(function(params){
				console.debug("Tabs activate fired!")
				var prefs = params[0];
				var predefinedFilters = params[1];

    			// create tabs
    			self.tabs = GridTabsManager.getTabsFor(prefs, self.listController, predefinedFilters || [])  //.then(function(tabs){self.tabs = tabs});
				
				if (self.listController.session.getItem('filter', null) != null) {
					// got some seach
					self.tabs.searchChanged(self.listController.params.filter);
				} else {
					// opened for the first time
					self.tabs.activateDefalt()
				}
				
				// bind to search change
				self.listController.setFilter.subscribe(function(objects){
					self.tabs.searchChanged(self.listController.params.filter);
				});

				self.onLoad({});

				return prefs;
    		});
    		
    		window.tabsCtrl = this;
    	}
}


var grid = angular.module('grid', ["agGrid", "dialogs.main", "as.sortable", "ngDraggable"])
.service('GridVolatileStateManager', Grid.GridVolatileStateManager)
.service('GridPersistentStateManager', Grid.GridPersistentStateManager)
.service('GridTabsManager', Grid.GridTabsManager)

.service('GridHelpers', function($translate, $filter) {
	this.makeAgCellRenderer = function(field, $ctrl) {
		return Grid.AgCellRenderer(field, $ctrl, $translate, $filter);
	}
	this.makeGridOptions = function(gridOptions) {
		return Grid.makeGridOptions(gridOptions,$translate);
	}
})

.component('grid', Grid.AgGridComponent)
.component('gridPager', Grid.PagerComponent)
.component('gridFilter', Grid.FilterComponent)
.component('gridTabs', Grid.TabsComponent)
.directive('cmsGridFilter', Grid.FilterComponentField)

.directive('setToParentHeight', function($rootScope) {
    return function(scope, element, attrs) {
    	var evalHeight = function() {
    		return element.parent().outerHeight(true);
    	}
    	var deregister = $rootScope.$watch(evalHeight, function(h) {
    		if (element.closest('.ng-hide').length) {  // parent only
				return;
			}
    		if (element.parent().is(':visible') && h !== null && h != 0) {
    			var border = element.outerHeight() - element.innerHeight();
    			element.height(h - border);
    			element.show();
    		}
    	});
    	scope.$on('$destroy', function(){
    		deregister();
    	});
	}
})




angular.module('theme')

.run(function($themeInitialSettings) {

    $themeInitialSettings['topNavThemeClass'] = 'navbar-default';
    $themeInitialSettings['sidebarThemeClass'] = 'sidebar-midnightblue';

})

angular
  .module('index', [
	'theme',
	'forms',
	'forms.fields.formbuilder',  // requires "formBuilder": "^2.9.8"
    'ui.router',
    'persistent',
	'languages',
	'ngSanitize',
	'uiGmapgoogle-maps',
	'dialogs.main'
	])
	
  .config(function ($stateProvider, $urlRouterProvider, $urlMatcherFactoryProvider, $locationProvider) {
		$urlRouterProvider.otherwise('/');
	
		$urlMatcherFactoryProvider.type("previous", {
			encode: function(value){ return 'previous/' + value },
			decode: function(value){ return 0|value.replace(/^previous\//, '') },
			pattern: /previous\/[0-9]+/
		})

		$urlMatcherFactoryProvider.type("invitation", {
			encode: function(value){ return 'invitation/' + value },
			decode: function(value){ return value.replace(/^invitation\//, '') },
			pattern: /invitation\/[^/]+/
		})

		$stateProvider
			.state("index", {
				url: "/",
				templateUrl: 'partials/index/event-list.html',
				controller: 'EventListController',
				controllerAs: '$ctrl',
			})
			.state("event", {
				url: "/:name/{eventID:previous}/{eventToken:invitation}",
				params: {
					eventID: { squash: true, value: null },
					eventToken: { squash: true, value: null },
				},
				views: {
					"": {
						controller: 'EventController',
						controllerAs: '$sCtrl',
						templateUrl: 'partials/index/event.html',
					},
					/*
					"aside@": {
						controller: 'HeaderController',
						controllerAs: '$header',
						templateUrl: 'partials/index/event-aside.html',
					}
					*/
				}
			})
			.state("event-confirm", {
				url: "/confirm/:hash",
				views: {
					"": {
						controller: 'EventConfirmController',
						controllerAs: '$sCtrl',
						templateUrl: 'partials/index/event-confirm.html',
					}
				}
			})
			.state("event-bulk-confirm", {
				url: "/bulk-confirm/:hash",
				views: {
					"": {
						controller: 'EventBulkConfirmController',
						controllerAs: '$sCtrl',
						templateUrl: 'partials/index/event-bulk-confirm.html',
					}
				}
			})
			.state("proxy-event-confirm", {
				url: "/proxy-confirm/:hash",
				views: {
					"": {
						controller: 'EventProxyConfirmController',
						controllerAs: '$sCtrl',
						templateUrl: 'partials/index/event-confirm.html',
					}
				}
			})
			.state("regstration-info", {
				url: "/status/:hash",
				views: {
					"": {
						controller: 'EventRegistrationController',
						controllerAs: '$sCtrl',
						templateUrl: 'partials/index/event-registration.html',
					}
				}
			})
			.state("proxy-regstration-info", {
				url: "/proxy-status/:hash",
				views: {
					"": {
						controller: 'EventProxyRegistrationController',
						controllerAs: '$sCtrl',
						templateUrl: 'partials/index/event-registration.html',
					}
				}
			})
			.state("regstration-cancel", {
				url: "/cancel/:hash",
				views: {
					"": {
						controller: 'EventCancelController',
						controllerAs: '$sCtrl',
						templateUrl: 'partials/index/event-cancel.html',
					}
				}
			})
			.state("regstration-change-group", {
				url: "/change-group/:hash",
				views: {
					"": {
						controller: 'EventChangeGroupController',
						controllerAs: '$sCtrl',
						templateUrl: 'partials/index/event-change-group.html',
					}
				}
			})
			/*
			.state("event-previous", {
				url: "/:name/previous/:id",
				views: {
					"": {
						controller: 'EventPreviousController',
						controllerAs: '$sCtrl',
						templateUrl: 'partials/index/event.html',
					},
					"aside@": {
						controller: 'HeaderController',
						controllerAs: '$header',
						templateUrl: 'partials/index/event-aside.html',
					}
				}
			})*/
			.state("event.thankyou", {
				url: "/thankyou",
				templateUrl: 'partials/index/event-thankyou.html',
			})
			/*.state("event-invitation", {
				url: "/:name/invitation/:token",
				views: {
					"": {
						controller: 'EventController',
						controllerAs: '$sCtrl',
						templateUrl: 'partials/index/event.html',
					},
					"aside@": {
						controller: 'HeaderController',
						controllerAs: '$header',
						templateUrl: 'partials/index/event-aside.html',
					}
				}
			})*/
			/*
			.state("event-previous-invitation", {
				url: "/:name/previous/:id/invitation/:token",
				views: {
					"": {
						controller: 'EventPreviousController',
						controllerAs: '$sCtrl',
						templateUrl: 'partials/index/event.html',
					},
					"aside@": {
						controller: 'HeaderController',
						controllerAs: '$header',
						templateUrl: 'partials/index/event-aside.html',
					}
				}
			})
			*/
			/*.state("event-invitation.thankyou", {
				url: "/thankyou",
				templateUrl: 'partials/index/event-thankyou.html',
			})*/
			.state("survey", {
				url: "/survey/:name",
				views: {
					"": {
						controller: 'SurveyController',
						controllerAs: '$sCtrl',
						templateUrl: 'partials/index/survey.html',
					},
				}
			})
			.state("event-survey", {
				url: "/eventsurvey/{participat_short_code:[A-Za-z0-9_-]+}",
				views: {
					"": {
						controller: 'EventSurveyController',
						controllerAs: '$sCtrl',
						templateUrl: 'partials/index/survey.html',
					},
				},
				resolve: {
					SurveyInfo: function(Classes, $stateParams) {
						return Classes.EventParticipation.get_survey_info({hash: $stateParams.participat_short_code}).then(function(result){
							return result;
						}, function(error){
							return {error:error};  // pozwól na obsługe błedu po stronie kontrollera
						})
					},
					ParticipantShortCode: function($stateParams) {
						return $stateParams.participat_short_code;
					}
				},
			});
			//$locationProvider.html5Mode({enabled: true, requireBase: false});
  })
   .run(function($rootScope, $location){
		$rootScope.systemName = 'Wydarzenia Industry';
		window.$rootScope = $rootScope;

        $rootScope.$on('$stateChangeSuccess', function (event) {
			// gtag('config', 'AW-1055466125', {'page_path': $location.path()});
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				'event': 'pageview',
				'pagePath': $location.path()
			});
			
			fbq('init', '495944647652309');
			fbq('track', 'PageView');
        });
  })
  .config(function($themeInitialSettingsProvider){
		$themeInitialSettingsProvider.set('fullscreen', true);
  })
  .config(function($logProvider){
    $logProvider.debugEnabled(true);
  })
 .filter('text_teaser', function () {
        return function (value, wordwise, max, tail) {
            if (!value) return '';

            max = parseInt(max, 10);
            if (!max) return value;
            if (value.length <= max) return value;

            value = value.substr(0, max);
            if (wordwise) {
                var lastspace = value.lastIndexOf(' ');
                if (lastspace !== -1) {
                  //Also remove . and , so its gives a cleaner result.
                  if (value.charAt(lastspace-1) === '.' || value.charAt(lastspace-1) === ',') {
                    lastspace = lastspace - 1;
                  }
                  value = value.substr(0, lastspace);
                }
            }

            return value + (tail || ' …');
        };
	})
	.service('MetaService', function(){
		var self = this;
		this.meta = {
			title: 'Wydarzenia Industry',
			contact: null,
			venues: null,
			eventPreviousList: null,
			eventCurrent: null,
			metaDescription: null,
			metaKeywords: null
		}
		this.setTitle = function(title) {
			self.meta.title = title || 'Wydarzenia Industry';
		}
		this.setContact = function(contact) {
			self.meta.contact = contact || null;
		}
		this.setVenues = function(venues) {
			self.meta.venues = venues || null;
		}
		this.setEventPreviousList = function(list) {
			self.meta.eventPreviousList = list || [];
		}
		this.setEventCurrent = function(event) {
			self.meta.eventCurrent = event || null;
		}
		this.setMetaDescription = function(desc) {
			self.meta.metaDescription = desc || null;
		}
		this.setMetaKeywords = function(keywords) {
			self.meta.metaKeywords = keywords || null;
		}
		this.get = function(item) {
			return self.meta[item];
		}
	})
	.service('EventService', function(){
		var self = this;
		this.variables = {
			event_default_group: {},
		}
		this.setEventDefaultGroup = function(eventDefaultGroups) {
			self.variables.event_default_group = eventDefaultGroups || {};
		}
		this.get = function(item) {
			return self.variables[item];
		}
	})
	.controller('HeadController', function($scope, MetaService) {
		this.getTitleWithSuffix = function() {
			var title = MetaService.get('title');
			var suffix = 'Wydarzenia Industry';
			if (title.indexOf(suffix) == -1) title += ' - ' + suffix;
			return title;
		}
		this.getMetaDescription = function(){
			return MetaService.get('metaDescription');
		}
		this.getMetaKeywords = function(){
			return MetaService.get('metaKeywords');
		}
	})
	.controller('HeaderController', function($scope, MetaService, $stateParams, LocaleService) {

        var self = this;
		self.eventToken = $stateParams.token || null;
		this.getTitle = function(){
			return MetaService.get('title');
		}
		this.getTitleWithSuffix = function() {
			var title = MetaService.get('title');
			var suffix = 'Wydarzenia Industry';
			if (title.indexOf(suffix) == -1) title += ' - ' + suffix;
			return title;
		}

		this.getContact = function() {
			return MetaService.get('contact');
		}

		this.getVenues = function() {
			return MetaService.get('venues');
		}
		
		this.getEventPreviousList = function() {
			return MetaService.get('eventPreviousList');
		}

		this.getEventCurrent = function() {
			return MetaService.get('eventCurrent');
		}
	})	
	.run( ['$rootScope', '$state', '$stateParams',
                      function ($rootScope,   $state,   $stateParams) {
    $rootScope.$state = $state;
    $rootScope.$stateParams = $stateParams; 
	}])
  ;

// Angular-Translate configuration
angular.module('languages')
	// Angular-Translate configuration
	.constant('LOCALES', {
		'locales': {
			//'en_US': 'English',
			'pl_PL': 'Рolski'
		},
		'preferredLocale': 'pl_PL',
		'dir': 'assets/locales'
	})

 


angular
.module('index')

	// Map view controller
	.controller('EventListController', function($translate, Classes, ApiRootUrl, MetaService, EventService, $timeout) {

        var self = this;
		self.surveyList = [];
		self.venueList = [];
		self.event_group_list = [];
		self.surveyListLoaded = false;
		
		self.searchTitleQuery = '';
		self.searchCityQuery = [];
		
        this.ApiRootUrl = ApiRootUrl;

		this.getSurveyList = function(){
			Classes.Event.get_list({
				'title_filter': self.searchTitleQuery,
				'city_filter': self.searchCityQuery.length ? self.searchCityQuery : null
			})
			.then(function(response){
				console.log(response);
				var list = response.event_list;
				//console.log(response);
				self.event_group_list = response.event_group_list;
				//console.log(self.event_group_list);
				angular.forEach(list, function(event, key) {
					self.setEventGroupDict(event);
				});				
				self.surveyList = list;
				console.log(list);
				
				$timeout(function(){
					self.setEqualBoxHeight();
				});
				
				return list;
			}).catch(function(e){
				console.log(e);
			});
		}
		self.getSurveyList();
		MetaService.setMetaKeywords()
		MetaService.setMetaDescription()
		MetaService.setTitle()
		MetaService.setContact()
		MetaService.setVenues()
		
		this.getVenueList = function(){
			//Classes.Venue.get_list_by_city()
			Classes.Venue.get_city_list()
			.then(function(list){
				//self.venueList = list;
				self.cityList = list;
				return list;
			}).catch(function(e){
				console.log(e);
			});
		}
		self.getVenueList();
		
		this.checkEventGroupAvailable = function(group){
			
			var now = new Date();
			var start = new Date(group.registration_start);
			var end = new Date(group.registration_end);

			now = now.getTime();
			start = start.getTime();
			end = end.getTime();
			
			if(now < start || now > end )
				return 'is_out_of_time';
			
			if (group.is_blocked || group.is_hidden)
				return 'is_blocked';
			
			return 'is_available';
		}
		
		this.setEqualBoxHeight = function(){
			
			var maxHeight = 0;
			var items = $('.events-list-item');
			
			items.each(function(key){
				if($(this).outerHeight() > maxHeight)
					maxHeight = $(this).outerHeight();
			});
			items.css({
				'height': maxHeight
			});
		}
		
		this.clearFilters = function(){
			self.searchTitleQuery = '';
			self.searchCityQuery = [];		
		}
		
		this.eventDefaultGroups = {};
		this.setEventGroupDict = function(event){
			var activeGroupsCount = 0;
			var eventDefaultGroup = null;
			event.event_groups_dict = [];
			angular.forEach(self.event_group_list, function(group, key) {

				if(group.event_id == event.id) {
					
				var item = {event_id: event.__id, group_id: group.id}
				
				if(group.online)
					var venue_city = 'Online';
				else if(group.venue_city)
					var venue_city = group.venue_city;
				else
					var venue_city = 'Nieokreślone miasto';
				
				//item.label = group.event_full_date + ' - ' + venue_city;
				item.label = group.event_start + ' - ' + venue_city;

				var group_state = self.checkEventGroupAvailable(group);
				if(group_state == 'is_blocked'){
					item.label += ' (' + $translate.instant('There are no vacancies') + ')';
					item.disabled = true;
				}else if(group_state == 'is_out_of_time'){
					// item.label += ' (' + $translate.instant('Registration completed') + ')';
					// item.disabled = true;
					return false;
				}
				
				if(!item.disabled)
					activeGroupsCount++;
				
				if(!item.disabled && !eventDefaultGroup)
					eventDefaultGroup = item;
				
				event.event_groups_dict.push(item);
			}
			});
			if(event.display_alt_location_form){
				event.event_groups_dict.push({
					event_id: event.__id,
					group_id: 'custom',
					label: event.alt_location_form_prompt 
				});
			}
			if(activeGroupsCount == 1){
				//self.eventDefaultGroups[event.__id] = event.event_groups_dict[0];
				self.eventDefaultGroups[event.__id] = eventDefaultGroup;
				EventService.setEventDefaultGroup(self.eventDefaultGroups);
			}
			return event;
		}
		
		this.onGroupChange = function(item){
			EventService.setEventDefaultGroup(self.eventDefaultGroups);
		};

        window.Classes = Classes;
        window.$ctrl = this;

    });

angular
.module('index')

	// Map view controller
	.controller('EventController', function($scope, $translate, Classes, ApiRootUrl, $state, $stateParams, FormService, MetaService, EventService, $q) {

		var self = this;
		self.eventLoading = true;
		self.event = null;
		self.eventLink = $stateParams.name;
		self.eventID = $stateParams.eventID;
		self.eventToken = $stateParams.eventToken;
		self.eventIsActive = false;
		self.eventTokenObj = null;
		self.errorMessage = null;
		self.eventMessage = null;
		self.pageMessage = null;
		$scope.title = 'test';
		self.registerMultiple = false;
		self.registerMultipleAutoRegister = false;
		
        this.ApiRootUrl = ApiRootUrl;
		
		this.getEvent = function(){
			
			self.pageMessage = null;
			self.event = null;
			
			Classes.Event.get_single({
				link: self.eventLink,
				id: self.eventID,
				token: self.eventToken
			})
			.then(function(event){
				self.eventLoading = false;
				self.event = event;
				if(event){
					//self.formValues['form_data'] = event.event_form.form;
					self.formValues['form_data'] = [];
					MetaService.setMetaKeywords(event.meta_keywords)
					MetaService.setMetaDescription(event.meta_description)
					MetaService.setTitle(event.title)
					MetaService.setContact(event.contact_info)
					MetaService.setVenues(_.uniq(_.map(_.filter(event.event_groups, group => self.isEventGroupAvaliable(group)), function(group){
						return group.venue
					}), '__id'));
					self.formSettingsData = event.event_form.form;
					self.addSurveyFields();
					self.addSurveyPersonFields();   // 1x
					self.addConsentFields();
					self.addGroupSelectionFields();
					self.assignEventToken();
					self.isEventActive();
					self.getEventOtherList(event.__id);

					self.turnOffRegistrationMultiple();
				}

				var eventDefaultGroup = EventService.get('event_default_group');
				if(eventDefaultGroup && eventDefaultGroup[event.__id] && eventDefaultGroup[event.__id].group_id){
					self.formValues['event_group'] = eventDefaultGroup[event.__id].group_id;
				}

				return event;
			}).catch(function(e){
				self.eventLoading = false;
				self.pageMessage = {type:'danger', body: e.data.message};
			});
		}
		self.getEvent();
		
		// get meta service values
		this.getContact = function() {
			return MetaService.get('contact');
		}
		this.getVenues = function() {
			return MetaService.get('venues') ? MetaService.get('venues').filter(item => item != null) : [];
		}
		this.getEventPreviousList = function() {
			return MetaService.get('eventPreviousList');
		}
		this.getEventCurrent = function() {
			return MetaService.get('eventCurrent');
		}
		
		this.getEventOtherList = function(current_id) {
			Classes.Event.get_event_other_list({
				link: $stateParams.name,
				current_id: current_id
			})
			.then(function(list){
				MetaService.setEventPreviousList(list.previous);
				MetaService.setEventCurrent(list.current);
				return list;
			}).catch(function(e){
				
			});
		}
		
		
		this.isEventActive = function(){
			
			if(!self.event)
				return false;
			
			var now = new Date();
			var start = new Date(self.event.visible_start);
			var end = new Date(self.event.visible_end);
			
			now = now.setHours(0,0,0,0);
			start = start.setHours(0,0,0,0);
			end = end.setHours(0,0,0,0);
			
			if(now >= start && now <= end ){
				self.eventIsActive = true;
			}else{
				self.eventMessage = {type:'danger', body: $translate.instant('Form is inactive')};
				self.eventIsActive = false;
			}

			if (!self.formFields[0].length && !self.event.display_alt_location_form && !self.event.hide_group_selection) {
				self.eventMessage = {type:'danger', body: $translate.instant('No event group available')};
				self.eventIsActive = false;
			}
			
			if(self.event.hide_event_form){
				self.eventIsActive = false;
				self.eventMessage = null;
			}
			
		}
		
		this.assignEventToken = function(){
			angular.forEach(self.event.event_tokens, function(tokenItem, key) {
				if(tokenItem.title == self.eventToken)
					self.eventTokenObj = tokenItem;
			});
		}
		
		// Build survey form
		self.formSettingsData = [] //JSON.parse(self.event.event_form.form);
		self.formRegisterData = [];	// form values injected into form schema
		self.formSinglePersonData = {}; // Object of persons data
		self.formRegisterConsents = [];
		self.formRegisterGroup = null;
		self.formRegisterGroupCustom = null;
		self.formFields = [
			[],	// Group Fields
			[],	// Survey Fields
			[],	// Consent Fields
			{}	// Persons Fields
		];
		self.formSurveyFields = [];
		self.formConsentFields = [];
		self.formMessage = null;
		self.formValues = {};	// From values
		self.formLayout = ['survey-form'];
		
		self.form = FormService.createForm({
			layout: self.formLayout,
			params: self.formFields,
			submit: function(data) {
				
				// Participation event_group
				if(!self.event.multi_group_registration){
					self.formRegisterGroups = {};
					if(data.event_group)
						self.formRegisterGroups[data.event_group] = true;
				}else{
					self.formRegisterGroups = data.event_groups;
				}
				self.formRegisterGroupCustom = data.event_group_custom;
				
				// Participation consents
				self.formRegisterConsents.length = 0;
				angular.forEach(self.event.event_consents, function(consent, key) {
					if(data['consent_'+consent.person_consent_option.id])
						self.formRegisterConsents.push(consent.person_consent_option.id);
				});
				
				// Single perons data
				self.formSinglePersonData= {};
				angular.forEach(self.formFields[3], function(personData, key) {
					self.formSinglePersonData[key] = data[key];
				});
				
				// Save survey
				if(self.event.event_form.is_multiple_allowed && self.registerMultiple){
					return Classes.EventParticipationProxy.registration({
						form_data: data.form_data,
						form_single_person_data: self.formSinglePersonData,
						event_id: self.event.__id,
						event_group: self.formRegisterGroup,
						event_groups: self.formRegisterGroups,
						event_group_custom: self.formRegisterGroupCustom,
						event_consents: self.formRegisterConsents,
						token: self.eventToken,
						registration_multiple: self.registerMultiple,
						registration_multiple_auto_register: self.registerMultipleAutoRegister
					}).then(function(resp){
						$state.go('.thankyou');
						//self.errorMessage = "Your registration has been saved";
						self.form.values = [];
						self.scrollToRegisterChapter();
					}).catch(function(e){
						self.errorMessage = e.data.message;
						self.scrollToRegisterChapter();
						return $q.reject(e)  // FormService ustawi field_errors itp.
					});					
				}else{
					return Classes.EventParticipation.registration({
						form_data: data.form_data,
						//form_data: self.formRegisterData, 
						event_id: self.event.__id,
						event_group: self.formRegisterGroup,
						event_groups: self.formRegisterGroups,
						event_group_custom: self.formRegisterGroupCustom,
						event_consents: self.formRegisterConsents,
						token: self.eventToken
					}).then(function(resp){
						$state.go('.thankyou');
						//self.errorMessage = "Your registration has been saved";
						self.form.values = [];
						self.scrollToRegisterChapter();
					}).catch(function(e){
						self.errorMessage = e.data.message;
						self.scrollToRegisterChapter();
						return $q.reject(e)  // FormService ustawi field_errors itp.
					});
				}
				
			},
		}, self.formValues);
		
		this.scrollToRegisterChapter = function(){
			angular.element(window).scrollTop($("#register-chapter").offset().top - 80);
		}
		
		this.addGroupSelectionFields = function(){
			
			self.formFields[0].length = 0;
			angular.forEach(self.event.event_groups, function(group, key) {
				
				var field = {
					//default:undefined,
					editable:"true",
					groups:['survey-form'],
					name: 'event_group',
					required: true,
					title: group.title,
					type: 'EventGroup',
					visible:"true",
					client: {
						'id': group.id,
						box_template_url: 'partials/index/field-box.html',
						group_date: group.event_full_date,
						// group_date: group.event_start_formatted,
						group_name: group.title
					}
				}
				if(self.isEventGroupAvaliable(group))
					self.formFields[0].push(field);
			});
		}
		
		this.addSurveyFields = function(){
			self.formFields[1].length = 0;
			self.formFields[1].push({
				editable:"true",
				groups:['survey-form'],
				name: 'form_data',
				required: false,
				title: '',
				type: 'FormResultsField',
				visible:"true",
				client: {
					formLabelClass: "text-left",
					formEditorClass: "",
					child_box_template_url: 'partials/index/field-box.html',
					box_template_url: 'partials/index/field-box.html',
				}
			});
		}
		
		this.addConsentFields = function(){
			self.formFields[2].length = 0;
			angular.forEach(self.event.event_consents, function(consent, key) {
				var field = {
					//client:undefined,
					//default:undefined,
					editable:"true",
					groups:['survey-form'],
					name: 'consent_'+consent.person_consent_option.id,
					required: consent.person_consent_option.required || false,
					title: consent.person_consent_option.title,
					type: 'ConsentOption',
					visible:"true",
					client: {
						'wording': consent.person_consent_option.wording,
						'link': consent.person_consent_option.link || false,
						'id': consent.person_consent_option.id,
						'required': consent.person_consent_option.is_required,
						box_template_url: 'partials/index/field-box.html',
					}
				}
				if(consent.person_consent_option.is_active)
					self.formFields[2].push(field);
			});
		}
		
		this.single_persons_keys = [];
		this.addSurveyPersonFields = function(){
			if(self.personsCountUnderLimit){
				var r = Math.random().toString(36).substring(7);
				self.formValues['form_single_person_data_' + r] = angular.copy(self.event.event_form.single_person_form);
				self.formFields[3]['form_single_person_data_' + r] = {
					editable:"true",
					groups:['survey-form'],
					name: 'form_single_person_data_' + r,
					required: false,
					title: '',
					type: 'FormResultsField',
					visible:"true",
					client: {
						formLabelClass: "text-left",
						formEditorClass: "",
						child_box_template_url: 'partials/index/field-box.html',
						box_template_url: 'partials/index/field-box.html',
					}
				};
				self.single_persons_keys.push('form_single_person_data_' + r);
			}
			self.checkGroupParticipantsCount();
		}
		
		this.removeSurveyPersonFields = function(index){
			delete self.formValues[index];
			delete self.formFields[3][index];
			//self.single_persons_keys.splice(index, 1);
			self.single_persons_keys.splice(self.single_persons_keys.indexOf(index), 1);
			self.checkGroupParticipantsCount();
		}
		
		this.personsCountUnderLimit = true;
		this.peronsOverflowMessage = null;
		this.personsGroupLimitCount = 0;
		//this.personsTokenLimitCount = 0;
		//this.personsTotalLimitCount = 0;
		this.checkGroupParticipantsCount = function(){
			self.personsCountUnderLimit = true;

			if(self.selectedGroup && self.selectedGroup.max_participants && self.selectedGroup.max_participants - self.selectedGroup.count_participants <= self.single_persons_keys.length){
				self.personsCountUnderLimit = false;
				self.peronsOverflowMessage = 'Osiągnięto limit wolnych miejsc dla wybranego terminu';
			}

			if(self.eventTokenObj && self.eventTokenObj.max_participants && self.eventTokenObj.max_participants - self.eventTokenObj.count_participants <= self.single_persons_keys.length){
				self.personsCountUnderLimit = false;
				self.peronsOverflowMessage = 'Osiągnięto limit wolnych miejsc dla zaproszenia';
			}
			
			if(self.selectedGroup && self.selectedGroup.max_participants)
				self.personsGroupLimitCount = self.selectedGroup.max_participants - self.selectedGroup.count_participants;
			else
				self.personsGroupLimitCount = 0;
			
			/*
			if(self.eventTokenObj)
				self.personsTokenLimitCount = self.eventTokenObj.max_participants - self.eventTokenObj.count_participants;
			else
				self.personsTokenLimitCount = 0;
			*/
			/*
			if(self.personsTokenLimitCount && self.personsGroupLimitCount)
				self.personsTotalLimitCount = Math.min(self.personsTokenLimitCount, self.personsGroupLimitCount);
			else if(self.personsTokenLimitCount)
				self.personsTotalLimitCount = self.personsTokenLimitCount
			else if(self.personsGroupLimitCount)
				self.personsTotalLimitCount = self.personsGroupLimitCount
			else
				self.personsTotalLimitCount = 0;
			*/
			//console.log(self.personsTokenLimitCount);
		}

		this.selectedGroup = null;		
		$scope.$watch(function(){return self.form.values.event_group;}, function(newValue, oldValue) {
			self.selectedGroup = null;
			if(self.event && self.event.event_groups){
				angular.forEach(self.event.event_groups, function(group, key) {
					if(group.id == newValue){
						self.selectedGroup = group;
					}
				});
			}
			self.checkGroupParticipantsCount();
			/*
			angular.forEach(self.formFields[3], function(personData, key) {				
				self.removeSurveyPersonFields(key);
			});	
			self.addSurveyPersonFields();
			*/
		});

		this.isEventGroupAvaliable = function(group){
			
			var now = new Date();
			var start = new Date(group.registration_start);
			var end = new Date(group.registration_end);
			
			now = now.getTime();
			start = start.getTime();
			end = end.getTime();

			if(now < start || now > end )
				return false;
			
			if (group.is_blocked || group.is_hidden)
				return false;
			
			return true;
		}
		
		this.turnOnRegistrationMultiple = function(auto_register){
			auto_register=auto_register||false;
			//self.personsTotalLimitCount = 0;
			self.registerMultiple = true;
			self.registerMultipleAutoRegister = auto_register;
			if(!self.single_persons_keys.length)
				self.addSurveyPersonFields();
			self.formValues['form_data'] = self.event.event_form.form;
		}
		
		this.turnOffRegistrationMultiple = function(){
			self.registerMultiple = false;
			self.registerMultipleAutoRegister = false;
			angular.forEach(self.formFields[3], function(personData, key) {				
				self.removeSurveyPersonFields(key);
			});
			//var form_fields = angular.copy(self.event.event_form.form);
			//self.formValues['form_data'] = form_fields;
			self.formValues['form_data'] = self.event.event_form.form;
		}

		this.goMainPage = function(){
			$state.go('index', {});
		}		
		

		
        window.Classes = Classes;
        window.$ctrl = this;

    })
	;


angular
.module('index')

	// Map view controller
	.controller('EventConfirmController', function($scope, $translate, Classes, ApiRootUrl, $state, $stateParams, FormService, MetaService) {

				
        this.ApiRootUrl = ApiRootUrl;
		var self = this;
		self.hash = $stateParams.hash;
		self.eventConfirmInProcess = false;
		self.eventConfirmInfo = null;
		self.errorMessage = null;
		
		MetaService.setTitle()
		MetaService.setMetaKeywords()
		MetaService.setMetaDescription()
		
		this.confirmEventParticipation = function(){
			Classes.EventParticipation.registration_confirm({
				hash: self.hash
			})
			.then(function(resp){
				self.eventConfirmInProcess = false;
				self.eventConfirmInfo = resp.info;
			}).catch(function(e){
				self.eventConfirmInProcess = false;
				self.errorMessage = {type:'danger', body: e.data.message};
			});
		}
		self.confirmEventParticipation();
		
		this.goMainPage = function(){
			$state.go('index', {});
		}
		
        window.Classes = Classes;
        window.$ctrl = this;

    })
	;


angular
.module('index')

	// Map view controller
	.controller('EventBulkConfirmController', function(Classes, ApiRootUrl, $state, $stateParams, MetaService) {

				
        this.ApiRootUrl = ApiRootUrl;
		var self = this;
		self.hash = $stateParams.hash;
		self.registrationConfirmInProcess = false;
		self.registrationConfirmInfo = [];
		self.errorMessage = null;
		self.response = null;
		
		MetaService.setTitle()
		MetaService.setMetaKeywords()
		MetaService.setMetaDescription()
		
		this.confirmRegistration = function(){
			self.registrationConfirmInProcess = true;
			Classes.EventRegistration.registration_confirm({
				hash: self.hash
			})
			.then(function(resp){
				self.registrationConfirmInProcess = false;
				self.registrationConfirmInfo = resp.info;
				self.response = resp;
			}).catch(function(e){
				self.registrationConfirmInProcess = false;
				self.errorMessage = {type:'danger', body: e.data.message};
			});
		}
		self.confirmRegistration();
		
		this.goMainPage = function(){
			$state.go('index', {});
		}
		
        window.Classes = Classes;
        window.$ctrl = this;

    })
	;


angular
.module('index')

	// Map view controller
	.controller('EventProxyConfirmController', function($scope, $translate, Classes, ApiRootUrl, $state, $stateParams, FormService, MetaService) {

				
        this.ApiRootUrl = ApiRootUrl;
		var self = this;
		self.hash = $stateParams.hash;
		self.eventConfirmInProcess = false;
		self.eventConfirmInfo = null;
		self.errorMessage = null;
		
		MetaService.setTitle()
		MetaService.setMetaKeywords()
		MetaService.setMetaDescription()
		
		this.confirmEventProxyParticipation = function(){
			Classes.EventParticipationProxy.registration_proxy_confirm({
				hash: self.hash
			})
			.then(function(resp){
				self.eventConfirmInProcess = false;
				self.eventConfirmInfo = resp.info;
			}).catch(function(e){
				self.eventConfirmInProcess = false;
				self.errorMessage = {type:'danger', body: e.data.message};
			});
		}
		self.confirmEventProxyParticipation();
		
		this.goMainPage = function(){
			$state.go('index', {});
		}
		
        window.Classes = Classes;
        window.$ctrl = this;

    })
	;


angular
.module('index')

	// Map view controller
	.controller('EventCancelController', function($scope, $translate, Classes, ApiRootUrl, $state, $stateParams, FormService, MetaService) {

				
        this.ApiRootUrl = ApiRootUrl;
		var self = this;
		self.hash = $stateParams.hash;
		self.is_busy = false;
		self.errorMessage = null;
		
		MetaService.setTitle()
		MetaService.setMetaKeywords()
		MetaService.setMetaDescription()
		
		this.cancelEventParticipation = function(){
			Classes.EventParticipation.registration_cancel({
				hash: self.hash
			})
			.then(function(resp){
				self.is_busy = false;
				$state.go('regstration-info', {hash: self.hash});
			}).catch(function(e){
				self.is_busy = false;
				self.errorMessage = {type:'danger', body: e.data.message};
			});
		}
		//self.cancelEventParticipation();
		
		this.goBack = function(){
			$state.go('regstration-info', {hash: self.hash});
		}
		
        window.Classes = Classes;
        window.$ctrl = this;

    })
	;


angular
.module('index')

	// Map view controller
	.controller('EventRegistrationController', function($scope, $translate, Classes, ApiRootUrl, $state, $stateParams, FormService, MetaService, dialogs) {

				
        this.ApiRootUrl = ApiRootUrl;
		var self = this;
		self.hash = $stateParams.hash;
		self.is_busy = false;
		self.participation = null;
		self.errorMessage = null;
		
		MetaService.setTitle()
		MetaService.setMetaKeywords()
		MetaService.setMetaDescription()
		
		this.readEventParticipation = function(){
			Classes.EventParticipation.status_info({
				hash: self.hash
			})
			.then(function(resp){
				self.is_busy = false;
				self.participation = resp.participation;
				self.event_group = resp.event_group;
				self.event = resp.event;
			}).catch(function(e){
				self.is_busy = false;
				self.errorMessage = {type:'danger', body: e.data.message};
			});
		}
		self.readEventParticipation();
		
		this.goRegistrationCancel = function(){
			$state.go('regstration-cancel', {hash: self.hash});
		}		
		this.goRegistrationChangeGroup = function(){
			$state.go('regstration-change-group', {hash: self.hash});
		}		
		this.goMainPage = function(){
			$state.go('index', {});
		}
		
        window.Classes = Classes;
        window.$ctrl = this;

    })
	;


angular
.module('index')

	// Map view controller
	.controller('EventProxyRegistrationController', function($scope, $translate, Classes, ApiRootUrl, $state, $stateParams, FormService, MetaService, dialogs) {

				
        this.ApiRootUrl = ApiRootUrl;
		var self = this;
		self.hash = $stateParams.hash;
		self.is_busy = false;
		self.participation = null;
		self.errorMessage = null;
		
		MetaService.setTitle()
		MetaService.setMetaKeywords()
		MetaService.setMetaDescription()
		
		this.readEventParticipation = function(){
			Classes.EventParticipationProxy.status_proxy_info({
				hash: self.hash
			})
			.then(function(resp){
				self.is_busy = false;
				self.participation = resp.participation;
				self.participation_items = resp.participation_items;
				self.event_group = resp.event_group;
				self.event = resp.event;
				
				console.log(resp);
			}).catch(function(e){
				self.is_busy = false;
				self.errorMessage = {type:'danger', body: e.data.message};
			});
		}
		self.readEventParticipation();
		
		this.goRegistrationCancel = function(){
			$state.go('regstration-cancel', {hash: self.hash});
		}		
		this.goRegistrationChangeGroup = function(){
			$state.go('regstration-change-group', {hash: self.hash});
		}		
		this.goMainPage = function(){
			$state.go('index', {});
		}
		
        window.Classes = Classes;
        window.$ctrl = this;

    })
	;


angular
.module('index')

	// Map view controller
	.controller('SurveyController', function($scope, $translate, Classes, ApiRootUrl, $state, $stateParams, FormService, MetaService, $q) {

		var self = this;
		self.pageLoading = true;
		self.survey = null;
		self.surveyErrorMessage = null;
		self.surveySaved = false;
		self.surveyIsActive = false;
		
		MetaService.setTitle()
		MetaService.setMetaKeywords()
		MetaService.setMetaDescription()
		
		this.ApiRootUrl = ApiRootUrl;
		
		self.formFields = [
			{
				editable:"true",
				groups:['survey-form'],
				name: 'form_data',
				required: false,
				title: '',
				type: 'FormResultsField',
				visible:"true",
				client: {
					formLabelClass: "text-left",
					formEditorClass: "",
					child_box_template_url: 'partials/index/field-box.html',
					box_template_url: 'partials/index/field-box.html',
				}
			}
		];
		self.formLayout = ['survey-form'];
		self.formValues = {}
	
		this.getSurvey = function(){
			Classes.SurveyForm.get_single({
				link: $stateParams.name
			})
			.then(function(item){
				self.pageLoading = false;
				self.survey = item;
				if(item){
					MetaService.setTitle(item.title)
					//MetaService.setContact(event.contact_info)
					//MetaService.setVenues(_.uniq(_.map(event.event_groups, function(group){
					//	return group.venue
					//}), '__id'));
					self.formValues['form_data'] = item.form;
					self.isSurveyActive();
				}
				
				console.log(item);
				
				return event;
			}).catch(function(e){
				self.pageLoading = false;
				self.surveyErrorMessage = {type:'danger', body: e.data.message};
			});
		}
		self.getSurvey();
		
		this.isSurveyActive = function(){
			
			if(!self.survey)
				return;
			
			var now = new Date();
			var start = new Date(self.survey.visible_start);
			var end = new Date(self.survey.visible_end);
			
			if(now >= start && now <= end )
				self.surveyIsActive = true;
			else
				self.surveyErrorMessage = {type:'danger', body: 'Survey is inactive'};
		}
		
		self.form = FormService.createForm({
			layout: self.formLayout,
			params: self.formFields,
			submit: function(data) {
				
				// Save survey
				return Classes.SurveyFormItem.submit_survey({
					form_data: data.form_data, 
					survey_id: self.survey.__id
				}).then(function(resp){
					//$state.go('.thankyou');
					self.surveyErrorMessage = null;
					self.form.values = [];
					self.surveySaved = true;
					self.scrollToFormChapter();
				}).catch(function(e){
					self.surveyErrorMessage = {type:'danger', body: e.data.message};
					self.scrollToFormChapter();
					return $q.reject(e);  // FormService zajmie się odczytaniem błędów pól jeśli dostanie error
				});
				
			},
		}, self.formValues);
		
		this.scrollToFormChapter = function(){
			angular.element(window).scrollTop($("#form-chapter").offset().top - 80);
		}
		
        window.Classes = Classes;
        window.$ctrl = this;

    });


angular
.module('index')

	// Map view controller
	.controller('EventSurveyController', function($scope, $translate, Classes, ApiRootUrl, $state, $stateParams, FormService, MetaService, $q, SurveyInfo, ParticipantShortCode) {

		var self = this;		
		self.survey = null;
		self.surveyErrorMessage = null;
		self.surveySaved = false;
		self.surveyIsActive = false;		
		self.formFields = [
			{
				editable:"true",
				groups:['survey-form'],
				name: 'form_data',
				required: false,
				title: '',
				type: 'FormResultsField',
				visible:"true",
				client: {
					formLabelClass: "text-left",
					formEditorClass: "",
					child_box_template_url: 'partials/index/field-box.html',
					box_template_url: 'partials/index/field-box.html',
				}
			}
		];
		self.formLayout = ['survey-form'];
		self.formValues = {}
		
		MetaService.setTitle()
		MetaService.setMetaKeywords()
		MetaService.setMetaDescription()
		
		this.ApiRootUrl = ApiRootUrl;
		
		this.isSurveyActive = function(){
			
			if(!self.survey)
				return;
			
			var now = new Date();
			var start = new Date(self.survey.visible_start);
			var end = new Date(self.survey.visible_end);
			
			if(now >= start && now <= end )
				self.surveyIsActive = true;
			else
				self.surveyErrorMessage = {type:'danger', body: 'Survey is inactive'};
		}
		
		if(SurveyInfo.error){
			self.surveyErrorMessage = {type:'danger', body: SurveyInfo.error.data.message};
		}else if(SurveyInfo.survey_form){
			self.survey = SurveyInfo.survey_form;
			self.formValues['form_data'] = SurveyInfo.survey_form.form;
			MetaService.setTitle(SurveyInfo.survey_form.title);
			self.isSurveyActive();
		}
		
		self.form = FormService.createForm({
			layout: self.formLayout,
			params: self.formFields,
			submit: function(data) {
				
				// Save survey
				return Classes.SurveyFormItem.submit_event_survey({
					form_data: data.form_data, 
					participant_code: ParticipantShortCode
				}).then(function(resp){
					self.surveyErrorMessage = null;
					self.form.values = [];
					self.surveySaved = true;
					self.scrollToFormChapter();
				}).catch(function(e){
					self.surveyErrorMessage = {type:'danger', body: e.data.message};
					self.scrollToFormChapter();
					return $q.reject(e);
				});
				
			},
		}, self.formValues);
		
		this.scrollToFormChapter = function(){
			angular.element(window).scrollTop($("#form-chapter").offset().top - 80);
		}
		
        window.Classes = Classes;
        window.$ctrl = this;

    });


angular
.module('index')

	// Map view controller
	.controller('EventChangeGroupController', function($scope, $translate, Classes, ApiRootUrl, $state, $stateParams, FormService, MetaService, $q) {

        this.ApiRootUrl = ApiRootUrl;
		var self = this;
		self.hash = $stateParams.hash;
		self.is_busy = false;
		self.participation = null;
		self.errorMessage = null;
		
		MetaService.setTitle()
		MetaService.setMetaKeywords()
		MetaService.setMetaDescription()
		
		this.readEventParticipation = function(){
			Classes.EventParticipation.event_groups_info({
				hash: self.hash
			})
			.then(function(resp){
				self.is_busy = false;
				self.participation = resp.participation;
				self.event_group = resp.event_group;
				self.event = resp.event;
				
				if(self.event_group)
					self.formValues.event_group = self.event_group.id;
				
				self.addGroupSelectionFields();				
			}).catch(function(e){
				self.is_busy = false;
				self.errorMessage = {type:'danger', body: e.data.message};
			});
		}
		self.readEventParticipation();
		
		// Build survey form
		self.formRegisterGroup = null;
		self.formRegisterGroupCustom = null;
		self.formFields = [];
		self.formMessage = null;
		self.formValues = {};	// From values
		self.formLayout = ['survey-form'];
		
		self.form = FormService.createForm({
			layout: self.formLayout,
			params: self.formFields,
			submit: function(data) {
				
				// Participation event_group
				self.formRegisterGroup = data.event_group;
				self.formRegisterGroupCustom = data.event_group_custom;
				
				// Save survey
				return Classes.EventParticipation.registration_change_group({
					event_group: self.formRegisterGroup,
					event_group_custom: self.formRegisterGroupCustom,
					hash: self.hash
				}).then(function(resp){
					$state.go('regstration-info', {hash: self.hash});
				}).catch(function(e){
					self.errorMessage = {type:'danger', body: e.data.message};
					return $q.reject(e)  // FormService ustawi field_errors itp.
				});
				
			},
		}, self.formValues);
		
		this.addGroupSelectionFields = function(){
			self.formFields.length = 0;
			angular.forEach(self.event.event_groups, function(group, key) {
				
				var field = {
					//default:undefined,
					editable:"true",
					groups:['survey-form'],
					name: 'event_group',
					required: true,
					title: group.title,
					type: 'EventGroup',
					visible:"true",
					client: {
						'id': group.id,
						box_template_url: 'partials/index/field-box.html',
						group_date: group.event_full_date,
						group_name: group.title
					}
				}
				if(self.isEventGroupAvaliable(group))
					self.formFields.push(field);
			});
		}
		
		this.isEventGroupAvaliable = function(group){
			
			var now = new Date();
			var start = new Date(group.registration_start);
			var end = new Date(group.registration_end);
			
			if(now < start || now > end )
				return false;
			
			if (group.is_blocked || group.is_hidden)
				return false;
			
			return true;
		}
		
		this.goBack = function(){
			$state.go('regstration-info', {hash: self.hash});
		}
		
        window.Classes = Classes;
        window.$ctrl = this;

    })
	;
